webpackJsonp([4],{

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1303),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1248),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1241),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(880)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1191),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1232),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1296),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(898)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1209),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1206),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-249fac07",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1184),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(964)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1275),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1227),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(862)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1173),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1263),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1240),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(903)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1214),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(899)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1210),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1223),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1234),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1216),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1242),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(872)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(962)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1273),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1194),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1283),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1237),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1185),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(882)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1193),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1226),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(950)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1261),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(956)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1267),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1259),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(910)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1221),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(965)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1276),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1173:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new_guest_book"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'guest_book'
      }
    }
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.back))])]), _vm._v(" "), _c('div', {
    staticClass: "gue_box"
  }, [_c('div', {
    staticClass: "gue_box_user"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.showPage.guestName))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestName),
      expression: "book.guestName"
    }],
    staticClass: "sign_inp",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.book.guestName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestEmail),
      expression: "book.guestEmail"
    }],
    staticClass: "sign_inp",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.book.guestEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestEmail", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gue_box_ans mb10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestMessage),
      expression: "book.guestMessage"
    }],
    staticClass: "sign_txt",
    attrs: {
      "name": "",
      "cols": "",
      "rows": "",
      "placeholder": "留言內容"
    },
    domProps: {
      "value": (_vm.book.guestMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestMessage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.showPage.verificationCode))]), _vm._v(" "), _c('td', {
    staticClass: "vile"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": "6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.showPage.leaveMessage))])])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1179:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all_in",
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "header_all"
  }, [_c('div', {
    staticClass: "header_left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/logo.jpg"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header_right"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLocale('CH')
      }
    }
  }, [_vm._v("中文版")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLocale('EN')
      }
    }
  }, [_vm._v("ENGLISH")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt15"
  }, [_c('gcse:search')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav_all"
  }, [_c('div', {
    staticClass: "disp_cell"
  }, [_c('ul', {
    staticClass: "drop-down-menu"
  }, _vm._l((_vm.menu), function(itemone, index) {
    return _c('li', {
      key: index
    }, [(!itemone.children[0] && _vm.checkTitle(itemone)) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.linkUrl(itemone)
        }
      }
    }, [_vm._v(_vm._s(_vm.showTitle(itemone)))]) : _vm._e(), _vm._v(" "), (itemone.children[0]) ? _c('a', [_vm._v(_vm._s(_vm.showTitle(itemone)))]) : _vm._e(), _vm._v(" "), (itemone.children[0]) ? _c('ul', {
      staticStyle: {
        "width": "139px"
      }
    }, _vm._l((itemone.children), function(itemtwo, index) {
      return _c('li', {
        key: index
      }, [_c('a', {
        staticStyle: {
          "padding": "0"
        },
        on: {
          "click": function($event) {
            _vm.linkUrl(itemtwo)
          }
        }
      }, [_vm._v(_vm._s(_vm.showTitle(itemtwo)))])])
    })) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "disp_con"
  }, [_c('div', {
    staticClass: "cell_nav_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cell_nav"
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.menu), function(itemone) {
    return _c('li', [(itemone.children[0]) ? _c('div', {
      staticClass: "title",
      attrs: {
        "var": itemone.id
      },
      on: {
        "click": _vm.subMenu
      }
    }, [_vm._v("\n                " + _vm._s(_vm.showTitle(itemone)) + "\n              ")]) : _c('div', {
      staticClass: "title clicknav",
      on: {
        "click": _vm.subMenu
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.linkUrl(itemone)
        }
      }
    }, [_vm._v(_vm._s(_vm.showTitle(itemone)))])]), _vm._v(" "), (itemone.children[0]) ? _c('div', {
      staticClass: "sub clicknav",
      attrs: {
        "var": itemone.id
      }
    }, [_c('ul', _vm._l((itemone.children), function(itemtwo) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.linkUrl(itemtwo)
          }
        }
      }, [_vm._v(_vm._s(_vm.showTitle(itemtwo)))])])
    }))]) : _vm._e()])
  }))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [(_vm.$route.meta.keepAlive) ? _c('div', {
    staticClass: "con_one"
  }, [_c('div', {
    staticClass: "con_one_left"
  }, [(_vm.noticepictures.length > '1') ? _c('div', {
    staticClass: "carousel slide",
    staticStyle: {
      "overflow": "hidden",
      "height": "340px",
      "position": "relative"
    },
    attrs: {
      "id": "carousel-example-generic",
      "data-ride": "carousel"
    }
  }, [_c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._l((_vm.noticepictures), function(notice, index) {
    return (index == '0') ? _c('div', {
      key: notice.id,
      staticClass: "item active"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": notice.pictures
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption flex-caption",
      staticStyle: {
        "padding": "10px 20px",
        "text-align": "left",
        "left": "0"
      }
    }, [_vm._v("\n                   " + _vm._s(notice.title) + "\n                ")])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.noticepictures), function(notice, index) {
    return (index > '0' && index < '10') ? _c('div', {
      key: notice.id,
      staticClass: "item"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": notice.pictures
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption flex-caption",
      staticStyle: {
        "padding": "10px 20px",
        "text-align": "left",
        "left": "0"
      }
    }, [_vm._v("\n                   " + _vm._s(notice.title) + "\n                ")])])]) : _vm._e()
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : (_vm.noticepictures[0]) ? _c('div', {
    staticStyle: {
      "height": "340px",
      "position": "relative",
      "overflow": "hidden"
    }
  }, [_c('a', {
    attrs: {
      "target": _vm.target(_vm.noticepictures[0]),
      "href": _vm.href(_vm.noticepictures[0])
    },
    on: {
      "click": function($event) {
        _vm.pushToNewsSub(_vm.noticepictures[0])
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.noticepictures[0].pictures
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption flex-caption",
    staticStyle: {
      "height": "40px",
      "bottom": "0",
      "padding": "10px 20px",
      "text-align": "left",
      "left": "0"
    }
  }, [_vm._v("\n                   " + _vm._s(_vm.noticepictures[0].title) + "\n                ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "con_one_right"
  }, [_c('div', {
    staticClass: "abgne_tab"
  }, [_c('div', {
    staticClass: "outertab"
  }, [_c('ul', {
    staticClass: "tabs",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.types), function(type, index) {
    return (type.homeDisplay === 1) ? _c('li', {
      key: index,
      class: {
        active: index === 0
      },
      on: {
        "click": function($event) {
          _vm.selectType(type)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(_vm.showType(type)))])]) : _vm._e()
  }))]), _vm._v(" "), _c('HomeNotice', {
    attrs: {
      "type": _vm.type,
      "notices": _vm.notices
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "con_one_left con_tim"
  }, [_c('router-link', {
    staticClass: "hoverimg",
    attrs: {
      "to": {
        name: 'site'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/8.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgwrap"
  }, [_vm._v("場地介紹")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "con_one_right"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "315",
      "src": _vm.video.fileUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'video'
      }
    }
  }, [_c('button', {
    staticClass: "more_btn fright",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("more")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAlive && _vm.course && false) ? _c('div', {
    staticClass: "con_title con_line"
  }, [_c('router-link', {
    staticStyle: {
      "color": "#00907f"
    },
    attrs: {
      "to": {
        name: 'class'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.course.schoolYear) + _vm._s(_vm.academicYear) + _vm._s(_vm.showCourseName()) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con_two"
  }, [(_vm.$route.meta.keepAlive && false) ? _c('div', {
    staticClass: "flexslider"
  }, [_c('ul', {
    staticClass: "slides"
  }, _vm._l((_vm.classes), function(classitem, index) {
    return ((index % 4) == 0) ? _c('li', {
      key: index,
      attrs: {
        "data-thumb": "/../static/images/8.jpg"
      }
    }, [_c('div', {
      staticClass: "bzbox"
    }, [_c('table', [_c('tr', [_c('td', [(_vm.classes[index]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 1]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 1].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 1].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 2]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 2].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 2].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 3]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 3].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 3].id)
        }
      }
    }) : _vm._e()])])])])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_all mt40"
  }, [_c('div', {
    staticClass: "footer_box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "footer_right"
  }, [(_vm.locale == 'CH') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.homeInfoCh)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locale == 'EN') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.homeInfoEn)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_link"
  }, _vm._l((_vm.links), function(link, index) {
    return (link.isActive == 1 && link.trash != 1) ? _c('a', {
      key: index,
      attrs: {
        "target": "_blank",
        "href": _vm.resolveLinkUrl(link.linkUrl)
      }
    }, [_c('img', {
      attrs: {
        "src": link.pictureUrl
      }
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_copy"
  }, [_vm._v("\n      臺灣大學體育室版權所有 Copyright " + _vm._s(_vm.nowYear) + " Department of Athletics, NTU All Rights Reserved\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell_nav_close"
  }, [_c('button', {
    staticClass: "cell_nav_close_btn",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/close.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disp_con"
  }, [_c('a', {
    staticClass: "toggleMenu"
  }, [_c('button', {
    staticClass: "cell_nav_open_btn",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_left"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.422627912698!2d121.53430791500597!3d25.01972768397899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9882cdc64e7%3A0xcfaa4ee05f721105!2z5ZyL56uL6Ie654Gj5aSn5a246auU6IKy5a6k!5e0!3m2!1szh-TW!2stw!4v1515722591657",
      "width": "100%",
      "height": "350",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}

/***/ }),

/***/ 1183:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_basic"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li"
  }, [_c('div', {
    staticClass: "tea_li_l2"
  }, [_c('div', {
    staticClass: "tea_lititle"
  }, [_vm._v(_vm._s(_vm.teacher.nameEn) + " " + _vm._s(_vm.teacher.nameCh))]), _vm._v(" "), _vm._l((_vm.teacher.background), function(background, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_c('span', {
      staticClass: "tea_tg"
    }, [_vm._v(_vm._s(_vm.showDegree(background)))]), _vm._v(" " + _vm._s(_vm.showSchool(background)) + ", " + _vm._s(background.graduation_year) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_tx mt15"
  }, [_vm._v(_vm._s(_vm.showPage.officeLocation) + " : " + _vm._s(_vm.teacher.office))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.tel) + " : " + _vm._s(_vm.teacher.tel))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v("Email : " + _vm._s(_vm.teacher.email))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.consultationTime) + " : " + _vm._s(_vm.teacher.advisory))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.personalWebpage) + " : " + _vm._s(_vm.teacher.website))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "15px",
      "border-bottom": "#ddd 1px solid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_tx mt15"
  }, [_vm._v(_vm._s(_vm.showTitle(_vm.teacher.title)))]), _vm._v(" "), _vm._l((_vm.teacher.subTitle), function(subTitle, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(subTitle))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tea_li_r2"
  }, [(_vm.teacher.profileImage) ? _c('img', {
    attrs: {
      "src": _vm.teacher.profileImage
    }
  }) : _c('img', {
    attrs: {
      "src": "/../static/images/timeline-default-photo.gif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.researchArea))]), _vm._v(" "), _vm._l((_vm.teacher.researchArea), function(researchArea, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showResearchArea(researchArea)))])
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.researchSummary))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx",
    domProps: {
      "innerHTML": _vm._s(_vm.showResearchSummary())
    }
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1184:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "journal"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.showPage.type))])]), _vm._v(" "), _vm._l((_vm.types), function(typeobj, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          _vm.pushToJournal(typeobj)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(_vm.showName(typeobj)))])])
  })], 2)])]) : _c('router-view', {
    attrs: {
      "type": _vm.nowType
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1185:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_journal"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 2) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n          " + _vm._s(teacherpublication.context) + "\n        ")]) : _c('span', [_c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.author))
      }
    }), _vm._v(", " + _vm._s(_vm.publication(teacherpublication)) + ",\n          "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.title))
      }
    }), _vm._v(", " + _vm._s(_vm.showName(teacherpublication)) + ", " + _vm._s(_vm.showIssueNumber(teacherpublication)) + ", " + _vm._s(teacherpublication.pageS) + " ~ " + _vm._s(teacherpublication.pageE) + ", "), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.memo) + ")")]) : _vm._e()])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "class_item"
    }
  }, [(!_vm.$route.meta.keepAliveSub2) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "ca_title"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showName()))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'coach_info',
        params: {
          classname: _vm.showName()
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.coach_info))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'facility',
        params: {
          classname: _vm.showName()
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_inside',
        params: {
          classname: _vm.showName()
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.apply_class))]), _vm._v(" "), _vm._l((_vm.admissions), function(admission, index) {
    return _c('div', {
      key: index,
      staticClass: "cla_box mt20"
    }, [_c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(_vm.classTypeName(admission)))]), _vm._v(" "), _c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(admission.memberType))]), _vm._v(" "), (admission.type === 2) ? _c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(_vm.memberRange(admission)) + _vm._s(_vm.showPage.people))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(admission.classHour))]), _vm._v(" "), _c('div', {
      staticClass: "cla_r"
    }, [_c('button', {
      staticClass: "ca2_btn",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.signUp(admission.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.signup))])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox mt30",
    domProps: {
      "innerHTML": _vm._s(_vm.showNote())
    }
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub2) ? _c('router-view', {
    attrs: {
      "classitem": _vm.classitem
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_prize"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.award))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.showHonor())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.experience))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.showHistory())
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_custom"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showName(_vm.customs[_vm.custom])))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx",
    domProps: {
      "innerHTML": _vm._s(_vm.showContext(_vm.customs[_vm.custom]))
    }
  }, [_vm._v("內容")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1202:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_container"
  }, [_c('div', {
    staticClass: "tab_content",
    staticStyle: {
      "height": "306px"
    },
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "tab_incon"
  }, [_vm._l((_vm.topNotice), function(notice, index) {
    return (index < 4) ? _c('div', {
      key: notice.id
    }, [_c('div', {
      staticClass: "fix"
    }), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "border-bottom": "#ccc 1px dotted",
        "padding": "5px 0",
        "margin-right": "6px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v(_vm._s(notice.createdAt.split(' ')[0]))]), _vm._v(" "), _c('div', {
      staticClass: "right",
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "overflow": "hidden"
      }
    }, [_c('span', {
      staticClass: "nhott"
    }, [_vm._v("HOT")]), _vm._v(_vm._s(notice.title))]), _c('img', {
      attrs: {
        "src": "/../static/images/stickyPin.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.normalNotices), function(notice, index) {
    return _c('div', {
      key: notice.id
    }, [_c('div', {
      staticClass: "fix"
    }), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "border-bottom": "#ccc 1px dotted",
        "padding": "5px 0",
        "margin-right": "6px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v(_vm._s(notice.createdAt.split(' ')[0]))]), _vm._v(" "), _c('div', {
      staticClass: "right",
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(notice.title))]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "fright mt10"
  }, [_c('button', {
    staticClass: "more_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.pushToNews
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "guest_book"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'new_guest_book'
      }
    }
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.leaveMessage))])]), _vm._v(" "), _vm._l((_vm.books), function(book, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "gue_box"
    }, [_c('div', {
      staticClass: "gue_box_user"
    }, [_c('div', {
      staticClass: "gue_box_user_title"
    }, [_vm._v(_vm._s(book.guestName)), _c('i', {
      staticClass: "fa fa-envelope-o ml5",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_user_date"
    }, [_vm._v(_vm._s(book.createdAt))]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_user_tx",
      domProps: {
        "innerHTML": _vm._s(_vm.changeBreak(book.guestMessage))
      }
    }), _vm._v(" "), (book.replyDisplay) ? _c('div', {
      staticClass: "gue_box_ans"
    }, [_c('div', {
      staticClass: "gue_box_ans_title"
    }, [_c('i', {
      staticClass: "fa fa-comments-o mr5",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(_vm.showPage.reply))]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_ans_date"
    }, [_vm._v(_vm._s(book.updatedAt))]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_ans_tx",
      domProps: {
        "innerHTML": _vm._s(_vm.changeBreak(book.reply))
      }
    })]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.books.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1210:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "photo_in"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs'), _c('a', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("> "), _c('span', {
    staticStyle: {
      "padding-left": "4px"
    }
  }, [_vm._v(_vm._s(_vm.photobread))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_vm._l((_vm.photos), function(photo, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n          " + _vm._s(photo.memo) + "\n          "), _vm._m(0, true)]), _vm._v(" "), _c('a', {
      attrs: {
        "href": photo.fileUrl,
        "data-lightbox": "pages"
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": photo.fileUrl
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.photos.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt10"
  }, [_c('button', {
    staticClass: "photo_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("more")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo_box_icon2"
  }, [_c('button', {
    staticClass: "view_ph",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),

/***/ 1214:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "photo"
    }
  }, [(!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "psear_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.albumSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.showPage.search))])]), _vm._v(" "), _vm._l((_vm.albums), function(album, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'photo_in',
          params: {
            albumId: album.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n            " + _vm._s(_vm.showMemo(album)) + "\n            "), _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "photo_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("more")])])]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": album.coverPictureUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_title"
    }, [_vm._v(_vm._s(_vm.showName(album)))]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_tx"
    }, [_vm._v(_vm._s(_vm.showPage.totalCount) + _vm._s(album.pictureCount) + _vm._s(_vm.showPage.item))])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.albums.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "outerphoto": _vm.albums
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1216:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('Button', {
    staticStyle: {
      "margin": "10px 10px 10px 25px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.back($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.back))]), _vm._v(" "), _vm._l((_vm.sites[_vm.siteindex].pictures), function(picture, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticStyle: {
        "margin": "25px",
        "max-width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "src": picture
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticStyle: {
      "border-left": "3px solid #bbb",
      "padding-left": "10px",
      "font-size": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.showName(_vm.sites[_vm.siteindex])))]), _vm._v(" "), _c('div', {
    staticClass: "site_link",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction(_vm.sites[_vm.siteindex]))
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news_sub"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('div', {
    staticClass: "tx18"
  }, [_vm._v(_vm._s(_vm.news.title))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('div', {
    staticClass: "tx18"
  }, [_vm._v(_vm._s(_vm.news.createdAt && _vm.news.createdAt.split(' ')[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s((_vm.news.context))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_r_l"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.backname))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachPicture))]), _vm._v(" "), _vm._l((_vm.news.pictures), function(picture, index) {
    return _c('div', {
      key: 'i' + index
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "margin": "25px"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "width": "212",
        "src": picture.file_url
      },
      on: {
        "click": function($event) {
          _vm.showPicture(picture.file_url)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachFile))]), _vm._v(" "), _vm._l((_vm.news.files), function(file, index) {
    return _c('div', {
      key: 'f' + index
    }, [_c('a', {
      attrs: {
        "href": file.file_url,
        "download": ""
      }
    }, [_vm._v(_vm._s(file.file_name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "pictureModal"
    },
    model: {
      value: (_vm.pictureModal),
      callback: function($$v) {
        _vm.pictureModal = $$v
      },
      expression: "pictureModal"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1221:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team_type"
    }
  }, [(_vm.$route.meta.keepAliveSub2) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_vm._l((_vm.teams), function(teamitem, index) {
    return (teamitem.type == _vm.teamtypeId) ? _c('div', {
      key: index,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectTeam(teamitem)
        }
      }
    }, [_c('div', {
      staticClass: "box2"
    }, [_c('div', {
      staticClass: "class_box"
    }, [_c('div', {
      staticClass: "class_pic1",
      style: ({
        backgroundImage: 'url(' + teamitem.coverPictureUrl + ')'
      })
    }, [_c('div', {
      staticClass: "class_title"
    }, [_vm._v(_vm._s(_vm.showName(teamitem)))])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "teams": _vm.teams
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "signup"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "ca_title"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.className) + " " + _vm._s(_vm.classTypeName(_vm.admission)) + " " + _vm._s(_vm.admission.classHour) + " " + _vm._s(_vm.showPage.application))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "team2_mbox"
  }, [_c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.name))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.name),
      expression: "recordToEdit.name"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.sex) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.sex),
      expression: "recordToEdit.sex"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.sex, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "sex", "1")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.male) + "\n              "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.sex),
      expression: "recordToEdit.sex"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.sex, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "sex", "0")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.female))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.sex),
      expression: "recordToEdit.sex"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.sex, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "sex", "2")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.unkown) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.ID))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.idNo),
      expression: "recordToEdit.idNo"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.idNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "idNo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.birthday))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "date",
      "placeholder": "出生年月日",
      "value": _vm.recordToEdit.birthday
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.parent))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.parentsName),
      expression: "recordToEdit.parentsName"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.parentsName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "parentsName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.serviceunits))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.serviceUnit),
      expression: "recordToEdit.serviceUnit"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.serviceUnit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "serviceUnit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.tel))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.tel),
      expression: "recordToEdit.tel"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "tel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.mobile))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.mobile),
      expression: "recordToEdit.mobile"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.email),
      expression: "recordToEdit.email"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.address))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.address),
      expression: "recordToEdit.address"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classtype) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.memberType),
      expression: "recordToEdit.memberType"
    }],
    attrs: {
      "type": "radio",
      "name": "",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.memberType, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "memberType", "1")
      }
    }
  }), _vm._v(_vm._s(_vm.showPage.adult) + "\n              "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.memberType),
      expression: "recordToEdit.memberType"
    }],
    attrs: {
      "type": "radio",
      "name": "",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.memberType, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "memberType", "2")
      }
    }
  }), _vm._v(_vm._s(_vm.showPage.child) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.charges) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.chargesType),
      expression: "recordToEdit.chargesType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.chargesType, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "chargesType", "1")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.onCampus) + "  "), _c('spen', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admission.charges1 && _vm.admission.charges1 > 0),
      expression: "admission.charges1 && admission.charges1 > 0 "
    }]
  }, [_vm._v("$" + _vm._s(_vm.admission.charges1))]), _vm._v(" "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.chargesType),
      expression: "recordToEdit.chargesType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.chargesType, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "chargesType", "2")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.offCampus) + " "), _c('spen', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admission.charges2 && _vm.admission.charges2 > 0),
      expression: "admission.charges2 && admission.charges2 > 0 "
    }]
  }, [_vm._v("$" + _vm._s(_vm.admission.charges2))])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "w_box"
  }, [_vm._v(_vm._s(_vm.showPage.applynote))]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classWeek) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "1") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.mon) + "\n              "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "2") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.tue))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "3") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.wed))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "4") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.thu))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "5") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.fri))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "6") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.sat))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "7") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.sun))])])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classcount))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "50px",
      "margin": "0 4px"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.recordToEdit.classCount),
      callback: function($$v) {
        _vm.$set(_vm.recordToEdit, "classCount", $$v)
      },
      expression: "recordToEdit.classCount"
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.lesson) + "\n          ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classtime))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "1") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 17：00～18：00\n              "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "2") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 18：00～19：00")])]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "3") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 19：00～20：00\n              "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "4") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 20：00～21：00")])]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "5") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.other) + "\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTimeOther),
      expression: "recordToEdit.classTimeOther"
    }],
    staticClass: "sign_inp4",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.classTimeOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "classTimeOther", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.coachrequirements) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coach),
      expression: "recordToEdit.coach"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.coach, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "coach", "1")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.coachMale) + "\n              "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coach),
      expression: "recordToEdit.coach"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.coach, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "coach", "0")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.coachFeMale))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coach),
      expression: "recordToEdit.coach"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.coach, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "coach", "2")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.coachSpecified) + "\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coachOther),
      expression: "recordToEdit.coachOther"
    }],
    staticClass: "sign_inp4",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.coachOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "coachOther", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "w_box"
  }, [_vm._v(_vm._s(_vm.admission.memo))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree),
      expression: "agree"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.agree) ? _vm._i(_vm.agree, "") > -1 : (_vm.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.agree) + "\n        "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.showPage.signup))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v("Email")])
}]}

/***/ }),

/***/ 1226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_research"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 4) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n          " + _vm._s(teacherpublication.context) + "\n        ")]) : _c('span', [(_vm.executiveDateS(teacherpublication)) ? _c('span', [_vm._v(_vm._s(_vm.executiveDateS(teacherpublication)) + " ~ " + _vm._s(_vm.executiveDateE(teacherpublication)) + ", ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.showName(teacherpublication)) + ", "), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.memo) + ")")]) : _vm._e()])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "member"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "coach_info"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "ca_title"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.className) + " " + _vm._s(_vm.showPage.coach_info_title))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_item',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_item))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'facility',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_inside',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _vm._l((_vm.coachs), function(coach, index) {
    return _c('div', {
      key: index,
      staticClass: "coach_box"
    }, [_c('div', {
      staticClass: "coach_l"
    }, [(coach.profileImage) ? _c('img', {
      attrs: {
        "src": coach.profileImage
      }
    }) : _c('img', {
      attrs: {
        "src": "/../static/images/timeline-default-photo.gif"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "coach_r"
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.showPage.name) + " : " + _vm._s(_vm.showName(coach)))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.showPage.sex) + " : " + _vm._s(_vm.showSex(coach.sex)))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.showPage.license) + " : "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.showLicense(coach))
      }
    })]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.showPage.history) + " : "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.showHistory(coach))
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sites), function(site, index) {
    return (site.trash !== 1) ? _c('div', {
      key: index,
      staticStyle: {
        "padding": "10px 10px 10px 25px"
      }
    }, [_c('a', {
      staticClass: "site_link",
      on: {
        "click": function($event) {
          _vm.pushToSite(index)
        }
      }
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(_vm.showName(site)))])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "sites": _vm.sites
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "site_pic"
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/u19394.jpg"
    }
  })])])
}]}

/***/ }),

/***/ 1237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_info"
    }
  }, [_c('div', {
    staticClass: "tea_r"
  }, [_c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_basic'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.personalInformation))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_edu'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.educationCourses))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_prize'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.awardsExperiences))])])], 1), _vm._v(" "), _vm._l((_vm.customs), function(custom, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_hnav"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'teacher_custom',
          params: {
            custom: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "teah_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v(_vm._s(_vm.showName(custom)))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "teacher": _vm.info,
      "teacherpublications": _vm.teacherpublications,
      "customs": _vm.customs
    }
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1240:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [(!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-left": "-10px"
    },
    domProps: {
      "innerHTML": _vm._s((_vm.Page.title))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.allContent)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "class_inside"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_item',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_item))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'coach_info',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.coach_info))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'facility',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fix",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showNote())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1242:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher"
    }
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_l"
  }, [_c('div', {
    staticClass: "tea_nav_title"
  }, [_vm._v(_vm._s(_vm.showPage.collegeMember))]), _vm._v(" "), _c('div', {
    staticClass: "tea_nav"
  }, [_c('ul', [_c('li', {
    class: _vm.on[11],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(11);
        _vm.selectTitle(11);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.honoraryProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[1],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(1);
        _vm.selectTitle(1);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.professor))]), _vm._v(" "), _c('li', {
    class: _vm.on[2],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(2);
        _vm.selectTitle(2);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.associateProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[3],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(3);
        _vm.selectTitle(3);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.assistantProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[5],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(5);
        _vm.selectTitle(5);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.fullTimeLecturer))]), _vm._v(" "), _c('li', {
    class: _vm.on[6],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(6);
        _vm.selectTitle(6);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[7],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(7);
        _vm.selectTitle(7);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctAssociateProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[8],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(8);
        _vm.selectTitle(8);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctAssistantProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[9],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(9);
        _vm.selectTitle(9);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctLecture))]), _vm._v(" "), _c('li', {
    class: _vm.on[10],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(10);
        _vm.selectTitle(10);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.teachingAssistant))])])])]), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "tea_r"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showTitle()))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "tea_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.teacherSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tea_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("GO")])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt15"
  }, _vm._l((_vm.teachers), function(teacher, index) {
    return (teacher.dept === 1 || teacher.dept === 2) ? _c('div', {
      key: index,
      staticClass: "tea_m"
    }, [_vm._v("\n          " + _vm._s(_vm.returnDept(teacher.dept)) + " / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher)
        }
      }
    }, [_vm._v(_vm._s(teacher.nameCh))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_g"
  }, [_vm._v(_vm._s(_vm.showPage.teacherMemberCount) + " " + _vm._s(_vm.teachers.length) + " " + _vm._s(_vm.showPage.people))]), _vm._v(" "), _c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li"
  }, _vm._l((_vm.teachers), function(teacher, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "tea_li_l"
    }, [(teacher.profileImage) ? _c('img', {
      attrs: {
        "src": teacher.profileImage
      }
    }) : _c('img', {
      attrs: {
        "src": "/../static/images/timeline-default-photo.gif"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tea_li_r"
    }, [_c('div', {
      staticClass: "tea_lititle"
    }, [_vm._v(_vm._s(teacher.nameEn) + " " + _vm._s(teacher.nameCh))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showTitle()))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(teacher.office) + " / " + _vm._s(teacher.tel) + " / " + _vm._s(teacher.email))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v("Office Hour : " + _vm._s(teacher.advisory))]), _vm._v(" "), _c('div', {
      staticClass: "tea_p"
    }, [_c('ul', [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 0)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.personalInformation))])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.educationCourses))])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 2)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.awardsExperiences))])]), _vm._v(" "), _vm._l((_vm.teachercustoms(teacher)), function(custom, index) {
      return _c('li', {
        key: index
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'teacher_custom',
            params: {
              custom: index,
              teacherid: teacher.id
            }
          }
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.showName(custom)) + "\n                    ")])], 1)
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.teachers.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "teacher": _vm.teacher
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "class"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_one"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_c('div', {
    staticClass: "tx_box",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "boxall"
  }, [_vm._l((_vm.classes), function(classitem, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selectClass(classitem)
        }
      }
    }, [_c('div', {
      staticClass: "box2"
    }, [_c('div', {
      staticClass: "class_box"
    }, [_c('div', {
      staticClass: "class_pic1",
      style: ({
        background: 'url(' + classitem.pictureUrl + ')'
      })
    }, [_c('div', {
      staticClass: "class_title"
    }, [_vm._v(_vm._s(_vm.showName(classitem)))])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tx_box mt20",
    domProps: {
      "innerHTML": _vm._s(_vm.showApplication())
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "classitem": _vm.nowClassitem
    },
    on: {
      "initClass": _vm.initClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team_type"
    }
  }, [(_vm.$route.meta.keepAliveSub3) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'photo_in',
          params: {
            albumId: album.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n            " + _vm._s(_vm.showMemo(album)) + "\n            "), _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "photo_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("more")])])]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": album.coverPictureUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_title"
    }, [_vm._v(_vm._s(_vm.showName(album)))]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_tx"
    }, [_vm._v(_vm._s(_vm.showPage.totalCount) + _vm._s(album.pictureCount) + _vm._s(_vm.showPage.item))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_seminar"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 1) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n          " + _vm._s(teacherpublication.context) + "\n        ")]) : _c('span', [_c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.author))
      }
    }), _vm._v(", " + _vm._s(_vm.publication(teacherpublication)) + ",\n          "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.title))
      }
    }), _vm._v(", " + _vm._s(_vm.showName(teacherpublication)) + ", " + _vm._s(_vm.publicationmonth(teacherpublication)) + ",\n          "), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.place) + "), ")]) : _vm._e(), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.memo) + ")")]) : _vm._e()])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_l"
  }, [_c('div', {
    staticClass: "tea_nav_title"
  }, [_vm._v(_vm._s(_vm.newsTitle))]), _vm._v(" "), _c('div', {
    staticClass: "tea_nav"
  }, [_c('ul', _vm._l((_vm.types), function(type, index) {
    return (type.homeDisplay === 1) ? _c('li', {
      key: index,
      class: _vm.on[type.id],
      on: {
        "click": function($event) {
          _vm.focus(type.id);
          _vm.selectName(type.id);
          _vm.pushToNew();
        }
      }
    }, [_vm._v(_vm._s(_vm.showType(type)))]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._l((_vm.hotNews), function(newsitem, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: 'hot' + index,
      staticClass: "more_box"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(newsitem),
        "href": _vm.href(newsitem)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(newsitem)
        }
      }
    }, [_c('div', {
      staticClass: "more_l"
    }, [_vm._v("\n              " + _vm._s(newsitem.createdAt.split(' ')[0]) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "more_r"
    }, [_c('span', {
      staticClass: "nhott"
    }, [_vm._v("HOT")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(newsitem.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.normalNews), function(newsitem, index) {
    return (_vm.inCurrentPage(_vm.hotNews.length + index)) ? _c('div', {
      key: index,
      staticClass: "more_box"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(newsitem),
        "href": _vm.href(newsitem)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(newsitem)
        }
      }
    }, [_c('div', {
      staticClass: "more_l"
    }, [_vm._v("\n              " + _vm._s(newsitem.createdAt.split(' ')[0]) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "more_r"
    }, [_c('span', [_vm._v(_vm._s(newsitem.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    staticStyle: {
      "margin-top": "100px"
    },
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.news.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "newsitem": _vm.newsitem
    },
    on: {
      "initNews": _vm.initNews
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_mbox"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'team_type',
        params: {
          teamtypeid: 1
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.menTeam))])], 1), _vm._v(" "), _c('div', {
    staticClass: "team_mbox2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'team_type',
        params: {
          teamtypeid: 0
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.womenTeam))])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "teams": _vm.teams
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_book"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', [_c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 3) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n            " + _vm._s(teacherpublication.context) + "\n          ")]) : _c('span', [_c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.author))
      }
    }), _vm._v(", " + _vm._s(_vm.publication(teacherpublication)) + ",\n            "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.title))
      }
    }), _vm._v(", " + _vm._s(_vm.showName(teacherpublication)) + "\n          ")])]) : _vm._e()
  }))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "journal_content"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('p', {
    staticStyle: {
      "border-left": "3px solid #bbb",
      "padding-left": "10px",
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.showName(_vm.type)))]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.showPage.fileName))])]), _vm._v(" "), _vm._l((_vm.journals), function(journal, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('a', {
      attrs: {
        "href": journal.fileUrl,
        "download": ""
      }
    }, [_c('div', [_vm._v(_vm._s(journal.title))])])])])
  })], 2)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "video"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.nowTitle,
      "class-name": "vertical-center-modal-video"
    },
    model: {
      value: (_vm.modalvideo),
      callback: function($$v) {
        _vm.modalvideo = $$v
      },
      expression: "modalvideo"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center",
      "margin": "0"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": _vm.nowVideo,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "psear_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.videoSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.showPage.search))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('span', {
    staticClass: "ca2_btn"
  }, [_vm._v(_vm._s(_vm.showPage.orderByReleaseDate))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _vm._l((_vm.videos), function(video, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box",
      on: {
        "click": function($event) {
          _vm.selectVideo(video)
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": video.coverPictureUrl
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.videos.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_edu"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.education))]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.backgroundColumn,
      "data": _vm.teacher.background
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.course))]), _vm._v(" "), _vm._l((_vm.teacher.course), function(course, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showCourse(course)))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1296:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "facility"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_item',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_item))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'coach_info',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.coach_info))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_inside',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fix",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showSite())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "administrative"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.administrativeMember))]), _vm._v(" "), _c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "con_ta"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "140"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "103"
    }
  }, [_vm._v(_vm._s(_vm.showPage.jobTitle))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "110"
    }
  }, [_vm._v(_vm._s(_vm.showPage.activityGroup))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "103"
    }
  }, [_vm._v(_vm._s(_vm.showPage.name))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "149"
    }
  }, [_vm._v(_vm._s(_vm.showPage.officePhone))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "385"
    }
  }, [_vm._v(_vm._s(_vm.showPage.business))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "156"
    }
  }, [_vm._v(_vm._s(_vm.showPage.agent))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.admins), function(admin, index) {
    return (_vm.inCurrentPage(index)) ? _c('tr', {
      key: index
    }, [(admin.profileImage) ? _c('td', {
      staticClass: "mobile-img"
    }, [_c('img', {
      attrs: {
        "src": admin.profileImage
      }
    })]) : _vm._e(), _vm._v(" "), (!admin.profileImage) ? _c('td', {
      staticClass: "mobile-img"
    }, [_c('img', {
      attrs: {
        "src": "/../static/images/timeline-default-photo.gif"
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.jobTitle
      }
    }, [_vm._v(_vm._s(_vm.showJobTitle(admin)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.activityGroup
      }
    }, [_vm._v(_vm._s(_vm.showGroup(admin)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.name
      }
    }, [_vm._v(_vm._s(_vm.showName(admin)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.officePhone
      }
    }, [_vm._v(_vm._s(admin.tel))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "data-label": _vm.showPage.business
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.showIntroduction(admin))
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.agent
      }
    }, [_vm._v(_vm._s(admin.agent))])]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.admins.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var animate_type = 'up'; //up or left or fadeout
var sec = 0.3; //0.5秒
var nav_box_setting = ['.cell_nav_box', '.cell_nav_open_btn', '.cell_nav_close_btn', animate_type, sec];
var nav_box_offset
var obj
var obj_close
var check
var move


$().ready(function() {
  nav_box(nav_box_setting);
  $(' #da-thumbs > li ').each(function() { $(this).hoverdir(); });
});

var cx = '005583908390302854516:faepp2qgog8';
var gcse = document.createElement('script');
gcse.type = 'text/javascript';
gcse.async = true;
gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
var s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(gcse, s);

function nav_box(nav_box_setting, animate) {
  nav_box_offset = 20;
  if (!nav_box_setting) return;

  obj = $(nav_box_setting[0]);
  obj_close = $(nav_box_setting[0]);
  animate_type = nav_box_setting[3];
  sec = nav_box_setting[4] * 1000;

  if (animate != 'Y') {
    if (animate_type == 'left') $(nav_box_setting[0]).css({ 'position': 'fixed', 'left': ($(this).width() * -1 - nav_box_offset) });
    if (animate_type == 'up') $(nav_box_setting[0]).css({ 'position': 'fixed', 'top': $(this).height() * -1 - nav_box_offset });
    if (animate_type == 'fadeout') $(nav_box_setting[0]).css({ 'position': 'fixed' }).hide();
    $(nav_box_setting[1]).on('click', function() { nav_box(nav_box_setting, 'Y') });
    $(nav_box_setting[2]).on('click', function() { nav_box(nav_box_setting, 'Y') });
    $('.clicknav').on('click', function() { nav_box(nav_box_setting, 'Y') });
    return;
  }

  check = false;
  if (animate_type == 'left' && parseInt(obj.css('left')) < 0) check = true;
  if (animate_type == 'up' && parseInt(obj.css('top')) < 0) check = true;
  if (animate_type == 'fadeout' && obj.css('display') == 'none') check = true;

  if (check) {
    //OPEN鈕效果
    //$(nav_box_setting[1]).hide();
    if (animate_type == 'left') obj.animate({ left: 0 }, sec);
    if (animate_type == 'up') obj.animate({ top: 84 }, sec);
    if (animate_type == 'fadeout') obj.fadeIn(sec);
  } else {
    if (animate_type == 'left') {
      move = obj.width() + nav_box_offset;
      obj.animate({ left: move * -1 }, sec);
    }

    if (animate_type == 'up') {
      move = obj.height() + nav_box_offset;
      obj.animate({ top: move * -1 }, sec);
    }
    if (animate_type == 'fadeout') obj.fadeOut(sec);

    //OPEN鈕效果
    //setTimeout(function(){$(nav_box_setting[1]).show();},sec);
  }
}

// $(function() {
//   SyntaxHighlighter.all();
// });

/* harmony default export */ __webpack_exports__["a"] = ({ //export your file
  init: function() {
    $('.clone').remove()
    $('.flexslider').flexslider({
      animation: "slide",
    });
    $('#carousel-example-generic').carousel({
      interval: 4000
    });

  },
  destroy: function() {
    $('.clone').remove()
  },
  test: function() {
    nav_box(nav_box_setting);
  }
});
$(window).on('load', function() {
  $('.flexslider').flexslider({
    animation: "slide",
    start: function(slider) {
      $('body').removeClass('loading');
    }
  });
})
// 若在mounted使用init()輪播圖片大小有變成超大的可能
//　所以額外使用load

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 1311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);

/*! jQuery v1.11.1 | (c) 2005, 2014 jQuery Foundation, Inc. | jquery.org/license */ ! function(a, b) { "object" == typeof module && "object" == typeof module.exports ? module.exports = a.document ? b(a, !0) : function(a) { if (!a.document) throw new Error("jQuery requires a window with a document"); return b(a) } : b(a) }("undefined" != typeof window ? window : this, function(a, b) {
  var c = [],
    d = c.slice,
    e = c.concat,
    f = c.push,
    g = c.indexOf,
    h = {},
    i = h.toString,
    j = h.hasOwnProperty,
    k = {},
    l = "1.11.1",
    m = function(a, b) { return new m.fn.init(a, b) },
    n = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
    o = /^-ms-/,
    p = /-([\da-z])/gi,
    q = function(a, b) { return b.toUpperCase() };
  m.fn = m.prototype = {
    jquery: l,
    constructor: m,
    selector: "",
    length: 0,
    toArray: function() { return d.call(this) },
    get: function(a) { return null != a ? 0 > a ? this[a + this.length] : this[a] : d.call(this) },
    pushStack: function(a) { var b = m.merge(this.constructor(), a); return b.prevObject = this, b.context = this.context, b },
    each: function(a, b) { return m.each(this, a, b) },
    map: function(a) { return this.pushStack(m.map(this, function(b, c) { return a.call(b, c, b) })) },
    slice: function() { return this.pushStack(d.apply(this, arguments)) },
    first: function() { return this.eq(0) },
    last: function() { return this.eq(-1) },
    eq: function(a) {
      var b = this.length,
        c = +a + (0 > a ? b : 0);
      return this.pushStack(c >= 0 && b > c ? [this[c]] : [])
    },
    end: function() { return this.prevObject || this.constructor(null) },
    push: f,
    sort: c.sort,
    splice: c.splice
  }, m.extend = m.fn.extend = function() {
    var a, b, c, d, e, f, g = arguments[0] || {},
      h = 1,
      i = arguments.length,
      j = !1;
    for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == typeof g || m.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++)
      if (null != (e = arguments[h]))
        for (d in e) a = g[d], c = e[d], g !== c && (j && c && (m.isPlainObject(c) || (b = m.isArray(c))) ? (b ? (b = !1, f = a && m.isArray(a) ? a : []) : f = a && m.isPlainObject(a) ? a : {}, g[d] = m.extend(j, f, c)) : void 0 !== c && (g[d] = c));
    return g
  }, m.extend({
    expando: "jQuery" + (l + Math.random()).replace(/\D/g, ""),
    isReady: !0,
    error: function(a) { throw new Error(a) },
    noop: function() {},
    isFunction: function(a) { return "function" === m.type(a) },
    isArray: Array.isArray || function(a) { return "array" === m.type(a) },
    isWindow: function(a) { return null != a && a == a.window },
    isNumeric: function(a) { return !m.isArray(a) && a - parseFloat(a) >= 0 },
    isEmptyObject: function(a) { var b; for (b in a) return !1; return !0 },
    isPlainObject: function(a) {
      var b;
      if (!a || "object" !== m.type(a) || a.nodeType || m.isWindow(a)) return !1;
      try { if (a.constructor && !j.call(a, "constructor") && !j.call(a.constructor.prototype, "isPrototypeOf")) return !1 } catch (c) { return !1 }
      if (k.ownLast)
        for (b in a) return j.call(a, b);
      for (b in a);
      return void 0 === b || j.call(a, b)
    },
    type: function(a) { return null == a ? a + "" : "object" == typeof a || "function" == typeof a ? h[i.call(a)] || "object" : typeof a },
    globalEval: function(b) { b && m.trim(b) && (a.execScript || function(b) { a.eval.call(a, b) })(b) },
    camelCase: function(a) { return a.replace(o, "ms-").replace(p, q) },
    nodeName: function(a, b) { return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase() },
    each: function(a, b, c) {
      var d, e = 0,
        f = a.length,
        g = r(a);
      if (c) {
        if (g) {
          for (; f > e; e++)
            if (d = b.apply(a[e], c), d === !1) break
        } else
          for (e in a)
            if (d = b.apply(a[e], c), d === !1) break
      } else if (g) {
        for (; f > e; e++)
          if (d = b.call(a[e], e, a[e]), d === !1) break
      } else
        for (e in a)
          if (d = b.call(a[e], e, a[e]), d === !1) break;
      return a
    },
    trim: function(a) { return null == a ? "" : (a + "").replace(n, "") },
    makeArray: function(a, b) { var c = b || []; return null != a && (r(Object(a)) ? m.merge(c, "string" == typeof a ? [a] : a) : f.call(c, a)), c },
    inArray: function(a, b, c) {
      var d;
      if (b) {
        if (g) return g.call(b, a, c);
        for (d = b.length, c = c ? 0 > c ? Math.max(0, d + c) : c : 0; d > c; c++)
          if (c in b && b[c] === a) return c
      }
      return -1
    },
    merge: function(a, b) {
      var c = +b.length,
        d = 0,
        e = a.length;
      while (c > d) a[e++] = b[d++];
      if (c !== c)
        while (void 0 !== b[d]) a[e++] = b[d++];
      return a.length = e, a
    },
    grep: function(a, b, c) { for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) d = !b(a[f], f), d !== h && e.push(a[f]); return e },
    map: function(a, b, c) {
      var d, f = 0,
        g = a.length,
        h = r(a),
        i = [];
      if (h)
        for (; g > f; f++) d = b(a[f], f, c), null != d && i.push(d);
      else
        for (f in a) d = b(a[f], f, c), null != d && i.push(d);
      return e.apply([], i)
    },
    guid: 1,
    proxy: function(a, b) { var c, e, f; return "string" == typeof b && (f = a[b], b = a, a = f), m.isFunction(a) ? (c = d.call(arguments, 2), e = function() { return a.apply(b || this, c.concat(d.call(arguments))) }, e.guid = a.guid = a.guid || m.guid++, e) : void 0 },
    now: function() { return +new Date },
    support: k
  }), m.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(a, b) { h["[object " + b + "]"] = b.toLowerCase() });

  function r(a) {
    var b = a.length,
      c = m.type(a);
    return "function" === c || m.isWindow(a) ? !1 : 1 === a.nodeType && b ? !0 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a
  }
  var s = function(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u = "sizzle" + -new Date,
      v = a.document,
      w = 0,
      x = 0,
      y = gb(),
      z = gb(),
      A = gb(),
      B = function(a, b) { return a === b && (l = !0), 0 },
      C = "undefined",
      D = 1 << 31,
      E = {}.hasOwnProperty,
      F = [],
      G = F.pop,
      H = F.push,
      I = F.push,
      J = F.slice,
      K = F.indexOf || function(a) {
        for (var b = 0, c = this.length; c > b; b++)
          if (this[b] === a) return b;
        return -1
      },
      L = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      M = "[\\x20\\t\\r\\n\\f]",
      N = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
      O = N.replace("w", "w#"),
      P = "\\[" + M + "*(" + N + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + O + "))|)" + M + "*\\]",
      Q = ":(" + N + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + P + ")*)|.*)\\)|)",
      R = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
      S = new RegExp("^" + M + "*," + M + "*"),
      T = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
      U = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]", "g"),
      V = new RegExp(Q),
      W = new RegExp("^" + O + "$"),
      X = { ID: new RegExp("^#(" + N + ")"), CLASS: new RegExp("^\\.(" + N + ")"), TAG: new RegExp("^(" + N.replace("w", "w*") + ")"), ATTR: new RegExp("^" + P), PSEUDO: new RegExp("^" + Q), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"), bool: new RegExp("^(?:" + L + ")$", "i"), needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i") },
      Y = /^(?:input|select|textarea|button)$/i,
      Z = /^h\d$/i,
      $ = /^[^{]+\{\s*\[native \w/,
      _ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      ab = /[+~]/,
      bb = /'|\\/g,
      cb = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)", "ig"),
      db = function(a, b, c) { var d = "0x" + b - 65536; return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320) };
    try { I.apply(F = J.call(v.childNodes), v.childNodes), F[v.childNodes.length].nodeType } catch (eb) {
      I = {
        apply: F.length ? function(a, b) { H.apply(a, J.call(b)) } : function(a, b) {
          var c = a.length,
            d = 0;
          while (a[c++] = b[d++]);
          a.length = c - 1
        }
      }
    }

    function fb(a, b, d, e) {
      var f, h, j, k, l, o, r, s, w, x;
      if ((b ? b.ownerDocument || b : v) !== n && m(b), b = b || n, d = d || [], !a || "string" != typeof a) return d;
      if (1 !== (k = b.nodeType) && 9 !== k) return [];
      if (p && !e) {
        if (f = _.exec(a))
          if (j = f[1]) { if (9 === k) { if (h = b.getElementById(j), !h || !h.parentNode) return d; if (h.id === j) return d.push(h), d } else if (b.ownerDocument && (h = b.ownerDocument.getElementById(j)) && t(b, h) && h.id === j) return d.push(h), d } else { if (f[2]) return I.apply(d, b.getElementsByTagName(a)), d; if ((j = f[3]) && c.getElementsByClassName && b.getElementsByClassName) return I.apply(d, b.getElementsByClassName(j)), d }
        if (c.qsa && (!q || !q.test(a))) {
          if (s = r = u, w = b, x = 9 === k && a, 1 === k && "object" !== b.nodeName.toLowerCase()) {
            o = g(a), (r = b.getAttribute("id")) ? s = r.replace(bb, "\\$&") : b.setAttribute("id", s), s = "[id='" + s + "'] ", l = o.length;
            while (l--) o[l] = s + qb(o[l]);
            w = ab.test(a) && ob(b.parentNode) || b, x = o.join(",")
          }
          if (x) try { return I.apply(d, w.querySelectorAll(x)), d } catch (y) {} finally { r || b.removeAttribute("id") }
        }
      }
      return i(a.replace(R, "$1"), b, d, e)
    }

    function gb() {
      var a = [];

      function b(c, e) { return a.push(c + " ") > d.cacheLength && delete b[a.shift()], b[c + " "] = e }
      return b
    }

    function hb(a) { return a[u] = !0, a }

    function ib(a) { var b = n.createElement("div"); try { return !!a(b) } catch (c) { return !1 } finally { b.parentNode && b.parentNode.removeChild(b), b = null } }

    function jb(a, b) {
      var c = a.split("|"),
        e = a.length;
      while (e--) d.attrHandle[c[e]] = b
    }

    function kb(a, b) {
      var c = b && a,
        d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || D) - (~a.sourceIndex || D);
      if (d) return d;
      if (c)
        while (c = c.nextSibling)
          if (c === b) return -1;
      return a ? 1 : -1
    }

    function lb(a) { return function(b) { var c = b.nodeName.toLowerCase(); return "input" === c && b.type === a } }

    function mb(a) { return function(b) { var c = b.nodeName.toLowerCase(); return ("input" === c || "button" === c) && b.type === a } }

    function nb(a) {
      return hb(function(b) {
        return b = +b, hb(function(c, d) {
          var e, f = a([], c.length, b),
            g = f.length;
          while (g--) c[e = f[g]] && (c[e] = !(d[e] = c[e]))
        })
      })
    }

    function ob(a) { return a && typeof a.getElementsByTagName !== C && a } c = fb.support = {}, f = fb.isXML = function(a) { var b = a && (a.ownerDocument || a).documentElement; return b ? "HTML" !== b.nodeName : !1 }, m = fb.setDocument = function(a) {
      var b, e = a ? a.ownerDocument || a : v,
        g = e.defaultView;
      return e !== n && 9 === e.nodeType && e.documentElement ? (n = e, o = e.documentElement, p = !f(e), g && g !== g.top && (g.addEventListener ? g.addEventListener("unload", function() { m() }, !1) : g.attachEvent && g.attachEvent("onunload", function() { m() })), c.attributes = ib(function(a) { return a.className = "i", !a.getAttribute("className") }), c.getElementsByTagName = ib(function(a) { return a.appendChild(e.createComment("")), !a.getElementsByTagName("*").length }), c.getElementsByClassName = $.test(e.getElementsByClassName) && ib(function(a) { return a.innerHTML = "<div class='a'></div><div class='a i'></div>", a.firstChild.className = "i", 2 === a.getElementsByClassName("i").length }), c.getById = ib(function(a) { return o.appendChild(a).id = u, !e.getElementsByName || !e.getElementsByName(u).length }), c.getById ? (d.find.ID = function(a, b) { if (typeof b.getElementById !== C && p) { var c = b.getElementById(a); return c && c.parentNode ? [c] : [] } }, d.filter.ID = function(a) { var b = a.replace(cb, db); return function(a) { return a.getAttribute("id") === b } }) : (delete d.find.ID, d.filter.ID = function(a) { var b = a.replace(cb, db); return function(a) { var c = typeof a.getAttributeNode !== C && a.getAttributeNode("id"); return c && c.value === b } }), d.find.TAG = c.getElementsByTagName ? function(a, b) { return typeof b.getElementsByTagName !== C ? b.getElementsByTagName(a) : void 0 } : function(a, b) {
        var c, d = [],
          e = 0,
          f = b.getElementsByTagName(a);
        if ("*" === a) { while (c = f[e++]) 1 === c.nodeType && d.push(c); return d }
        return f
      }, d.find.CLASS = c.getElementsByClassName && function(a, b) { return typeof b.getElementsByClassName !== C && p ? b.getElementsByClassName(a) : void 0 }, r = [], q = [], (c.qsa = $.test(e.querySelectorAll)) && (ib(function(a) { a.innerHTML = "<select msallowclip=''><option selected=''></option></select>", a.querySelectorAll("[msallowclip^='']").length && q.push("[*^$]=" + M + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || q.push("\\[" + M + "*(?:value|" + L + ")"), a.querySelectorAll(":checked").length || q.push(":checked") }), ib(function(a) {
        var b = e.createElement("input");
        b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && q.push("name" + M + "*[*^$|!~]?="), a.querySelectorAll(":enabled").length || q.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), q.push(",.*:")
      })), (c.matchesSelector = $.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ib(function(a) { c.disconnectedMatch = s.call(a, "div"), s.call(a, "[s!='']:x"), r.push("!=", Q) }), q = q.length && new RegExp(q.join("|")), r = r.length && new RegExp(r.join("|")), b = $.test(o.compareDocumentPosition), t = b || $.test(o.contains) ? function(a, b) {
        var c = 9 === a.nodeType ? a.documentElement : a,
          d = b && b.parentNode;
        return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)))
      } : function(a, b) {
        if (b)
          while (b = b.parentNode)
            if (b === a) return !0;
        return !1
      }, B = b ? function(a, b) { if (a === b) return l = !0, 0; var d = !a.compareDocumentPosition - !b.compareDocumentPosition; return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === e || a.ownerDocument === v && t(v, a) ? -1 : b === e || b.ownerDocument === v && t(v, b) ? 1 : k ? K.call(k, a) - K.call(k, b) : 0 : 4 & d ? -1 : 1) } : function(a, b) {
        if (a === b) return l = !0, 0;
        var c, d = 0,
          f = a.parentNode,
          g = b.parentNode,
          h = [a],
          i = [b];
        if (!f || !g) return a === e ? -1 : b === e ? 1 : f ? -1 : g ? 1 : k ? K.call(k, a) - K.call(k, b) : 0;
        if (f === g) return kb(a, b);
        c = a;
        while (c = c.parentNode) h.unshift(c);
        c = b;
        while (c = c.parentNode) i.unshift(c);
        while (h[d] === i[d]) d++;
        return d ? kb(h[d], i[d]) : h[d] === v ? -1 : i[d] === v ? 1 : 0
      }, e) : n
    }, fb.matches = function(a, b) { return fb(a, null, null, b) }, fb.matchesSelector = function(a, b) {
      if ((a.ownerDocument || a) !== n && m(a), b = b.replace(U, "='$1']"), !(!c.matchesSelector || !p || r && r.test(b) || q && q.test(b))) try { var d = s.call(a, b); if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d } catch (e) {}
      return fb(b, n, null, [a]).length > 0
    }, fb.contains = function(a, b) { return (a.ownerDocument || a) !== n && m(a), t(a, b) }, fb.attr = function(a, b) {
      (a.ownerDocument || a) !== n && m(a);
      var e = d.attrHandle[b.toLowerCase()],
        f = e && E.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
      return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null
    }, fb.error = function(a) { throw new Error("Syntax error, unrecognized expression: " + a) }, fb.uniqueSort = function(a) {
      var b, d = [],
        e = 0,
        f = 0;
      if (l = !c.detectDuplicates, k = !c.sortStable && a.slice(0), a.sort(B), l) { while (b = a[f++]) b === a[f] && (e = d.push(f)); while (e--) a.splice(d[e], 1) }
      return k = null, a
    }, e = fb.getText = function(a) {
      var b, c = "",
        d = 0,
        f = a.nodeType;
      if (f) { if (1 === f || 9 === f || 11 === f) { if ("string" == typeof a.textContent) return a.textContent; for (a = a.firstChild; a; a = a.nextSibling) c += e(a) } else if (3 === f || 4 === f) return a.nodeValue } else
        while (b = a[d++]) c += e(b);
      return c
    }, d = fb.selectors = {
      cacheLength: 50,
      createPseudo: hb,
      match: X,
      attrHandle: {},
      find: {},
      relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
      preFilter: { ATTR: function(a) { return a[1] = a[1].replace(cb, db), a[3] = (a[3] || a[4] || a[5] || "").replace(cb, db), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4) }, CHILD: function(a) { return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || fb.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && fb.error(a[0]), a }, PSEUDO: function(a) { var b, c = !a[6] && a[2]; return X.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && V.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3)) } },
      filter: {
        TAG: function(a) { var b = a.replace(cb, db).toLowerCase(); return "*" === a ? function() { return !0 } : function(a) { return a.nodeName && a.nodeName.toLowerCase() === b } },
        CLASS: function(a) { var b = y[a + " "]; return b || (b = new RegExp("(^|" + M + ")" + a + "(" + M + "|$)")) && y(a, function(a) { return b.test("string" == typeof a.className && a.className || typeof a.getAttribute !== C && a.getAttribute("class") || "") }) },
        ATTR: function(a, b, c) { return function(d) { var e = fb.attr(d, a); return null == e ? "!=" === b : b ? (e += "", "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e + " ").indexOf(c) > -1 : "|=" === b ? e === c || e.slice(0, c.length + 1) === c + "-" : !1) : !0 } },
        CHILD: function(a, b, c, d, e) {
          var f = "nth" !== a.slice(0, 3),
            g = "last" !== a.slice(-4),
            h = "of-type" === b;
          return 1 === d && 0 === e ? function(a) { return !!a.parentNode } : function(b, c, i) {
            var j, k, l, m, n, o, p = f !== g ? "nextSibling" : "previousSibling",
              q = b.parentNode,
              r = h && b.nodeName.toLowerCase(),
              s = !i && !h;
            if (q) {
              if (f) {
                while (p) {
                  l = b;
                  while (l = l[p])
                    if (h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType) return !1;
                  o = p = "only" === a && !o && "nextSibling"
                }
                return !0
              }
              if (o = [g ? q.firstChild : q.lastChild], g && s) {
                k = q[u] || (q[u] = {}), j = k[a] || [], n = j[0] === w && j[1], m = j[0] === w && j[2], l = n && q.childNodes[n];
                while (l = ++n && l && l[p] || (m = n = 0) || o.pop())
                  if (1 === l.nodeType && ++m && l === b) { k[a] = [w, n, m]; break }
              } else if (s && (j = (b[u] || (b[u] = {}))[a]) && j[0] === w) m = j[1];
              else
                while (l = ++n && l && l[p] || (m = n = 0) || o.pop())
                  if ((h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType) && ++m && (s && ((l[u] || (l[u] = {}))[a] = [w, m]), l === b)) break;
              return m -= e, m === d || m % d === 0 && m / d >= 0
            }
          }
        },
        PSEUDO: function(a, b) {
          var c, e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || fb.error("unsupported pseudo: " + a);
          return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b], d.setFilters.hasOwnProperty(a.toLowerCase()) ? hb(function(a, c) {
            var d, f = e(a, b),
              g = f.length;
            while (g--) d = K.call(a, f[g]), a[d] = !(c[d] = f[g])
          }) : function(a) { return e(a, 0, c) }) : e
        }
      },
      pseudos: {
        not: hb(function(a) {
          var b = [],
            c = [],
            d = h(a.replace(R, "$1"));
          return d[u] ? hb(function(a, b, c, e) {
            var f, g = d(a, null, e, []),
              h = a.length;
            while (h--)(f = g[h]) && (a[h] = !(b[h] = f))
          }) : function(a, e, f) { return b[0] = a, d(b, null, f, c), !c.pop() }
        }),
        has: hb(function(a) { return function(b) { return fb(a, b).length > 0 } }),
        contains: hb(function(a) { return function(b) { return (b.textContent || b.innerText || e(b)).indexOf(a) > -1 } }),
        lang: hb(function(a) {
          return W.test(a || "") || fb.error("unsupported lang: " + a), a = a.replace(cb, db).toLowerCase(),
            function(b) {
              var c;
              do
                if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-"); while ((b = b.parentNode) && 1 === b.nodeType);
              return !1
            }
        }),
        target: function(b) { var c = a.location && a.location.hash; return c && c.slice(1) === b.id },
        root: function(a) { return a === o },
        focus: function(a) { return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex) },
        enabled: function(a) { return a.disabled === !1 },
        disabled: function(a) { return a.disabled === !0 },
        checked: function(a) { var b = a.nodeName.toLowerCase(); return "input" === b && !!a.checked || "option" === b && !!a.selected },
        selected: function(a) { return a.parentNode && a.parentNode.selectedIndex, a.selected === !0 },
        empty: function(a) {
          for (a = a.firstChild; a; a = a.nextSibling)
            if (a.nodeType < 6) return !1;
          return !0
        },
        parent: function(a) { return !d.pseudos.empty(a) },
        header: function(a) { return Z.test(a.nodeName) },
        input: function(a) { return Y.test(a.nodeName) },
        button: function(a) { var b = a.nodeName.toLowerCase(); return "input" === b && "button" === a.type || "button" === b },
        text: function(a) { var b; return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase()) },
        first: nb(function() { return [0] }),
        last: nb(function(a, b) { return [b - 1] }),
        eq: nb(function(a, b, c) { return [0 > c ? c + b : c] }),
        even: nb(function(a, b) { for (var c = 0; b > c; c += 2) a.push(c); return a }),
        odd: nb(function(a, b) { for (var c = 1; b > c; c += 2) a.push(c); return a }),
        lt: nb(function(a, b, c) { for (var d = 0 > c ? c + b : c; --d >= 0;) a.push(d); return a }),
        gt: nb(function(a, b, c) { for (var d = 0 > c ? c + b : c; ++d < b;) a.push(d); return a })
      }
    }, d.pseudos.nth = d.pseudos.eq;
    for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) d.pseudos[b] = lb(b);
    for (b in { submit: !0, reset: !0 }) d.pseudos[b] = mb(b);

    function pb() {} pb.prototype = d.filters = d.pseudos, d.setFilters = new pb, g = fb.tokenize = function(a, b) {
      var c, e, f, g, h, i, j, k = z[a + " "];
      if (k) return b ? 0 : k.slice(0);
      h = a, i = [], j = d.preFilter;
      while (h) {
        (!c || (e = S.exec(h))) && (e && (h = h.slice(e[0].length) || h), i.push(f = [])), c = !1, (e = T.exec(h)) && (c = e.shift(), f.push({ value: c, type: e[0].replace(R, " ") }), h = h.slice(c.length));
        for (g in d.filter) !(e = X[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(), f.push({ value: c, type: g, matches: e }), h = h.slice(c.length));
        if (!c) break
      }
      return b ? h.length : h ? fb.error(a) : z(a, i).slice(0)
    };

    function qb(a) { for (var b = 0, c = a.length, d = ""; c > b; b++) d += a[b].value; return d }

    function rb(a, b, c) {
      var d = b.dir,
        e = c && "parentNode" === d,
        f = x++;
      return b.first ? function(b, c, f) {
        while (b = b[d])
          if (1 === b.nodeType || e) return a(b, c, f)
      } : function(b, c, g) {
        var h, i, j = [w, f];
        if (g) {
          while (b = b[d])
            if ((1 === b.nodeType || e) && a(b, c, g)) return !0
        } else
          while (b = b[d])
            if (1 === b.nodeType || e) { if (i = b[u] || (b[u] = {}), (h = i[d]) && h[0] === w && h[1] === f) return j[2] = h[2]; if (i[d] = j, j[2] = a(b, c, g)) return !0 }
      }
    }

    function sb(a) {
      return a.length > 1 ? function(b, c, d) {
        var e = a.length;
        while (e--)
          if (!a[e](b, c, d)) return !1;
        return !0
      } : a[0]
    }

    function tb(a, b, c) { for (var d = 0, e = b.length; e > d; d++) fb(a, b[d], c); return c }

    function ub(a, b, c, d, e) { for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++)(f = a[h]) && (!c || c(f, d, e)) && (g.push(f), j && b.push(h)); return g }

    function vb(a, b, c, d, e, f) {
      return d && !d[u] && (d = vb(d)), e && !e[u] && (e = vb(e, f)), hb(function(f, g, h, i) {
        var j, k, l, m = [],
          n = [],
          o = g.length,
          p = f || tb(b || "*", h.nodeType ? [h] : h, []),
          q = !a || !f && b ? p : ub(p, m, a, h, i),
          r = c ? e || (f ? a : o || d) ? [] : g : q;
        if (c && c(q, r, h, i), d) { j = ub(r, n), d(j, [], h, i), k = j.length; while (k--)(l = j[k]) && (r[n[k]] = !(q[n[k]] = l)) }
        if (f) {
          if (e || a) {
            if (e) {
              j = [], k = r.length;
              while (k--)(l = r[k]) && j.push(q[k] = l);
              e(null, r = [], j, i)
            }
            k = r.length;
            while (k--)(l = r[k]) && (j = e ? K.call(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l))
          }
        } else r = ub(r === g ? r.splice(o, r.length) : r), e ? e(null, g, r, i) : I.apply(g, r)
      })
    }

    function wb(a) {
      for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = rb(function(a) { return a === b }, h, !0), l = rb(function(a) { return K.call(b, a) > -1 }, h, !0), m = [function(a, c, d) { return !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d)) }]; f > i; i++)
        if (c = d.relative[a[i].type]) m = [rb(sb(m), c)];
        else {
          if (c = d.filter[a[i].type].apply(null, a[i].matches), c[u]) {
            for (e = ++i; f > e; e++)
              if (d.relative[a[e].type]) break;
            return vb(i > 1 && sb(m), i > 1 && qb(a.slice(0, i - 1).concat({ value: " " === a[i - 2].type ? "*" : "" })).replace(R, "$1"), c, e > i && wb(a.slice(i, e)), f > e && wb(a = a.slice(e)), f > e && qb(a))
          }
          m.push(c)
        }
      return sb(m)
    }

    function xb(a, b) {
      var c = b.length > 0,
        e = a.length > 0,
        f = function(f, g, h, i, k) {
          var l, m, o, p = 0,
            q = "0",
            r = f && [],
            s = [],
            t = j,
            u = f || e && d.find.TAG("*", k),
            v = w += null == t ? 1 : Math.random() || .1,
            x = u.length;
          for (k && (j = g !== n && g); q !== x && null != (l = u[q]); q++) {
            if (e && l) {
              m = 0;
              while (o = a[m++])
                if (o(l, g, h)) { i.push(l); break }
              k && (w = v)
            }
            c && ((l = !o && l) && p--, f && r.push(l))
          }
          if (p += q, c && q !== p) {
            m = 0;
            while (o = b[m++]) o(r, s, g, h);
            if (f) {
              if (p > 0)
                while (q--) r[q] || s[q] || (s[q] = G.call(i));
              s = ub(s)
            }
            I.apply(i, s), k && !f && s.length > 0 && p + b.length > 1 && fb.uniqueSort(i)
          }
          return k && (w = v, j = t), r
        };
      return c ? hb(f) : f
    }
    return h = fb.compile = function(a, b) {
      var c, d = [],
        e = [],
        f = A[a + " "];
      if (!f) {
        b || (b = g(a)), c = b.length;
        while (c--) f = wb(b[c]), f[u] ? d.push(f) : e.push(f);
        f = A(a, xb(e, d)), f.selector = a
      }
      return f
    }, i = fb.select = function(a, b, e, f) {
      var i, j, k, l, m, n = "function" == typeof a && a,
        o = !f && g(a = n.selector || a);
      if (e = e || [], 1 === o.length) {
        if (j = o[0] = o[0].slice(0), j.length > 2 && "ID" === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type]) {
          if (b = (d.find.ID(k.matches[0].replace(cb, db), b) || [])[0], !b) return e;
          n && (b = b.parentNode), a = a.slice(j.shift().value.length)
        }
        i = X.needsContext.test(a) ? 0 : j.length;
        while (i--) { if (k = j[i], d.relative[l = k.type]) break; if ((m = d.find[l]) && (f = m(k.matches[0].replace(cb, db), ab.test(j[0].type) && ob(b.parentNode) || b))) { if (j.splice(i, 1), a = f.length && qb(j), !a) return I.apply(e, f), e; break } }
      }
      return (n || h(a, o))(f, b, !p, e, ab.test(a) && ob(b.parentNode) || b), e
    }, c.sortStable = u.split("").sort(B).join("") === u, c.detectDuplicates = !!l, m(), c.sortDetached = ib(function(a) { return 1 & a.compareDocumentPosition(n.createElement("div")) }), ib(function(a) { return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href") }) || jb("type|href|height|width", function(a, b, c) { return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2) }), c.attributes && ib(function(a) { return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value") }) || jb("value", function(a, b, c) { return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue }), ib(function(a) { return null == a.getAttribute("disabled") }) || jb(L, function(a, b, c) { var d; return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null }), fb
  }(a);
  m.find = s, m.expr = s.selectors, m.expr[":"] = m.expr.pseudos, m.unique = s.uniqueSort, m.text = s.getText, m.isXMLDoc = s.isXML, m.contains = s.contains;
  var t = m.expr.match.needsContext,
    u = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
    v = /^.[^:#\[\.,]*$/;

  function w(a, b, c) {
    if (m.isFunction(b)) return m.grep(a, function(a, d) { return !!b.call(a, d, a) !== c });
    if (b.nodeType) return m.grep(a, function(a) { return a === b !== c });
    if ("string" == typeof b) {
      if (v.test(b)) return m.filter(b, a, c);
      b = m.filter(b, a)
    }
    return m.grep(a, function(a) { return m.inArray(a, b) >= 0 !== c })
  }
  m.filter = function(a, b, c) { var d = b[0]; return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? m.find.matchesSelector(d, a) ? [d] : [] : m.find.matches(a, m.grep(b, function(a) { return 1 === a.nodeType })) }, m.fn.extend({
    find: function(a) {
      var b, c = [],
        d = this,
        e = d.length;
      if ("string" != typeof a) return this.pushStack(m(a).filter(function() {
        for (b = 0; e > b; b++)
          if (m.contains(d[b], this)) return !0
      }));
      for (b = 0; e > b; b++) m.find(a, d[b], c);
      return c = this.pushStack(e > 1 ? m.unique(c) : c), c.selector = this.selector ? this.selector + " " + a : a, c
    },
    filter: function(a) { return this.pushStack(w(this, a || [], !1)) },
    not: function(a) { return this.pushStack(w(this, a || [], !0)) },
    is: function(a) { return !!w(this, "string" == typeof a && t.test(a) ? m(a) : a || [], !1).length }
  });
  var x, y = a.document,
    z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
    A = m.fn.init = function(a, b) {
      var c, d;
      if (!a) return this;
      if ("string" == typeof a) {
        if (c = "<" === a.charAt(0) && ">" === a.charAt(a.length - 1) && a.length >= 3 ? [null, a, null] : z.exec(a), !c || !c[1] && b) return !b || b.jquery ? (b || x).find(a) : this.constructor(b).find(a);
        if (c[1]) {
          if (b = b instanceof m ? b[0] : b, m.merge(this, m.parseHTML(c[1], b && b.nodeType ? b.ownerDocument || b : y, !0)), u.test(c[1]) && m.isPlainObject(b))
            for (c in b) m.isFunction(this[c]) ? this[c](b[c]) : this.attr(c, b[c]);
          return this
        }
        if (d = y.getElementById(c[2]), d && d.parentNode) {
          if (d.id !== c[2]) return x.find(a);
          this.length = 1, this[0] = d
        }
        return this.context = y, this.selector = a, this
      }
      return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : m.isFunction(a) ? "undefined" != typeof x.ready ? x.ready(a) : a(m) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), m.makeArray(a, this))
    };
  A.prototype = m.fn, x = m(y);
  var B = /^(?:parents|prev(?:Until|All))/,
    C = { children: !0, contents: !0, next: !0, prev: !0 };
  m.extend({
    dir: function(a, b, c) {
      var d = [],
        e = a[b];
      while (e && 9 !== e.nodeType && (void 0 === c || 1 !== e.nodeType || !m(e).is(c))) 1 === e.nodeType && d.push(e), e = e[b];
      return d
    },
    sibling: function(a, b) { for (var c = []; a; a = a.nextSibling) 1 === a.nodeType && a !== b && c.push(a); return c }
  }), m.fn.extend({
    has: function(a) {
      var b, c = m(a, this),
        d = c.length;
      return this.filter(function() {
        for (b = 0; d > b; b++)
          if (m.contains(this, c[b])) return !0
      })
    },
    closest: function(a, b) {
      for (var c, d = 0, e = this.length, f = [], g = t.test(a) || "string" != typeof a ? m(a, b || this.context) : 0; e > d; d++)
        for (c = this[d]; c && c !== b; c = c.parentNode)
          if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && m.find.matchesSelector(c, a))) { f.push(c); break }
      return this.pushStack(f.length > 1 ? m.unique(f) : f)
    },
    index: function(a) { return a ? "string" == typeof a ? m.inArray(this[0], m(a)) : m.inArray(a.jquery ? a[0] : a, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1 },
    add: function(a, b) { return this.pushStack(m.unique(m.merge(this.get(), m(a, b)))) },
    addBack: function(a) { return this.add(null == a ? this.prevObject : this.prevObject.filter(a)) }
  });

  function D(a, b) { do a = a[b]; while (a && 1 !== a.nodeType); return a } m.each({ parent: function(a) { var b = a.parentNode; return b && 11 !== b.nodeType ? b : null }, parents: function(a) { return m.dir(a, "parentNode") }, parentsUntil: function(a, b, c) { return m.dir(a, "parentNode", c) }, next: function(a) { return D(a, "nextSibling") }, prev: function(a) { return D(a, "previousSibling") }, nextAll: function(a) { return m.dir(a, "nextSibling") }, prevAll: function(a) { return m.dir(a, "previousSibling") }, nextUntil: function(a, b, c) { return m.dir(a, "nextSibling", c) }, prevUntil: function(a, b, c) { return m.dir(a, "previousSibling", c) }, siblings: function(a) { return m.sibling((a.parentNode || {}).firstChild, a) }, children: function(a) { return m.sibling(a.firstChild) }, contents: function(a) { return m.nodeName(a, "iframe") ? a.contentDocument || a.contentWindow.document : m.merge([], a.childNodes) } }, function(a, b) { m.fn[a] = function(c, d) { var e = m.map(this, b, c); return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = m.filter(d, e)), this.length > 1 && (C[a] || (e = m.unique(e)), B.test(a) && (e = e.reverse())), this.pushStack(e) } });
  var E = /\S+/g,
    F = {};

  function G(a) { var b = F[a] = {}; return m.each(a.match(E) || [], function(a, c) { b[c] = !0 }), b } m.Callbacks = function(a) {
    a = "string" == typeof a ? F[a] || G(a) : m.extend({}, a);
    var b, c, d, e, f, g, h = [],
      i = !a.once && [],
      j = function(l) {
        for (c = a.memory && l, d = !0, f = g || 0, g = 0, e = h.length, b = !0; h && e > f; f++)
          if (h[f].apply(l[0], l[1]) === !1 && a.stopOnFalse) { c = !1; break }
        b = !1, h && (i ? i.length && j(i.shift()) : c ? h = [] : k.disable())
      },
      k = { add: function() { if (h) { var d = h.length;! function f(b) { m.each(b, function(b, c) { var d = m.type(c); "function" === d ? a.unique && k.has(c) || h.push(c) : c && c.length && "string" !== d && f(c) }) }(arguments), b ? e = h.length : c && (g = d, j(c)) } return this }, remove: function() { return h && m.each(arguments, function(a, c) { var d; while ((d = m.inArray(c, h, d)) > -1) h.splice(d, 1), b && (e >= d && e--, f >= d && f--) }), this }, has: function(a) { return a ? m.inArray(a, h) > -1 : !(!h || !h.length) }, empty: function() { return h = [], e = 0, this }, disable: function() { return h = i = c = void 0, this }, disabled: function() { return !h }, lock: function() { return i = void 0, c || k.disable(), this }, locked: function() { return !i }, fireWith: function(a, c) { return !h || d && !i || (c = c || [], c = [a, c.slice ? c.slice() : c], b ? i.push(c) : j(c)), this }, fire: function() { return k.fireWith(this, arguments), this }, fired: function() { return !!d } };
    return k
  }, m.extend({
    Deferred: function(a) {
      var b = [
          ["resolve", "done", m.Callbacks("once memory"), "resolved"],
          ["reject", "fail", m.Callbacks("once memory"), "rejected"],
          ["notify", "progress", m.Callbacks("memory")]
        ],
        c = "pending",
        d = {
          state: function() { return c },
          always: function() { return e.done(arguments).fail(arguments), this },
          then: function() {
            var a = arguments;
            return m.Deferred(function(c) {
              m.each(b, function(b, f) {
                var g = m.isFunction(a[b]) && a[b];
                e[f[1]](function() {
                  var a = g && g.apply(this, arguments);
                  a && m.isFunction(a.promise) ? a.promise().done(c.resolve).fail(c.reject).progress(c.notify) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments)
                })
              }), a = null
            }).promise()
          },
          promise: function(a) { return null != a ? m.extend(a, d) : d }
        },
        e = {};
      return d.pipe = d.then, m.each(b, function(a, f) {
        var g = f[2],
          h = f[3];
        d[f[1]] = g.add, h && g.add(function() { c = h }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function() { return e[f[0] + "With"](this === e ? d : this, arguments), this }, e[f[0] + "With"] = g.fireWith
      }), d.promise(e), a && a.call(e, e), e
    },
    when: function(a) {
      var b = 0,
        c = d.call(arguments),
        e = c.length,
        f = 1 !== e || a && m.isFunction(a.promise) ? e : 0,
        g = 1 === f ? a : m.Deferred(),
        h = function(a, b, c) { return function(e) { b[a] = this, c[a] = arguments.length > 1 ? d.call(arguments) : e, c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c) } },
        i, j, k;
      if (e > 1)
        for (i = new Array(e), j = new Array(e), k = new Array(e); e > b; b++) c[b] && m.isFunction(c[b].promise) ? c[b].promise().done(h(b, k, c)).fail(g.reject).progress(h(b, j, i)) : --f;
      return f || g.resolveWith(k, c), g.promise()
    }
  });
  var H;
  m.fn.ready = function(a) { return m.ready.promise().done(a), this }, m.extend({
    isReady: !1,
    readyWait: 1,
    holdReady: function(a) { a ? m.readyWait++ : m.ready(!0) },
    ready: function(a) {
      if (a === !0 ? !--m.readyWait : !m.isReady) {
        if (!y.body) return setTimeout(m.ready);
        m.isReady = !0, a !== !0 && --m.readyWait > 0 || (H.resolveWith(y, [m]), m.fn.triggerHandler && (m(y).triggerHandler("ready"), m(y).off("ready")))
      }
    }
  });

  function I() { y.addEventListener ? (y.removeEventListener("DOMContentLoaded", J, !1), a.removeEventListener("load", J, !1)) : (y.detachEvent("onreadystatechange", J), a.detachEvent("onload", J)) }

  function J() {
    (y.addEventListener || "load" === event.type || "complete" === y.readyState) && (I(), m.ready())
  }
  m.ready.promise = function(b) {
    if (!H)
      if (H = m.Deferred(), "complete" === y.readyState) setTimeout(m.ready);
      else if (y.addEventListener) y.addEventListener("DOMContentLoaded", J, !1), a.addEventListener("load", J, !1);
    else { y.attachEvent("onreadystatechange", J), a.attachEvent("onload", J); var c = !1; try { c = null == a.frameElement && y.documentElement } catch (d) {} c && c.doScroll && ! function e() { if (!m.isReady) { try { c.doScroll("left") } catch (a) { return setTimeout(e, 50) } I(), m.ready() } }() }
    return H.promise(b)
  };
  var K = "undefined",
    L;
  for (L in m(k)) break;
  k.ownLast = "0" !== L, k.inlineBlockNeedsLayout = !1, m(function() {
      var a, b, c, d;
      c = y.getElementsByTagName("body")[0], c && c.style && (b = y.createElement("div"), d = y.createElement("div"), d.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", c.appendChild(d).appendChild(b), typeof b.style.zoom !== K && (b.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", k.inlineBlockNeedsLayout = a = 3 === b.offsetWidth, a && (c.style.zoom = 1)), c.removeChild(d))
    }),
    function() { var a = y.createElement("div"); if (null == k.deleteExpando) { k.deleteExpando = !0; try { delete a.test } catch (b) { k.deleteExpando = !1 } } a = null }(), m.acceptData = function(a) {
      var b = m.noData[(a.nodeName + " ").toLowerCase()],
        c = +a.nodeType || 1;
      return 1 !== c && 9 !== c ? !1 : !b || b !== !0 && a.getAttribute("classid") === b
    };
  var M = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    N = /([A-Z])/g;

  function O(a, b, c) { if (void 0 === c && 1 === a.nodeType) { var d = "data-" + b.replace(N, "-$1").toLowerCase(); if (c = a.getAttribute(d), "string" == typeof c) { try { c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : M.test(c) ? m.parseJSON(c) : c } catch (e) {} m.data(a, b, c) } else c = void 0 } return c }

  function P(a) {
    var b;
    for (b in a)
      if (("data" !== b || !m.isEmptyObject(a[b])) && "toJSON" !== b) return !1;
    return !0
  }

  function Q(a, b, d, e) {
    if (m.acceptData(a)) {
      var f, g, h = m.expando,
        i = a.nodeType,
        j = i ? m.cache : a,
        k = i ? a[h] : a[h] && h;
      if (k && j[k] && (e || j[k].data) || void 0 !== d || "string" != typeof b) return k || (k = i ? a[h] = c.pop() || m.guid++ : h), j[k] || (j[k] = i ? {} : { toJSON: m.noop }), ("object" == typeof b || "function" == typeof b) && (e ? j[k] = m.extend(j[k], b) : j[k].data = m.extend(j[k].data, b)), g = j[k], e || (g.data || (g.data = {}), g = g.data), void 0 !== d && (g[m.camelCase(b)] = d), "string" == typeof b ? (f = g[b], null == f && (f = g[m.camelCase(b)])) : f = g, f
    }
  }

  function R(a, b, c) {
    if (m.acceptData(a)) {
      var d, e, f = a.nodeType,
        g = f ? m.cache : a,
        h = f ? a[m.expando] : m.expando;
      if (g[h]) { if (b && (d = c ? g[h] : g[h].data)) { m.isArray(b) ? b = b.concat(m.map(b, m.camelCase)) : b in d ? b = [b] : (b = m.camelCase(b), b = b in d ? [b] : b.split(" ")), e = b.length; while (e--) delete d[b[e]]; if (c ? !P(d) : !m.isEmptyObject(d)) return }(c || (delete g[h].data, P(g[h]))) && (f ? m.cleanData([a], !0) : k.deleteExpando || g != g.window ? delete g[h] : g[h] = null) }
    }
  }
  m.extend({ cache: {}, noData: { "applet ": !0, "embed ": !0, "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" }, hasData: function(a) { return a = a.nodeType ? m.cache[a[m.expando]] : a[m.expando], !!a && !P(a) }, data: function(a, b, c) { return Q(a, b, c) }, removeData: function(a, b) { return R(a, b) }, _data: function(a, b, c) { return Q(a, b, c, !0) }, _removeData: function(a, b) { return R(a, b, !0) } }), m.fn.extend({
    data: function(a, b) {
      var c, d, e, f = this[0],
        g = f && f.attributes;
      if (void 0 === a) {
        if (this.length && (e = m.data(f), 1 === f.nodeType && !m._data(f, "parsedAttrs"))) {
          c = g.length;
          while (c--) g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = m.camelCase(d.slice(5)), O(f, d, e[d])));
          m._data(f, "parsedAttrs", !0)
        }
        return e
      }
      return "object" == typeof a ? this.each(function() { m.data(this, a) }) : arguments.length > 1 ? this.each(function() { m.data(this, a, b) }) : f ? O(f, a, m.data(f, a)) : void 0
    },
    removeData: function(a) { return this.each(function() { m.removeData(this, a) }) }
  }), m.extend({
    queue: function(a, b, c) { var d; return a ? (b = (b || "fx") + "queue", d = m._data(a, b), c && (!d || m.isArray(c) ? d = m._data(a, b, m.makeArray(c)) : d.push(c)), d || []) : void 0 },
    dequeue: function(a, b) {
      b = b || "fx";
      var c = m.queue(a, b),
        d = c.length,
        e = c.shift(),
        f = m._queueHooks(a, b),
        g = function() { m.dequeue(a, b) };
      "inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire()
    },
    _queueHooks: function(a, b) { var c = b + "queueHooks"; return m._data(a, c) || m._data(a, c, { empty: m.Callbacks("once memory").add(function() { m._removeData(a, b + "queue"), m._removeData(a, c) }) }) }
  }), m.fn.extend({
    queue: function(a, b) {
      var c = 2;
      return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? m.queue(this[0], a) : void 0 === b ? this : this.each(function() {
        var c = m.queue(this, a, b);
        m._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && m.dequeue(this, a)
      })
    },
    dequeue: function(a) { return this.each(function() { m.dequeue(this, a) }) },
    clearQueue: function(a) { return this.queue(a || "fx", []) },
    promise: function(a, b) {
      var c, d = 1,
        e = m.Deferred(),
        f = this,
        g = this.length,
        h = function() {--d || e.resolveWith(f, [f]) };
      "string" != typeof a && (b = a, a = void 0), a = a || "fx";
      while (g--) c = m._data(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
      return h(), e.promise(b)
    }
  });
  var S = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    T = ["Top", "Right", "Bottom", "Left"],
    U = function(a, b) { return a = b || a, "none" === m.css(a, "display") || !m.contains(a.ownerDocument, a) },
    V = m.access = function(a, b, c, d, e, f, g) {
      var h = 0,
        i = a.length,
        j = null == c;
      if ("object" === m.type(c)) { e = !0; for (h in c) m.access(a, b, h, c[h], !0, f, g) } else if (void 0 !== d && (e = !0, m.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function(a, b, c) { return j.call(m(a), c) })), b))
        for (; i > h; h++) b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
      return e ? a : j ? b.call(a) : i ? b(a[0], c) : f
    },
    W = /^(?:checkbox|radio)$/i;
  ! function() {
    var a = y.createElement("input"),
      b = y.createElement("div"),
      c = y.createDocumentFragment();
    if (b.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", k.leadingWhitespace = 3 === b.firstChild.nodeType, k.tbody = !b.getElementsByTagName("tbody").length, k.htmlSerialize = !!b.getElementsByTagName("link").length, k.html5Clone = "<:nav></:nav>" !== y.createElement("nav").cloneNode(!0).outerHTML, a.type = "checkbox", a.checked = !0, c.appendChild(a), k.appendChecked = a.checked, b.innerHTML = "<textarea>x</textarea>", k.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue, c.appendChild(b), b.innerHTML = "<input type='radio' checked='checked' name='t'/>", k.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, k.noCloneEvent = !0, b.attachEvent && (b.attachEvent("onclick", function() { k.noCloneEvent = !1 }), b.cloneNode(!0).click()), null == k.deleteExpando) { k.deleteExpando = !0; try { delete b.test } catch (d) { k.deleteExpando = !1 } }
  }(),
  function() {
    var b, c, d = y.createElement("div");
    for (b in { submit: !0, change: !0, focusin: !0 }) c = "on" + b, (k[b + "Bubbles"] = c in a) || (d.setAttribute(c, "t"), k[b + "Bubbles"] = d.attributes[c].expando === !1);
    d = null
  }();
  var X = /^(?:input|select|textarea)$/i,
    Y = /^key/,
    Z = /^(?:mouse|pointer|contextmenu)|click/,
    $ = /^(?:focusinfocus|focusoutblur)$/,
    _ = /^([^.]*)(?:\.(.+)|)$/;

  function ab() { return !0 }

  function bb() { return !1 }

  function cb() { try { return y.activeElement } catch (a) {} } m.event = {
    global: {},
    add: function(a, b, c, d, e) {
      var f, g, h, i, j, k, l, n, o, p, q, r = m._data(a);
      if (r) {
        c.handler && (i = c, c = i.handler, e = i.selector), c.guid || (c.guid = m.guid++), (g = r.events) || (g = r.events = {}), (k = r.handle) || (k = r.handle = function(a) { return typeof m === K || a && m.event.triggered === a.type ? void 0 : m.event.dispatch.apply(k.elem, arguments) }, k.elem = a), b = (b || "").match(E) || [""], h = b.length;
        while (h--) f = _.exec(b[h]) || [], o = q = f[1], p = (f[2] || "").split(".").sort(), o && (j = m.event.special[o] || {}, o = (e ? j.delegateType : j.bindType) || o, j = m.event.special[o] || {}, l = m.extend({ type: o, origType: q, data: d, handler: c, guid: c.guid, selector: e, needsContext: e && m.expr.match.needsContext.test(e), namespace: p.join(".") }, i), (n = g[o]) || (n = g[o] = [], n.delegateCount = 0, j.setup && j.setup.call(a, d, p, k) !== !1 || (a.addEventListener ? a.addEventListener(o, k, !1) : a.attachEvent && a.attachEvent("on" + o, k))), j.add && (j.add.call(a, l), l.handler.guid || (l.handler.guid = c.guid)), e ? n.splice(n.delegateCount++, 0, l) : n.push(l), m.event.global[o] = !0);
        a = null
      }
    },
    remove: function(a, b, c, d, e) {
      var f, g, h, i, j, k, l, n, o, p, q, r = m.hasData(a) && m._data(a);
      if (r && (k = r.events)) {
        b = (b || "").match(E) || [""], j = b.length;
        while (j--)
          if (h = _.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o) {
            l = m.event.special[o] || {}, o = (d ? l.delegateType : l.bindType) || o, n = k[o] || [], h = h[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), i = f = n.length;
            while (f--) g = n[f], !e && q !== g.origType || c && c.guid !== g.guid || h && !h.test(g.namespace) || d && d !== g.selector && ("**" !== d || !g.selector) || (n.splice(f, 1), g.selector && n.delegateCount--, l.remove && l.remove.call(a, g));
            i && !n.length && (l.teardown && l.teardown.call(a, p, r.handle) !== !1 || m.removeEvent(a, o, r.handle), delete k[o])
          } else
            for (o in k) m.event.remove(a, o + b[j], c, d, !0);
        m.isEmptyObject(k) && (delete r.handle, m._removeData(a, "events"))
      }
    },
    trigger: function(b, c, d, e) {
      var f, g, h, i, k, l, n, o = [d || y],
        p = j.call(b, "type") ? b.type : b,
        q = j.call(b, "namespace") ? b.namespace.split(".") : [];
      if (h = l = d = d || y, 3 !== d.nodeType && 8 !== d.nodeType && !$.test(p + m.event.triggered) && (p.indexOf(".") >= 0 && (q = p.split("."), p = q.shift(), q.sort()), g = p.indexOf(":") < 0 && "on" + p, b = b[m.expando] ? b : new m.Event(p, "object" == typeof b && b), b.isTrigger = e ? 2 : 3, b.namespace = q.join("."), b.namespace_re = b.namespace ? new RegExp("(^|\\.)" + q.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = d), c = null == c ? [b] : m.makeArray(c, [b]), k = m.event.special[p] || {}, e || !k.trigger || k.trigger.apply(d, c) !== !1)) {
        if (!e && !k.noBubble && !m.isWindow(d)) {
          for (i = k.delegateType || p, $.test(i + p) || (h = h.parentNode); h; h = h.parentNode) o.push(h), l = h;
          l === (d.ownerDocument || y) && o.push(l.defaultView || l.parentWindow || a)
        }
        n = 0;
        while ((h = o[n++]) && !b.isPropagationStopped()) b.type = n > 1 ? i : k.bindType || p, f = (m._data(h, "events") || {})[b.type] && m._data(h, "handle"), f && f.apply(h, c), f = g && h[g], f && f.apply && m.acceptData(h) && (b.result = f.apply(h, c), b.result === !1 && b.preventDefault());
        if (b.type = p, !e && !b.isDefaultPrevented() && (!k._default || k._default.apply(o.pop(), c) === !1) && m.acceptData(d) && g && d[p] && !m.isWindow(d)) { l = d[g], l && (d[g] = null), m.event.triggered = p; try { d[p]() } catch (r) {} m.event.triggered = void 0, l && (d[g] = l) }
        return b.result
      }
    },
    dispatch: function(a) {
      a = m.event.fix(a);
      var b, c, e, f, g, h = [],
        i = d.call(arguments),
        j = (m._data(this, "events") || {})[a.type] || [],
        k = m.event.special[a.type] || {};
      if (i[0] = a, a.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, a) !== !1) { h = m.event.handlers.call(this, a, j), b = 0; while ((f = h[b++]) && !a.isPropagationStopped()) { a.currentTarget = f.elem, g = 0; while ((e = f.handlers[g++]) && !a.isImmediatePropagationStopped())(!a.namespace_re || a.namespace_re.test(e.namespace)) && (a.handleObj = e, a.data = e.data, c = ((m.event.special[e.origType] || {}).handle || e.handler).apply(f.elem, i), void 0 !== c && (a.result = c) === !1 && (a.preventDefault(), a.stopPropagation())) } return k.postDispatch && k.postDispatch.call(this, a), a.result }
    },
    handlers: function(a, b) {
      var c, d, e, f, g = [],
        h = b.delegateCount,
        i = a.target;
      if (h && i.nodeType && (!a.button || "click" !== a.type))
        for (; i != this; i = i.parentNode || this)
          if (1 === i.nodeType && (i.disabled !== !0 || "click" !== a.type)) {
            for (e = [], f = 0; h > f; f++) d = b[f], c = d.selector + " ", void 0 === e[c] && (e[c] = d.needsContext ? m(c, this).index(i) >= 0 : m.find(c, this, null, [i]).length), e[c] && e.push(d);
            e.length && g.push({ elem: i, handlers: e })
          }
      return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g
    },
    fix: function(a) {
      if (a[m.expando]) return a;
      var b, c, d, e = a.type,
        f = a,
        g = this.fixHooks[e];
      g || (this.fixHooks[e] = g = Z.test(e) ? this.mouseHooks : Y.test(e) ? this.keyHooks : {}), d = g.props ? this.props.concat(g.props) : this.props, a = new m.Event(f), b = d.length;
      while (b--) c = d[b], a[c] = f[c];
      return a.target || (a.target = f.srcElement || y), 3 === a.target.nodeType && (a.target = a.target.parentNode), a.metaKey = !!a.metaKey, g.filter ? g.filter(a, f) : a
    },
    props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
    fixHooks: {},
    keyHooks: { props: "char charCode key keyCode".split(" "), filter: function(a, b) { return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a } },
    mouseHooks: {
      props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
      filter: function(a, b) {
        var c, d, e, f = b.button,
          g = b.fromElement;
        return null == a.pageX && null != b.clientX && (d = a.target.ownerDocument || y, e = d.documentElement, c = d.body, a.pageX = b.clientX + (e && e.scrollLeft || c && c.scrollLeft || 0) - (e && e.clientLeft || c && c.clientLeft || 0), a.pageY = b.clientY + (e && e.scrollTop || c && c.scrollTop || 0) - (e && e.clientTop || c && c.clientTop || 0)), !a.relatedTarget && g && (a.relatedTarget = g === a.target ? b.toElement : g), a.which || void 0 === f || (a.which = 1 & f ? 1 : 2 & f ? 3 : 4 & f ? 2 : 0), a
      }
    },
    special: { load: { noBubble: !0 }, focus: { trigger: function() { if (this !== cb() && this.focus) try { return this.focus(), !1 } catch (a) {} }, delegateType: "focusin" }, blur: { trigger: function() { return this === cb() && this.blur ? (this.blur(), !1) : void 0 }, delegateType: "focusout" }, click: { trigger: function() { return m.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0 }, _default: function(a) { return m.nodeName(a.target, "a") } }, beforeunload: { postDispatch: function(a) { void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result) } } },
    simulate: function(a, b, c, d) {
      var e = m.extend(new m.Event, c, { type: a, isSimulated: !0, originalEvent: {} });
      d ? m.event.trigger(e, null, b) : m.event.dispatch.call(b, e), e.isDefaultPrevented() && c.preventDefault()
    }
  }, m.removeEvent = y.removeEventListener ? function(a, b, c) { a.removeEventListener && a.removeEventListener(b, c, !1) } : function(a, b, c) {
    var d = "on" + b;
    a.detachEvent && (typeof a[d] === K && (a[d] = null), a.detachEvent(d, c))
  }, m.Event = function(a, b) { return this instanceof m.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? ab : bb) : this.type = a, b && m.extend(this, b), this.timeStamp = a && a.timeStamp || m.now(), void(this[m.expando] = !0)) : new m.Event(a, b) }, m.Event.prototype = {
    isDefaultPrevented: bb,
    isPropagationStopped: bb,
    isImmediatePropagationStopped: bb,
    preventDefault: function() {
      var a = this.originalEvent;
      this.isDefaultPrevented = ab, a && (a.preventDefault ? a.preventDefault() : a.returnValue = !1)
    },
    stopPropagation: function() {
      var a = this.originalEvent;
      this.isPropagationStopped = ab, a && (a.stopPropagation && a.stopPropagation(), a.cancelBubble = !0)
    },
    stopImmediatePropagation: function() {
      var a = this.originalEvent;
      this.isImmediatePropagationStopped = ab, a && a.stopImmediatePropagation && a.stopImmediatePropagation(), this.stopPropagation()
    }
  }, m.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function(a, b) {
    m.event.special[a] = {
      delegateType: b,
      bindType: b,
      handle: function(a) {
        var c, d = this,
          e = a.relatedTarget,
          f = a.handleObj;
        return (!e || e !== d && !m.contains(d, e)) && (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c
      }
    }
  }), k.submitBubbles || (m.event.special.submit = {
    setup: function() {
      return m.nodeName(this, "form") ? !1 : void m.event.add(this, "click._submit keypress._submit", function(a) {
        var b = a.target,
          c = m.nodeName(b, "input") || m.nodeName(b, "button") ? b.form : void 0;
        c && !m._data(c, "submitBubbles") && (m.event.add(c, "submit._submit", function(a) { a._submit_bubble = !0 }), m._data(c, "submitBubbles", !0))
      })
    },
    postDispatch: function(a) { a._submit_bubble && (delete a._submit_bubble, this.parentNode && !a.isTrigger && m.event.simulate("submit", this.parentNode, a, !0)) },
    teardown: function() { return m.nodeName(this, "form") ? !1 : void m.event.remove(this, "._submit") }
  }), k.changeBubbles || (m.event.special.change = {
    setup: function() {
      return X.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (m.event.add(this, "propertychange._change", function(a) { "checked" === a.originalEvent.propertyName && (this._just_changed = !0) }), m.event.add(this, "click._change", function(a) { this._just_changed && !a.isTrigger && (this._just_changed = !1), m.event.simulate("change", this, a, !0) })), !1) : void m.event.add(this, "beforeactivate._change", function(a) {
        var b = a.target;
        X.test(b.nodeName) && !m._data(b, "changeBubbles") && (m.event.add(b, "change._change", function(a) {!this.parentNode || a.isSimulated || a.isTrigger || m.event.simulate("change", this.parentNode, a, !0) }), m._data(b, "changeBubbles", !0))
      })
    },
    handle: function(a) { var b = a.target; return this !== b || a.isSimulated || a.isTrigger || "radio" !== b.type && "checkbox" !== b.type ? a.handleObj.handler.apply(this, arguments) : void 0 },
    teardown: function() { return m.event.remove(this, "._change"), !X.test(this.nodeName) }
  }), k.focusinBubbles || m.each({ focus: "focusin", blur: "focusout" }, function(a, b) {
    var c = function(a) { m.event.simulate(b, a.target, m.event.fix(a), !0) };
    m.event.special[b] = {
      setup: function() {
        var d = this.ownerDocument || this,
          e = m._data(d, b);
        e || d.addEventListener(a, c, !0), m._data(d, b, (e || 0) + 1)
      },
      teardown: function() {
        var d = this.ownerDocument || this,
          e = m._data(d, b) - 1;
        e ? m._data(d, b, e) : (d.removeEventListener(a, c, !0), m._removeData(d, b))
      }
    }
  }), m.fn.extend({
    on: function(a, b, c, d, e) {
      var f, g;
      if ("object" == typeof a) { "string" != typeof b && (c = c || b, b = void 0); for (f in a) this.on(f, b, c, a[f], e); return this }
      if (null == c && null == d ? (d = b, c = b = void 0) : null == d && ("string" == typeof b ? (d = c, c = void 0) : (d = c, c = b, b = void 0)), d === !1) d = bb;
      else if (!d) return this;
      return 1 === e && (g = d, d = function(a) { return m().off(a), g.apply(this, arguments) }, d.guid = g.guid || (g.guid = m.guid++)), this.each(function() { m.event.add(this, a, d, c, b) })
    },
    one: function(a, b, c, d) { return this.on(a, b, c, d, 1) },
    off: function(a, b, c) { var d, e; if (a && a.preventDefault && a.handleObj) return d = a.handleObj, m(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this; if ("object" == typeof a) { for (e in a) this.off(e, b, a[e]); return this } return (b === !1 || "function" == typeof b) && (c = b, b = void 0), c === !1 && (c = bb), this.each(function() { m.event.remove(this, a, c, b) }) },
    trigger: function(a, b) { return this.each(function() { m.event.trigger(a, b, this) }) },
    triggerHandler: function(a, b) { var c = this[0]; return c ? m.event.trigger(a, b, c, !0) : void 0 }
  });

  function db(a) {
    var b = eb.split("|"),
      c = a.createDocumentFragment();
    if (c.createElement)
      while (b.length) c.createElement(b.pop());
    return c
  }
  var eb = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
    fb = / jQuery\d+="(?:null|\d+)"/g,
    gb = new RegExp("<(?:" + eb + ")[\\s/>]", "i"),
    hb = /^\s+/,
    ib = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
    jb = /<([\w:]+)/,
    kb = /<tbody/i,
    lb = /<|&#?\w+;/,
    mb = /<(?:script|style|link)/i,
    nb = /checked\s*(?:[^=]|=\s*.checked.)/i,
    ob = /^$|\/(?:java|ecma)script/i,
    pb = /^true\/(.*)/,
    qb = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
    rb = { option: [1, "<select multiple='multiple'>", "</select>"], legend: [1, "<fieldset>", "</fieldset>"], area: [1, "<map>", "</map>"], param: [1, "<object>", "</object>"], thead: [1, "<table>", "</table>"], tr: [2, "<table><tbody>", "</tbody></table>"], col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: k.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"] },
    sb = db(y),
    tb = sb.appendChild(y.createElement("div"));
  rb.optgroup = rb.option, rb.tbody = rb.tfoot = rb.colgroup = rb.caption = rb.thead, rb.th = rb.td;

  function ub(a, b) {
    var c, d, e = 0,
      f = typeof a.getElementsByTagName !== K ? a.getElementsByTagName(b || "*") : typeof a.querySelectorAll !== K ? a.querySelectorAll(b || "*") : void 0;
    if (!f)
      for (f = [], c = a.childNodes || a; null != (d = c[e]); e++) !b || m.nodeName(d, b) ? f.push(d) : m.merge(f, ub(d, b));
    return void 0 === b || b && m.nodeName(a, b) ? m.merge([a], f) : f
  }

  function vb(a) { W.test(a.type) && (a.defaultChecked = a.checked) }

  function wb(a, b) { return m.nodeName(a, "table") && m.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a }

  function xb(a) { return a.type = (null !== m.find.attr(a, "type")) + "/" + a.type, a }

  function yb(a) { var b = pb.exec(a.type); return b ? a.type = b[1] : a.removeAttribute("type"), a }

  function zb(a, b) { for (var c, d = 0; null != (c = a[d]); d++) m._data(c, "globalEval", !b || m._data(b[d], "globalEval")) }

  function Ab(a, b) {
    if (1 === b.nodeType && m.hasData(a)) {
      var c, d, e, f = m._data(a),
        g = m._data(b, f),
        h = f.events;
      if (h) {
        delete g.handle, g.events = {};
        for (c in h)
          for (d = 0, e = h[c].length; e > d; d++) m.event.add(b, c, h[c][d])
      }
      g.data && (g.data = m.extend({}, g.data))
    }
  }

  function Bb(a, b) {
    var c, d, e;
    if (1 === b.nodeType) {
      if (c = b.nodeName.toLowerCase(), !k.noCloneEvent && b[m.expando]) {
        e = m._data(b);
        for (d in e.events) m.removeEvent(b, d, e.handle);
        b.removeAttribute(m.expando)
      }
      "script" === c && b.text !== a.text ? (xb(b).text = a.text, yb(b)) : "object" === c ? (b.parentNode && (b.outerHTML = a.outerHTML), k.html5Clone && a.innerHTML && !m.trim(b.innerHTML) && (b.innerHTML = a.innerHTML)) : "input" === c && W.test(a.type) ? (b.defaultChecked = b.checked = a.checked, b.value !== a.value && (b.value = a.value)) : "option" === c ? b.defaultSelected = b.selected = a.defaultSelected : ("input" === c || "textarea" === c) && (b.defaultValue = a.defaultValue)
    }
  }
  m.extend({
    clone: function(a, b, c) {
      var d, e, f, g, h, i = m.contains(a.ownerDocument, a);
      if (k.html5Clone || m.isXMLDoc(a) || !gb.test("<" + a.nodeName + ">") ? f = a.cloneNode(!0) : (tb.innerHTML = a.outerHTML, tb.removeChild(f = tb.firstChild)), !(k.noCloneEvent && k.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || m.isXMLDoc(a)))
        for (d = ub(f), h = ub(a), g = 0; null != (e = h[g]); ++g) d[g] && Bb(e, d[g]);
      if (b)
        if (c)
          for (h = h || ub(a), d = d || ub(f), g = 0; null != (e = h[g]); g++) Ab(e, d[g]);
        else Ab(a, f);
      return d = ub(f, "script"), d.length > 0 && zb(d, !i && ub(a, "script")), d = h = e = null, f
    },
    buildFragment: function(a, b, c, d) {
      for (var e, f, g, h, i, j, l, n = a.length, o = db(b), p = [], q = 0; n > q; q++)
        if (f = a[q], f || 0 === f)
          if ("object" === m.type(f)) m.merge(p, f.nodeType ? [f] : f);
          else if (lb.test(f)) {
        h = h || o.appendChild(b.createElement("div")), i = (jb.exec(f) || ["", ""])[1].toLowerCase(), l = rb[i] || rb._default, h.innerHTML = l[1] + f.replace(ib, "<$1></$2>") + l[2], e = l[0];
        while (e--) h = h.lastChild;
        if (!k.leadingWhitespace && hb.test(f) && p.push(b.createTextNode(hb.exec(f)[0])), !k.tbody) { f = "table" !== i || kb.test(f) ? "<table>" !== l[1] || kb.test(f) ? 0 : h : h.firstChild, e = f && f.childNodes.length; while (e--) m.nodeName(j = f.childNodes[e], "tbody") && !j.childNodes.length && f.removeChild(j) } m.merge(p, h.childNodes), h.textContent = "";
        while (h.firstChild) h.removeChild(h.firstChild);
        h = o.lastChild
      } else p.push(b.createTextNode(f));
      h && o.removeChild(h), k.appendChecked || m.grep(ub(p, "input"), vb), q = 0;
      while (f = p[q++])
        if ((!d || -1 === m.inArray(f, d)) && (g = m.contains(f.ownerDocument, f), h = ub(o.appendChild(f), "script"), g && zb(h), c)) { e = 0; while (f = h[e++]) ob.test(f.type || "") && c.push(f) }
      return h = null, o
    },
    cleanData: function(a, b) {
      for (var d, e, f, g, h = 0, i = m.expando, j = m.cache, l = k.deleteExpando, n = m.event.special; null != (d = a[h]); h++)
        if ((b || m.acceptData(d)) && (f = d[i], g = f && j[f])) {
          if (g.events)
            for (e in g.events) n[e] ? m.event.remove(d, e) : m.removeEvent(d, e, g.handle);
          j[f] && (delete j[f], l ? delete d[i] : typeof d.removeAttribute !== K ? d.removeAttribute(i) : d[i] = null, c.push(f))
        }
    }
  }), m.fn.extend({
    text: function(a) { return V(this, function(a) { return void 0 === a ? m.text(this) : this.empty().append((this[0] && this[0].ownerDocument || y).createTextNode(a)) }, null, a, arguments.length) },
    append: function() {
      return this.domManip(arguments, function(a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = wb(this, a);
          b.appendChild(a)
        }
      })
    },
    prepend: function() {
      return this.domManip(arguments, function(a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = wb(this, a);
          b.insertBefore(a, b.firstChild)
        }
      })
    },
    before: function() { return this.domManip(arguments, function(a) { this.parentNode && this.parentNode.insertBefore(a, this) }) },
    after: function() { return this.domManip(arguments, function(a) { this.parentNode && this.parentNode.insertBefore(a, this.nextSibling) }) },
    remove: function(a, b) { for (var c, d = a ? m.filter(a, this) : this, e = 0; null != (c = d[e]); e++) b || 1 !== c.nodeType || m.cleanData(ub(c)), c.parentNode && (b && m.contains(c.ownerDocument, c) && zb(ub(c, "script")), c.parentNode.removeChild(c)); return this },
    empty: function() {
      for (var a, b = 0; null != (a = this[b]); b++) {
        1 === a.nodeType && m.cleanData(ub(a, !1));
        while (a.firstChild) a.removeChild(a.firstChild);
        a.options && m.nodeName(a, "select") && (a.options.length = 0)
      }
      return this
    },
    clone: function(a, b) { return a = null == a ? !1 : a, b = null == b ? a : b, this.map(function() { return m.clone(this, a, b) }) },
    html: function(a) {
      return V(this, function(a) {
        var b = this[0] || {},
          c = 0,
          d = this.length;
        if (void 0 === a) return 1 === b.nodeType ? b.innerHTML.replace(fb, "") : void 0;
        if (!("string" != typeof a || mb.test(a) || !k.htmlSerialize && gb.test(a) || !k.leadingWhitespace && hb.test(a) || rb[(jb.exec(a) || ["", ""])[1].toLowerCase()])) {
          a = a.replace(ib, "<$1></$2>");
          try {
            for (; d > c; c++) b = this[c] || {}, 1 === b.nodeType && (m.cleanData(ub(b, !1)), b.innerHTML = a);
            b = 0
          } catch (e) {}
        }
        b && this.empty().append(a)
      }, null, a, arguments.length)
    },
    replaceWith: function() { var a = arguments[0]; return this.domManip(arguments, function(b) { a = this.parentNode, m.cleanData(ub(this)), a && a.replaceChild(b, this) }), a && (a.length || a.nodeType) ? this : this.remove() },
    detach: function(a) { return this.remove(a, !0) },
    domManip: function(a, b) {
      a = e.apply([], a);
      var c, d, f, g, h, i, j = 0,
        l = this.length,
        n = this,
        o = l - 1,
        p = a[0],
        q = m.isFunction(p);
      if (q || l > 1 && "string" == typeof p && !k.checkClone && nb.test(p)) return this.each(function(c) {
        var d = n.eq(c);
        q && (a[0] = p.call(this, c, d.html())), d.domManip(a, b)
      });
      if (l && (i = m.buildFragment(a, this[0].ownerDocument, !1, this), c = i.firstChild, 1 === i.childNodes.length && (i = c), c)) {
        for (g = m.map(ub(i, "script"), xb), f = g.length; l > j; j++) d = i, j !== o && (d = m.clone(d, !0, !0), f && m.merge(g, ub(d, "script"))), b.call(this[j], d, j);
        if (f)
          for (h = g[g.length - 1].ownerDocument, m.map(g, yb), j = 0; f > j; j++) d = g[j], ob.test(d.type || "") && !m._data(d, "globalEval") && m.contains(h, d) && (d.src ? m._evalUrl && m._evalUrl(d.src) : m.globalEval((d.text || d.textContent || d.innerHTML || "").replace(qb, "")));
        i = c = null
      }
      return this
    }
  }), m.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function(a, b) { m.fn[a] = function(a) { for (var c, d = 0, e = [], g = m(a), h = g.length - 1; h >= d; d++) c = d === h ? this : this.clone(!0), m(g[d])[b](c), f.apply(e, c.get()); return this.pushStack(e) } });
  var Cb, Db = {};

  function Eb(b, c) {
    var d, e = m(c.createElement(b)).appendTo(c.body),
      f = a.getDefaultComputedStyle && (d = a.getDefaultComputedStyle(e[0])) ? d.display : m.css(e[0], "display");
    return e.detach(), f
  }

  function Fb(a) {
    var b = y,
      c = Db[a];
    return c || (c = Eb(a, b), "none" !== c && c || (Cb = (Cb || m("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement), b = (Cb[0].contentWindow || Cb[0].contentDocument).document, b.write(), b.close(), c = Eb(a, b), Cb.detach()), Db[a] = c), c
  }! function() {
    var a;
    k.shrinkWrapBlocks = function() {
      if (null != a) return a;
      a = !1;
      var b, c, d;
      return c = y.getElementsByTagName("body")[0], c && c.style ? (b = y.createElement("div"), d = y.createElement("div"), d.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", c.appendChild(d).appendChild(b), typeof b.style.zoom !== K && (b.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", b.appendChild(y.createElement("div")).style.width = "5px", a = 3 !== b.offsetWidth), c.removeChild(d), a) : void 0
    }
  }();
  var Gb = /^margin/,
    Hb = new RegExp("^(" + S + ")(?!px)[a-z%]+$", "i"),
    Ib, Jb, Kb = /^(top|right|bottom|left)$/;
  a.getComputedStyle ? (Ib = function(a) { return a.ownerDocument.defaultView.getComputedStyle(a, null) }, Jb = function(a, b, c) { var d, e, f, g, h = a.style; return c = c || Ib(a), g = c ? c.getPropertyValue(b) || c[b] : void 0, c && ("" !== g || m.contains(a.ownerDocument, a) || (g = m.style(a, b)), Hb.test(g) && Gb.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f)), void 0 === g ? g : g + "" }) : y.documentElement.currentStyle && (Ib = function(a) { return a.currentStyle }, Jb = function(a, b, c) { var d, e, f, g, h = a.style; return c = c || Ib(a), g = c ? c[b] : void 0, null == g && h && h[b] && (g = h[b]), Hb.test(g) && !Kb.test(b) && (d = h.left, e = a.runtimeStyle, f = e && e.left, f && (e.left = a.currentStyle.left), h.left = "fontSize" === b ? "1em" : g, g = h.pixelLeft + "px", h.left = d, f && (e.left = f)), void 0 === g ? g : g + "" || "auto" });

  function Lb(a, b) { return { get: function() { var c = a(); if (null != c) return c ? void delete this.get : (this.get = b).apply(this, arguments) } } }! function() {
    var b, c, d, e, f, g, h;
    if (b = y.createElement("div"), b.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", d = b.getElementsByTagName("a")[0], c = d && d.style) {
      c.cssText = "float:left;opacity:.5", k.opacity = "0.5" === c.opacity, k.cssFloat = !!c.cssFloat, b.style.backgroundClip = "content-box", b.cloneNode(!0).style.backgroundClip = "", k.clearCloneStyle = "content-box" === b.style.backgroundClip, k.boxSizing = "" === c.boxSizing || "" === c.MozBoxSizing || "" === c.WebkitBoxSizing, m.extend(k, { reliableHiddenOffsets: function() { return null == g && i(), g }, boxSizingReliable: function() { return null == f && i(), f }, pixelPosition: function() { return null == e && i(), e }, reliableMarginRight: function() { return null == h && i(), h } });

      function i() {
        var b, c, d, i;
        c = y.getElementsByTagName("body")[0], c && c.style && (b = y.createElement("div"), d = y.createElement("div"), d.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", c.appendChild(d).appendChild(b), b.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", e = f = !1, h = !0, a.getComputedStyle && (e = "1%" !== (a.getComputedStyle(b, null) || {}).top, f = "4px" === (a.getComputedStyle(b, null) || { width: "4px" }).width, i = b.appendChild(y.createElement("div")), i.style.cssText = b.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", i.style.marginRight = i.style.width = "0", b.style.width = "1px", h = !parseFloat((a.getComputedStyle(i, null) || {}).marginRight)), b.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", i = b.getElementsByTagName("td"), i[0].style.cssText = "margin:0;border:0;padding:0;display:none", g = 0 === i[0].offsetHeight, g && (i[0].style.display = "", i[1].style.display = "none", g = 0 === i[0].offsetHeight), c.removeChild(d))
      }
    }
  }(), m.swap = function(a, b, c, d) {
    var e, f, g = {};
    for (f in b) g[f] = a.style[f], a.style[f] = b[f];
    e = c.apply(a, d || []);
    for (f in b) a.style[f] = g[f];
    return e
  };
  var Mb = /alpha\([^)]*\)/i,
    Nb = /opacity\s*=\s*([^)]*)/,
    Ob = /^(none|table(?!-c[ea]).+)/,
    Pb = new RegExp("^(" + S + ")(.*)$", "i"),
    Qb = new RegExp("^([+-])=(" + S + ")", "i"),
    Rb = { position: "absolute", visibility: "hidden", display: "block" },
    Sb = { letterSpacing: "0", fontWeight: "400" },
    Tb = ["Webkit", "O", "Moz", "ms"];

  function Ub(a, b) {
    if (b in a) return b;
    var c = b.charAt(0).toUpperCase() + b.slice(1),
      d = b,
      e = Tb.length;
    while (e--)
      if (b = Tb[e] + c, b in a) return b;
    return d
  }

  function Vb(a, b) { for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++) d = a[g], d.style && (f[g] = m._data(d, "olddisplay"), c = d.style.display, b ? (f[g] || "none" !== c || (d.style.display = ""), "" === d.style.display && U(d) && (f[g] = m._data(d, "olddisplay", Fb(d.nodeName)))) : (e = U(d), (c && "none" !== c || !e) && m._data(d, "olddisplay", e ? c : m.css(d, "display")))); for (g = 0; h > g; g++) d = a[g], d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none")); return a }

  function Wb(a, b, c) { var d = Pb.exec(b); return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b }

  function Xb(a, b, c, d, e) { for (var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2) "margin" === c && (g += m.css(a, c + T[f], !0, e)), d ? ("content" === c && (g -= m.css(a, "padding" + T[f], !0, e)), "margin" !== c && (g -= m.css(a, "border" + T[f] + "Width", !0, e))) : (g += m.css(a, "padding" + T[f], !0, e), "padding" !== c && (g += m.css(a, "border" + T[f] + "Width", !0, e))); return g }

  function Yb(a, b, c) {
    var d = !0,
      e = "width" === b ? a.offsetWidth : a.offsetHeight,
      f = Ib(a),
      g = k.boxSizing && "border-box" === m.css(a, "boxSizing", !1, f);
    if (0 >= e || null == e) {
      if (e = Jb(a, b, f), (0 > e || null == e) && (e = a.style[b]), Hb.test(e)) return e;
      d = g && (k.boxSizingReliable() || e === a.style[b]), e = parseFloat(e) || 0
    }
    return e + Xb(a, b, c || (g ? "border" : "content"), d, f) + "px"
  }
  m.extend({
    cssHooks: { opacity: { get: function(a, b) { if (b) { var c = Jb(a, "opacity"); return "" === c ? "1" : c } } } },
    cssNumber: { columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
    cssProps: { "float": k.cssFloat ? "cssFloat" : "styleFloat" },
    style: function(a, b, c, d) {
      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
        var e, f, g, h = m.camelCase(b),
          i = a.style;
        if (b = m.cssProps[h] || (m.cssProps[h] = Ub(i, h)), g = m.cssHooks[b] || m.cssHooks[h], void 0 === c) return g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b];
        if (f = typeof c, "string" === f && (e = Qb.exec(c)) && (c = (e[1] + 1) * e[2] + parseFloat(m.css(a, b)), f = "number"), null != c && c === c && ("number" !== f || m.cssNumber[h] || (c += "px"), k.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"), !(g && "set" in g && void 0 === (c = g.set(a, c, d))))) try { i[b] = c } catch (j) {}
      }
    },
    css: function(a, b, c, d) { var e, f, g, h = m.camelCase(b); return b = m.cssProps[h] || (m.cssProps[h] = Ub(a.style, h)), g = m.cssHooks[b] || m.cssHooks[h], g && "get" in g && (f = g.get(a, !0, c)), void 0 === f && (f = Jb(a, b, d)), "normal" === f && b in Sb && (f = Sb[b]), "" === c || c ? (e = parseFloat(f), c === !0 || m.isNumeric(e) ? e || 0 : f) : f }
  }), m.each(["height", "width"], function(a, b) { m.cssHooks[b] = { get: function(a, c, d) { return c ? Ob.test(m.css(a, "display")) && 0 === a.offsetWidth ? m.swap(a, Rb, function() { return Yb(a, b, d) }) : Yb(a, b, d) : void 0 }, set: function(a, c, d) { var e = d && Ib(a); return Wb(a, c, d ? Xb(a, b, d, k.boxSizing && "border-box" === m.css(a, "boxSizing", !1, e), e) : 0) } } }), k.opacity || (m.cssHooks.opacity = {
    get: function(a, b) { return Nb.test((b && a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : b ? "1" : "" },
    set: function(a, b) {
      var c = a.style,
        d = a.currentStyle,
        e = m.isNumeric(b) ? "alpha(opacity=" + 100 * b + ")" : "",
        f = d && d.filter || c.filter || "";
      c.zoom = 1, (b >= 1 || "" === b) && "" === m.trim(f.replace(Mb, "")) && c.removeAttribute && (c.removeAttribute("filter"), "" === b || d && !d.filter) || (c.filter = Mb.test(f) ? f.replace(Mb, e) : f + " " + e)
    }
  }), m.cssHooks.marginRight = Lb(k.reliableMarginRight, function(a, b) { return b ? m.swap(a, { display: "inline-block" }, Jb, [a, "marginRight"]) : void 0 }), m.each({ margin: "", padding: "", border: "Width" }, function(a, b) { m.cssHooks[a + b] = { expand: function(c) { for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; 4 > d; d++) e[a + T[d] + b] = f[d] || f[d - 2] || f[0]; return e } }, Gb.test(a) || (m.cssHooks[a + b].set = Wb) }), m.fn.extend({
    css: function(a, b) {
      return V(this, function(a, b, c) {
        var d, e, f = {},
          g = 0;
        if (m.isArray(b)) { for (d = Ib(a), e = b.length; e > g; g++) f[b[g]] = m.css(a, b[g], !1, d); return f }
        return void 0 !== c ? m.style(a, b, c) : m.css(a, b)
      }, a, b, arguments.length > 1)
    },
    show: function() { return Vb(this, !0) },
    hide: function() { return Vb(this) },
    toggle: function(a) { return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function() { U(this) ? m(this).show() : m(this).hide() }) }
  });

  function Zb(a, b, c, d, e) { return new Zb.prototype.init(a, b, c, d, e) } m.Tween = Zb, Zb.prototype = {
    constructor: Zb,
    init: function(a, b, c, d, e, f) {
      this.elem = a, this.prop = c, this.easing = e || "swing", this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (m.cssNumber[c] ? "" : "px")
    },
    cur: function() { var a = Zb.propHooks[this.prop]; return a && a.get ? a.get(this) : Zb.propHooks._default.get(this) },
    run: function(a) { var b, c = Zb.propHooks[this.prop]; return this.pos = b = this.options.duration ? m.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : Zb.propHooks._default.set(this), this }
  }, Zb.prototype.init.prototype = Zb.prototype, Zb.propHooks = { _default: { get: function(a) { var b; return null == a.elem[a.prop] || a.elem.style && null != a.elem.style[a.prop] ? (b = m.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0) : a.elem[a.prop] }, set: function(a) { m.fx.step[a.prop] ? m.fx.step[a.prop](a) : a.elem.style && (null != a.elem.style[m.cssProps[a.prop]] || m.cssHooks[a.prop]) ? m.style(a.elem, a.prop, a.now + a.unit) : a.elem[a.prop] = a.now } } }, Zb.propHooks.scrollTop = Zb.propHooks.scrollLeft = { set: function(a) { a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now) } }, m.easing = { linear: function(a) { return a }, swing: function(a) { return .5 - Math.cos(a * Math.PI) / 2 } }, m.fx = Zb.prototype.init, m.fx.step = {};
  var $b, _b, ac = /^(?:toggle|show|hide)$/,
    bc = new RegExp("^(?:([+-])=|)(" + S + ")([a-z%]*)$", "i"),
    cc = /queueHooks$/,
    dc = [ic],
    ec = {
      "*": [function(a, b) {
        var c = this.createTween(a, b),
          d = c.cur(),
          e = bc.exec(b),
          f = e && e[3] || (m.cssNumber[a] ? "" : "px"),
          g = (m.cssNumber[a] || "px" !== f && +d) && bc.exec(m.css(c.elem, a)),
          h = 1,
          i = 20;
        if (g && g[3] !== f) {
          f = f || g[3], e = e || [], g = +d || 1;
          do h = h || ".5", g /= h, m.style(c.elem, a, g + f); while (h !== (h = c.cur() / d) && 1 !== h && --i)
        }
        return e && (g = c.start = +g || +d || 0, c.unit = f, c.end = e[1] ? g + (e[1] + 1) * e[2] : +e[2]), c
      }]
    };

  function fc() { return setTimeout(function() { $b = void 0 }), $b = m.now() }

  function gc(a, b) {
    var c, d = { height: a },
      e = 0;
    for (b = b ? 1 : 0; 4 > e; e += 2 - b) c = T[e], d["margin" + c] = d["padding" + c] = a;
    return b && (d.opacity = d.width = a), d
  }

  function hc(a, b, c) {
    for (var d, e = (ec[b] || []).concat(ec["*"]), f = 0, g = e.length; g > f; f++)
      if (d = e[f].call(c, b, a)) return d
  }

  function ic(a, b, c) {
    var d, e, f, g, h, i, j, l, n = this,
      o = {},
      p = a.style,
      q = a.nodeType && U(a),
      r = m._data(a, "fxshow");
    c.queue || (h = m._queueHooks(a, "fx"), null == h.unqueued && (h.unqueued = 0, i = h.empty.fire, h.empty.fire = function() { h.unqueued || i() }), h.unqueued++, n.always(function() { n.always(function() { h.unqueued--, m.queue(a, "fx").length || h.empty.fire() }) })), 1 === a.nodeType && ("height" in b || "width" in b) && (c.overflow = [p.overflow, p.overflowX, p.overflowY], j = m.css(a, "display"), l = "none" === j ? m._data(a, "olddisplay") || Fb(a.nodeName) : j, "inline" === l && "none" === m.css(a, "float") && (k.inlineBlockNeedsLayout && "inline" !== Fb(a.nodeName) ? p.zoom = 1 : p.display = "inline-block")), c.overflow && (p.overflow = "hidden", k.shrinkWrapBlocks() || n.always(function() { p.overflow = c.overflow[0], p.overflowX = c.overflow[1], p.overflowY = c.overflow[2] }));
    for (d in b)
      if (e = b[d], ac.exec(e)) {
        if (delete b[d], f = f || "toggle" === e, e === (q ? "hide" : "show")) {
          if ("show" !== e || !r || void 0 === r[d]) continue;
          q = !0
        }
        o[d] = r && r[d] || m.style(a, d)
      } else j = void 0;
    if (m.isEmptyObject(o)) "inline" === ("none" === j ? Fb(a.nodeName) : j) && (p.display = j);
    else {
      r ? "hidden" in r && (q = r.hidden) : r = m._data(a, "fxshow", {}), f && (r.hidden = !q), q ? m(a).show() : n.done(function() { m(a).hide() }), n.done(function() {
        var b;
        m._removeData(a, "fxshow");
        for (b in o) m.style(a, b, o[b])
      });
      for (d in o) g = hc(q ? r[d] : 0, d, n), d in r || (r[d] = g.start, q && (g.end = g.start, g.start = "width" === d || "height" === d ? 1 : 0))
    }
  }

  function jc(a, b) {
    var c, d, e, f, g;
    for (c in a)
      if (d = m.camelCase(c), e = b[d], f = a[c], m.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = m.cssHooks[d], g && "expand" in g) { f = g.expand(f), delete a[d]; for (c in f) c in a || (a[c] = f[c], b[c] = e) } else b[d] = e
  }

  function kc(a, b, c) {
    var d, e, f = 0,
      g = dc.length,
      h = m.Deferred().always(function() { delete i.elem }),
      i = function() { if (e) return !1; for (var b = $b || fc(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++) j.tweens[g].run(f); return h.notifyWith(a, [j, f, c]), 1 > f && i ? c : (h.resolveWith(a, [j]), !1) },
      j = h.promise({
        elem: a,
        props: m.extend({}, b),
        opts: m.extend(!0, { specialEasing: {} }, c),
        originalProperties: b,
        originalOptions: c,
        startTime: $b || fc(),
        duration: c.duration,
        tweens: [],
        createTween: function(b, c) { var d = m.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing); return j.tweens.push(d), d },
        stop: function(b) {
          var c = 0,
            d = b ? j.tweens.length : 0;
          if (e) return this;
          for (e = !0; d > c; c++) j.tweens[c].run(1);
          return b ? h.resolveWith(a, [j, b]) : h.rejectWith(a, [j, b]), this
        }
      }),
      k = j.props;
    for (jc(k, j.opts.specialEasing); g > f; f++)
      if (d = dc[f].call(j, a, k, j.opts)) return d;
    return m.map(k, hc, j), m.isFunction(j.opts.start) && j.opts.start.call(a, j), m.fx.timer(m.extend(i, { elem: a, anim: j, queue: j.opts.queue })), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always)
  }
  m.Animation = m.extend(kc, { tweener: function(a, b) { m.isFunction(a) ? (b = a, a = ["*"]) : a = a.split(" "); for (var c, d = 0, e = a.length; e > d; d++) c = a[d], ec[c] = ec[c] || [], ec[c].unshift(b) }, prefilter: function(a, b) { b ? dc.unshift(a) : dc.push(a) } }), m.speed = function(a, b, c) { var d = a && "object" == typeof a ? m.extend({}, a) : { complete: c || !c && b || m.isFunction(a) && a, duration: a, easing: c && b || b && !m.isFunction(b) && b }; return d.duration = m.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in m.fx.speeds ? m.fx.speeds[d.duration] : m.fx.speeds._default, (null == d.queue || d.queue === !0) && (d.queue = "fx"), d.old = d.complete, d.complete = function() { m.isFunction(d.old) && d.old.call(this), d.queue && m.dequeue(this, d.queue) }, d }, m.fn.extend({
      fadeTo: function(a, b, c, d) { return this.filter(U).css("opacity", 0).show().end().animate({ opacity: b }, a, c, d) },
      animate: function(a, b, c, d) {
        var e = m.isEmptyObject(a),
          f = m.speed(b, c, d),
          g = function() {
            var b = kc(this, m.extend({}, a), f);
            (e || m._data(this, "finish")) && b.stop(!0)
          };
        return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
      },
      stop: function(a, b, c) {
        var d = function(a) {
          var b = a.stop;
          delete a.stop, b(c)
        };
        return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function() {
          var b = !0,
            e = null != a && a + "queueHooks",
            f = m.timers,
            g = m._data(this);
          if (e) g[e] && g[e].stop && d(g[e]);
          else
            for (e in g) g[e] && g[e].stop && cc.test(e) && d(g[e]);
          for (e = f.length; e--;) f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
          (b || !c) && m.dequeue(this, a)
        })
      },
      finish: function(a) {
        return a !== !1 && (a = a || "fx"), this.each(function() {
          var b, c = m._data(this),
            d = c[a + "queue"],
            e = c[a + "queueHooks"],
            f = m.timers,
            g = d ? d.length : 0;
          for (c.finish = !0, m.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
          for (b = 0; g > b; b++) d[b] && d[b].finish && d[b].finish.call(this);
          delete c.finish
        })
      }
    }), m.each(["toggle", "show", "hide"], function(a, b) {
      var c = m.fn[b];
      m.fn[b] = function(a, d, e) { return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(gc(b, !0), a, d, e) }
    }), m.each({ slideDown: gc("show"), slideUp: gc("hide"), slideToggle: gc("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function(a, b) { m.fn[a] = function(a, c, d) { return this.animate(b, a, c, d) } }), m.timers = [], m.fx.tick = function() {
      var a, b = m.timers,
        c = 0;
      for ($b = m.now(); c < b.length; c++) a = b[c], a() || b[c] !== a || b.splice(c--, 1);
      b.length || m.fx.stop(), $b = void 0
    }, m.fx.timer = function(a) { m.timers.push(a), a() ? m.fx.start() : m.timers.pop() }, m.fx.interval = 13, m.fx.start = function() { _b || (_b = setInterval(m.fx.tick, m.fx.interval)) }, m.fx.stop = function() { clearInterval(_b), _b = null }, m.fx.speeds = { slow: 600, fast: 200, _default: 400 }, m.fn.delay = function(a, b) {
      return a = m.fx ? m.fx.speeds[a] || a : a, b = b || "fx", this.queue(b, function(b, c) {
        var d = setTimeout(b, a);
        c.stop = function() { clearTimeout(d) }
      })
    },
    function() {
      var a, b, c, d, e;
      b = y.createElement("div"), b.setAttribute("className", "t"), b.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", d = b.getElementsByTagName("a")[0], c = y.createElement("select"), e = c.appendChild(y.createElement("option")), a = b.getElementsByTagName("input")[0], d.style.cssText = "top:1px", k.getSetAttribute = "t" !== b.className, k.style = /top/.test(d.getAttribute("style")), k.hrefNormalized = "/a" === d.getAttribute("href"), k.checkOn = !!a.value, k.optSelected = e.selected, k.enctype = !!y.createElement("form").enctype, c.disabled = !0, k.optDisabled = !e.disabled, a = y.createElement("input"), a.setAttribute("value", ""), k.input = "" === a.getAttribute("value"), a.value = "t", a.setAttribute("type", "radio"), k.radioValue = "t" === a.value
    }();
  var lc = /\r/g;
  m.fn.extend({
    val: function(a) {
      var b, c, d, e = this[0]; {
        if (arguments.length) return d = m.isFunction(a), this.each(function(c) {
          var e;
          1 === this.nodeType && (e = d ? a.call(this, c, m(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : m.isArray(e) && (e = m.map(e, function(a) { return null == a ? "" : a + "" })), b = m.valHooks[this.type] || m.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e))
        });
        if (e) return b = m.valHooks[e.type] || m.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(lc, "") : null == c ? "" : c)
      }
    }
  }), m.extend({
    valHooks: {
      option: { get: function(a) { var b = m.find.attr(a, "value"); return null != b ? b : m.trim(m.text(a)) } },
      select: {
        get: function(a) {
          for (var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++)
            if (c = d[i], !(!c.selected && i !== e || (k.optDisabled ? c.disabled : null !== c.getAttribute("disabled")) || c.parentNode.disabled && m.nodeName(c.parentNode, "optgroup"))) {
              if (b = m(c).val(), f) return b;
              g.push(b)
            }
          return g
        },
        set: function(a, b) {
          var c, d, e = a.options,
            f = m.makeArray(b),
            g = e.length;
          while (g--)
            if (d = e[g], m.inArray(m.valHooks.option.get(d), f) >= 0) try { d.selected = c = !0 } catch (h) { d.scrollHeight } else d.selected = !1;
          return c || (a.selectedIndex = -1), e
        }
      }
    }
  }), m.each(["radio", "checkbox"], function() { m.valHooks[this] = { set: function(a, b) { return m.isArray(b) ? a.checked = m.inArray(m(a).val(), b) >= 0 : void 0 } }, k.checkOn || (m.valHooks[this].get = function(a) { return null === a.getAttribute("value") ? "on" : a.value }) });
  var mc, nc, oc = m.expr.attrHandle,
    pc = /^(?:checked|selected)$/i,
    qc = k.getSetAttribute,
    rc = k.input;
  m.fn.extend({ attr: function(a, b) { return V(this, m.attr, a, b, arguments.length > 1) }, removeAttr: function(a) { return this.each(function() { m.removeAttr(this, a) }) } }), m.extend({
    attr: function(a, b, c) { var d, e, f = a.nodeType; if (a && 3 !== f && 8 !== f && 2 !== f) return typeof a.getAttribute === K ? m.prop(a, b, c) : (1 === f && m.isXMLDoc(a) || (b = b.toLowerCase(), d = m.attrHooks[b] || (m.expr.match.bool.test(b) ? nc : mc)), void 0 === c ? d && "get" in d && null !== (e = d.get(a, b)) ? e : (e = m.find.attr(a, b), null == e ? void 0 : e) : null !== c ? d && "set" in d && void 0 !== (e = d.set(a, c, b)) ? e : (a.setAttribute(b, c + ""), c) : void m.removeAttr(a, b)) },
    removeAttr: function(a, b) {
      var c, d, e = 0,
        f = b && b.match(E);
      if (f && 1 === a.nodeType)
        while (c = f[e++]) d = m.propFix[c] || c, m.expr.match.bool.test(c) ? rc && qc || !pc.test(c) ? a[d] = !1 : a[m.camelCase("default-" + c)] = a[d] = !1 : m.attr(a, c, ""), a.removeAttribute(qc ? c : d)
    },
    attrHooks: { type: { set: function(a, b) { if (!k.radioValue && "radio" === b && m.nodeName(a, "input")) { var c = a.value; return a.setAttribute("type", b), c && (a.value = c), b } } } }
  }), nc = { set: function(a, b, c) { return b === !1 ? m.removeAttr(a, c) : rc && qc || !pc.test(c) ? a.setAttribute(!qc && m.propFix[c] || c, c) : a[m.camelCase("default-" + c)] = a[c] = !0, c } }, m.each(m.expr.match.bool.source.match(/\w+/g), function(a, b) {
    var c = oc[b] || m.find.attr;
    oc[b] = rc && qc || !pc.test(b) ? function(a, b, d) { var e, f; return d || (f = oc[b], oc[b] = e, e = null != c(a, b, d) ? b.toLowerCase() : null, oc[b] = f), e } : function(a, b, c) { return c ? void 0 : a[m.camelCase("default-" + b)] ? b.toLowerCase() : null }
  }), rc && qc || (m.attrHooks.value = { set: function(a, b, c) { return m.nodeName(a, "input") ? void(a.defaultValue = b) : mc && mc.set(a, b, c) } }), qc || (mc = { set: function(a, b, c) { var d = a.getAttributeNode(c); return d || a.setAttributeNode(d = a.ownerDocument.createAttribute(c)), d.value = b += "", "value" === c || b === a.getAttribute(c) ? b : void 0 } }, oc.id = oc.name = oc.coords = function(a, b, c) { var d; return c ? void 0 : (d = a.getAttributeNode(b)) && "" !== d.value ? d.value : null }, m.valHooks.button = { get: function(a, b) { var c = a.getAttributeNode(b); return c && c.specified ? c.value : void 0 }, set: mc.set }, m.attrHooks.contenteditable = { set: function(a, b, c) { mc.set(a, "" === b ? !1 : b, c) } }, m.each(["width", "height"], function(a, b) { m.attrHooks[b] = { set: function(a, c) { return "" === c ? (a.setAttribute(b, "auto"), c) : void 0 } } })), k.style || (m.attrHooks.style = { get: function(a) { return a.style.cssText || void 0 }, set: function(a, b) { return a.style.cssText = b + "" } });
  var sc = /^(?:input|select|textarea|button|object)$/i,
    tc = /^(?:a|area)$/i;
  m.fn.extend({ prop: function(a, b) { return V(this, m.prop, a, b, arguments.length > 1) }, removeProp: function(a) { return a = m.propFix[a] || a, this.each(function() { try { this[a] = void 0, delete this[a] } catch (b) {} }) } }), m.extend({ propFix: { "for": "htmlFor", "class": "className" }, prop: function(a, b, c) { var d, e, f, g = a.nodeType; if (a && 3 !== g && 8 !== g && 2 !== g) return f = 1 !== g || !m.isXMLDoc(a), f && (b = m.propFix[b] || b, e = m.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b] }, propHooks: { tabIndex: { get: function(a) { var b = m.find.attr(a, "tabindex"); return b ? parseInt(b, 10) : sc.test(a.nodeName) || tc.test(a.nodeName) && a.href ? 0 : -1 } } } }), k.hrefNormalized || m.each(["href", "src"], function(a, b) { m.propHooks[b] = { get: function(a) { return a.getAttribute(b, 4) } } }), k.optSelected || (m.propHooks.selected = { get: function(a) { var b = a.parentNode; return b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex), null } }), m.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() { m.propFix[this.toLowerCase()] = this }), k.enctype || (m.propFix.enctype = "encoding");
  var uc = /[\t\r\n\f]/g;
  m.fn.extend({
    addClass: function(a) {
      var b, c, d, e, f, g, h = 0,
        i = this.length,
        j = "string" == typeof a && a;
      if (m.isFunction(a)) return this.each(function(b) { m(this).addClass(a.call(this, b, this.className)) });
      if (j)
        for (b = (a || "").match(E) || []; i > h; h++)
          if (c = this[h], d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(uc, " ") : " ")) {
            f = 0;
            while (e = b[f++]) d.indexOf(" " + e + " ") < 0 && (d += e + " ");
            g = m.trim(d), c.className !== g && (c.className = g)
          }
      return this
    },
    removeClass: function(a) {
      var b, c, d, e, f, g, h = 0,
        i = this.length,
        j = 0 === arguments.length || "string" == typeof a && a;
      if (m.isFunction(a)) return this.each(function(b) { m(this).removeClass(a.call(this, b, this.className)) });
      if (j)
        for (b = (a || "").match(E) || []; i > h; h++)
          if (c = this[h], d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(uc, " ") : "")) {
            f = 0;
            while (e = b[f++])
              while (d.indexOf(" " + e + " ") >= 0) d = d.replace(" " + e + " ", " ");
            g = a ? m.trim(d) : "", c.className !== g && (c.className = g)
          }
      return this
    },
    toggleClass: function(a, b) {
      var c = typeof a;
      return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : this.each(m.isFunction(a) ? function(c) { m(this).toggleClass(a.call(this, c, this.className, b), b) } : function() {
        if ("string" === c) {
          var b, d = 0,
            e = m(this),
            f = a.match(E) || [];
          while (b = f[d++]) e.hasClass(b) ? e.removeClass(b) : e.addClass(b)
        } else(c === K || "boolean" === c) && (this.className && m._data(this, "__className__", this.className), this.className = this.className || a === !1 ? "" : m._data(this, "__className__") || "")
      })
    },
    hasClass: function(a) {
      for (var b = " " + a + " ", c = 0, d = this.length; d > c; c++)
        if (1 === this[c].nodeType && (" " + this[c].className + " ").replace(uc, " ").indexOf(b) >= 0) return !0;
      return !1
    }
  }), m.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(a, b) { m.fn[b] = function(a, c) { return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b) } }), m.fn.extend({ hover: function(a, b) { return this.mouseenter(a).mouseleave(b || a) }, bind: function(a, b, c) { return this.on(a, null, b, c) }, unbind: function(a, b) { return this.off(a, null, b) }, delegate: function(a, b, c, d) { return this.on(b, a, c, d) }, undelegate: function(a, b, c) { return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c) } });
  var vc = m.now(),
    wc = /\?/,
    xc = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
  m.parseJSON = function(b) {
    if (a.JSON && a.JSON.parse) return a.JSON.parse(b + "");
    var c, d = null,
      e = m.trim(b + "");
    return e && !m.trim(e.replace(xc, function(a, b, e, f) { return c && b && (d = 0), 0 === d ? a : (c = e || b, d += !f - !e, "") })) ? Function("return " + e)() : m.error("Invalid JSON: " + b)
  }, m.parseXML = function(b) { var c, d; if (!b || "string" != typeof b) return null; try { a.DOMParser ? (d = new DOMParser, c = d.parseFromString(b, "text/xml")) : (c = new ActiveXObject("Microsoft.XMLDOM"), c.async = "false", c.loadXML(b)) } catch (e) { c = void 0 } return c && c.documentElement && !c.getElementsByTagName("parsererror").length || m.error("Invalid XML: " + b), c };
  var yc, zc, Ac = /#.*$/,
    Bc = /([?&])_=[^&]*/,
    Cc = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
    Dc = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Ec = /^(?:GET|HEAD)$/,
    Fc = /^\/\//,
    Gc = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
    Hc = {},
    Ic = {},
    Jc = "*/".concat("*");
  try { zc = location.href } catch (Kc) { zc = y.createElement("a"), zc.href = "", zc = zc.href } yc = Gc.exec(zc.toLowerCase()) || [];

  function Lc(a) {
    return function(b, c) {
      "string" != typeof b && (c = b, b = "*");
      var d, e = 0,
        f = b.toLowerCase().match(E) || [];
      if (m.isFunction(c))
        while (d = f[e++]) "+" === d.charAt(0) ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c)
    }
  }

  function Mc(a, b, c, d) {
    var e = {},
      f = a === Ic;

    function g(h) { var i; return e[h] = !0, m.each(a[h] || [], function(a, h) { var j = h(b, c, d); return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j), g(j), !1) }), i }
    return g(b.dataTypes[0]) || !e["*"] && g("*")
  }

  function Nc(a, b) { var c, d, e = m.ajaxSettings.flatOptions || {}; for (d in b) void 0 !== b[d] && ((e[d] ? a : c || (c = {}))[d] = b[d]); return c && m.extend(!0, a, c), a }

  function Oc(a, b, c) {
    var d, e, f, g, h = a.contents,
      i = a.dataTypes;
    while ("*" === i[0]) i.shift(), void 0 === e && (e = a.mimeType || b.getResponseHeader("Content-Type"));
    if (e)
      for (g in h)
        if (h[g] && h[g].test(e)) { i.unshift(g); break }
    if (i[0] in c) f = i[0];
    else { for (g in c) { if (!i[0] || a.converters[g + " " + i[0]]) { f = g; break } d || (d = g) } f = f || d }
    return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0
  }

  function Pc(a, b, c, d) {
    var e, f, g, h, i, j = {},
      k = a.dataTypes.slice();
    if (k[1])
      for (g in a.converters) j[g.toLowerCase()] = a.converters[g];
    f = k.shift();
    while (f)
      if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift())
        if ("*" === f) f = i;
        else if ("*" !== i && i !== f) {
      if (g = j[i + " " + f] || j["* " + f], !g)
        for (e in j)
          if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) { g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1])); break }
      if (g !== !0)
        if (g && a["throws"]) b = g(b);
        else try { b = g(b) } catch (l) { return { state: "parsererror", error: g ? l : "No conversion from " + i + " to " + f } }
    }
    return { state: "success", data: b }
  }
  m.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: { url: zc, type: "GET", isLocal: Dc.test(yc[1]), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Jc, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /xml/, html: /html/, json: /json/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": m.parseJSON, "text xml": m.parseXML }, flatOptions: { url: !0, context: !0 } },
    ajaxSetup: function(a, b) { return b ? Nc(Nc(a, m.ajaxSettings), b) : Nc(m.ajaxSettings, a) },
    ajaxPrefilter: Lc(Hc),
    ajaxTransport: Lc(Ic),
    ajax: function(a, b) {
      "object" == typeof a && (b = a, a = void 0), b = b || {};
      var c, d, e, f, g, h, i, j, k = m.ajaxSetup({}, b),
        l = k.context || k,
        n = k.context && (l.nodeType || l.jquery) ? m(l) : m.event,
        o = m.Deferred(),
        p = m.Callbacks("once memory"),
        q = k.statusCode || {},
        r = {},
        s = {},
        t = 0,
        u = "canceled",
        v = {
          readyState: 0,
          getResponseHeader: function(a) { var b; if (2 === t) { if (!j) { j = {}; while (b = Cc.exec(f)) j[b[1].toLowerCase()] = b[2] } b = j[a.toLowerCase()] } return null == b ? null : b },
          getAllResponseHeaders: function() { return 2 === t ? f : null },
          setRequestHeader: function(a, b) { var c = a.toLowerCase(); return t || (a = s[c] = s[c] || a, r[a] = b), this },
          overrideMimeType: function(a) { return t || (k.mimeType = a), this },
          statusCode: function(a) {
            var b;
            if (a)
              if (2 > t)
                for (b in a) q[b] = [q[b], a[b]];
              else v.always(a[v.status]);
            return this
          },
          abort: function(a) { var b = a || u; return i && i.abort(b), x(0, b), this }
        };
      if (o.promise(v).complete = p.add, v.success = v.done, v.error = v.fail, k.url = ((a || k.url || zc) + "").replace(Ac, "").replace(Fc, yc[1] + "//"), k.type = b.method || b.type || k.method || k.type, k.dataTypes = m.trim(k.dataType || "*").toLowerCase().match(E) || [""], null == k.crossDomain && (c = Gc.exec(k.url.toLowerCase()), k.crossDomain = !(!c || c[1] === yc[1] && c[2] === yc[2] && (c[3] || ("http:" === c[1] ? "80" : "443")) === (yc[3] || ("http:" === yc[1] ? "80" : "443")))), k.data && k.processData && "string" != typeof k.data && (k.data = m.param(k.data, k.traditional)), Mc(Hc, k, b, v), 2 === t) return v;
      h = k.global, h && 0 === m.active++ && m.event.trigger("ajaxStart"), k.type = k.type.toUpperCase(), k.hasContent = !Ec.test(k.type), e = k.url, k.hasContent || (k.data && (e = k.url += (wc.test(e) ? "&" : "?") + k.data, delete k.data), k.cache === !1 && (k.url = Bc.test(e) ? e.replace(Bc, "$1_=" + vc++) : e + (wc.test(e) ? "&" : "?") + "_=" + vc++)), k.ifModified && (m.lastModified[e] && v.setRequestHeader("If-Modified-Since", m.lastModified[e]), m.etag[e] && v.setRequestHeader("If-None-Match", m.etag[e])), (k.data && k.hasContent && k.contentType !== !1 || b.contentType) && v.setRequestHeader("Content-Type", k.contentType), v.setRequestHeader("Accept", k.dataTypes[0] && k.accepts[k.dataTypes[0]] ? k.accepts[k.dataTypes[0]] + ("*" !== k.dataTypes[0] ? ", " + Jc + "; q=0.01" : "") : k.accepts["*"]);
      for (d in k.headers) v.setRequestHeader(d, k.headers[d]);
      if (k.beforeSend && (k.beforeSend.call(l, v, k) === !1 || 2 === t)) return v.abort();
      u = "abort";
      for (d in { success: 1, error: 1, complete: 1 }) v[d](k[d]);
      if (i = Mc(Ic, k, b, v)) {
        v.readyState = 1, h && n.trigger("ajaxSend", [v, k]), k.async && k.timeout > 0 && (g = setTimeout(function() { v.abort("timeout") }, k.timeout));
        try { t = 1, i.send(r, x) } catch (w) {
          if (!(2 > t)) throw w;
          x(-1, w)
        }
      } else x(-1, "No Transport");

      function x(a, b, c, d) {
        var j, r, s, u, w, x = b;
        2 !== t && (t = 2, g && clearTimeout(g), i = void 0, f = d || "", v.readyState = a > 0 ? 4 : 0, j = a >= 200 && 300 > a || 304 === a, c && (u = Oc(k, v, c)), u = Pc(k, u, v, j), j ? (k.ifModified && (w = v.getResponseHeader("Last-Modified"), w && (m.lastModified[e] = w), w = v.getResponseHeader("etag"), w && (m.etag[e] = w)), 204 === a || "HEAD" === k.type ? x = "nocontent" : 304 === a ? x = "notmodified" : (x = u.state, r = u.data, s = u.error, j = !s)) : (s = x, (a || !x) && (x = "error", 0 > a && (a = 0))), v.status = a, v.statusText = (b || x) + "", j ? o.resolveWith(l, [r, x, v]) : o.rejectWith(l, [v, x, s]), v.statusCode(q), q = void 0, h && n.trigger(j ? "ajaxSuccess" : "ajaxError", [v, k, j ? r : s]), p.fireWith(l, [v, x]), h && (n.trigger("ajaxComplete", [v, k]), --m.active || m.event.trigger("ajaxStop")))
      }
      return v
    },
    getJSON: function(a, b, c) { return m.get(a, b, c, "json") },
    getScript: function(a, b) { return m.get(a, void 0, b, "script") }
  }), m.each(["get", "post"], function(a, b) { m[b] = function(a, c, d, e) { return m.isFunction(c) && (e = e || d, d = c, c = void 0), m.ajax({ url: a, type: b, dataType: e, data: c, success: d }) } }), m.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(a, b) { m.fn[b] = function(a) { return this.on(b, a) } }), m._evalUrl = function(a) { return m.ajax({ url: a, type: "GET", dataType: "script", async: !1, global: !1, "throws": !0 }) }, m.fn.extend({
    wrapAll: function(a) {
      if (m.isFunction(a)) return this.each(function(b) { m(this).wrapAll(a.call(this, b)) });
      if (this[0]) {
        var b = m(a, this[0].ownerDocument).eq(0).clone(!0);
        this[0].parentNode && b.insertBefore(this[0]), b.map(function() { var a = this; while (a.firstChild && 1 === a.firstChild.nodeType) a = a.firstChild; return a }).append(this)
      }
      return this
    },
    wrapInner: function(a) {
      return this.each(m.isFunction(a) ? function(b) { m(this).wrapInner(a.call(this, b)) } : function() {
        var b = m(this),
          c = b.contents();
        c.length ? c.wrapAll(a) : b.append(a)
      })
    },
    wrap: function(a) { var b = m.isFunction(a); return this.each(function(c) { m(this).wrapAll(b ? a.call(this, c) : a) }) },
    unwrap: function() { return this.parent().each(function() { m.nodeName(this, "body") || m(this).replaceWith(this.childNodes) }).end() }
  }), m.expr.filters.hidden = function(a) { return a.offsetWidth <= 0 && a.offsetHeight <= 0 || !k.reliableHiddenOffsets() && "none" === (a.style && a.style.display || m.css(a, "display")) }, m.expr.filters.visible = function(a) { return !m.expr.filters.hidden(a) };
  var Qc = /%20/g,
    Rc = /\[\]$/,
    Sc = /\r?\n/g,
    Tc = /^(?:submit|button|image|reset|file)$/i,
    Uc = /^(?:input|select|textarea|keygen)/i;

  function Vc(a, b, c, d) {
    var e;
    if (m.isArray(b)) m.each(b, function(b, e) { c || Rc.test(a) ? d(a, e) : Vc(a + "[" + ("object" == typeof e ? b : "") + "]", e, c, d) });
    else if (c || "object" !== m.type(b)) d(a, b);
    else
      for (e in b) Vc(a + "[" + e + "]", b[e], c, d)
  }
  m.param = function(a, b) {
    var c, d = [],
      e = function(a, b) { b = m.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b) };
    if (void 0 === b && (b = m.ajaxSettings && m.ajaxSettings.traditional), m.isArray(a) || a.jquery && !m.isPlainObject(a)) m.each(a, function() { e(this.name, this.value) });
    else
      for (c in a) Vc(c, a[c], b, e);
    return d.join("&").replace(Qc, "+")
  }, m.fn.extend({ serialize: function() { return m.param(this.serializeArray()) }, serializeArray: function() { return this.map(function() { var a = m.prop(this, "elements"); return a ? m.makeArray(a) : this }).filter(function() { var a = this.type; return this.name && !m(this).is(":disabled") && Uc.test(this.nodeName) && !Tc.test(a) && (this.checked || !W.test(a)) }).map(function(a, b) { var c = m(this).val(); return null == c ? null : m.isArray(c) ? m.map(c, function(a) { return { name: b.name, value: a.replace(Sc, "\r\n") } }) : { name: b.name, value: c.replace(Sc, "\r\n") } }).get() } }), m.ajaxSettings.xhr = void 0 !== a.ActiveXObject ? function() { return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && Zc() || $c() } : Zc;
  var Wc = 0,
    Xc = {},
    Yc = m.ajaxSettings.xhr();
  a.ActiveXObject && m(a).on("unload", function() { for (var a in Xc) Xc[a](void 0, !0) }), k.cors = !!Yc && "withCredentials" in Yc, Yc = k.ajax = !!Yc, Yc && m.ajaxTransport(function(a) {
    if (!a.crossDomain || k.cors) {
      var b;
      return {
        send: function(c, d) {
          var e, f = a.xhr(),
            g = ++Wc;
          if (f.open(a.type, a.url, a.async, a.username, a.password), a.xhrFields)
            for (e in a.xhrFields) f[e] = a.xhrFields[e];
          a.mimeType && f.overrideMimeType && f.overrideMimeType(a.mimeType), a.crossDomain || c["X-Requested-With"] || (c["X-Requested-With"] = "XMLHttpRequest");
          for (e in c) void 0 !== c[e] && f.setRequestHeader(e, c[e] + "");
          f.send(a.hasContent && a.data || null), b = function(c, e) {
            var h, i, j;
            if (b && (e || 4 === f.readyState))
              if (delete Xc[g], b = void 0, f.onreadystatechange = m.noop, e) 4 !== f.readyState && f.abort();
              else { j = {}, h = f.status, "string" == typeof f.responseText && (j.text = f.responseText); try { i = f.statusText } catch (k) { i = "" } h || !a.isLocal || a.crossDomain ? 1223 === h && (h = 204) : h = j.text ? 200 : 404 }
            j && d(h, i, j, f.getAllResponseHeaders())
          }, a.async ? 4 === f.readyState ? setTimeout(b) : f.onreadystatechange = Xc[g] = b : b()
        },
        abort: function() { b && b(void 0, !0) }
      }
    }
  });

  function Zc() { try { return new a.XMLHttpRequest } catch (b) {} }

  function $c() { try { return new a.ActiveXObject("Microsoft.XMLHTTP") } catch (b) {} } m.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /(?:java|ecma)script/ }, converters: { "text script": function(a) { return m.globalEval(a), a } } }), m.ajaxPrefilter("script", function(a) { void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET", a.global = !1) }), m.ajaxTransport("script", function(a) {
    if (a.crossDomain) {
      var b, c = y.head || m("head")[0] || y.documentElement;
      return {
        send: function(d, e) {
          b = y.createElement("script"), b.async = !0, a.scriptCharset && (b.charset = a.scriptCharset), b.src = a.url, b.onload = b.onreadystatechange = function(a, c) {
            (c || !b.readyState || /loaded|complete/.test(b.readyState)) && (b.onload = b.onreadystatechange = null, b.parentNode && b.parentNode.removeChild(b), b = null, c || e(200, "success"))
          }, c.insertBefore(b, c.firstChild)
        },
        abort: function() { b && b.onload(void 0, !0) }
      }
    }
  });
  var _c = [],
    ad = /(=)\?(?=&|$)|\?\?/;
  m.ajaxSetup({ jsonp: "callback", jsonpCallback: function() { var a = _c.pop() || m.expando + "_" + vc++; return this[a] = !0, a } }), m.ajaxPrefilter("json jsonp", function(b, c, d) { var e, f, g, h = b.jsonp !== !1 && (ad.test(b.url) ? "url" : "string" == typeof b.data && !(b.contentType || "").indexOf("application/x-www-form-urlencoded") && ad.test(b.data) && "data"); return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = m.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(ad, "$1" + e) : b.jsonp !== !1 && (b.url += (wc.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function() { return g || m.error(e + " was not called"), g[0] }, b.dataTypes[0] = "json", f = a[e], a[e] = function() { g = arguments }, d.always(function() { a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, _c.push(e)), g && m.isFunction(f) && f(g[0]), g = f = void 0 }), "script") : void 0 }), m.parseHTML = function(a, b, c) {
    if (!a || "string" != typeof a) return null;
    "boolean" == typeof b && (c = b, b = !1), b = b || y;
    var d = u.exec(a),
      e = !c && [];
    return d ? [b.createElement(d[1])] : (d = m.buildFragment([a], b, e), e && e.length && m(e).remove(), m.merge([], d.childNodes))
  };
  var bd = m.fn.load;
  m.fn.load = function(a, b, c) {
    if ("string" != typeof a && bd) return bd.apply(this, arguments);
    var d, e, f, g = this,
      h = a.indexOf(" ");
    return h >= 0 && (d = m.trim(a.slice(h, a.length)), a = a.slice(0, h)), m.isFunction(b) ? (c = b, b = void 0) : b && "object" == typeof b && (f = "POST"), g.length > 0 && m.ajax({ url: a, type: f, dataType: "html", data: b }).done(function(a) { e = arguments, g.html(d ? m("<div>").append(m.parseHTML(a)).find(d) : a) }).complete(c && function(a, b) { g.each(c, e || [a.responseText, b, a]) }), this
  }, m.expr.filters.animated = function(a) { return m.grep(m.timers, function(b) { return a === b.elem }).length };
  var cd = a.document.documentElement;

  function dd(a) { return m.isWindow(a) ? a : 9 === a.nodeType ? a.defaultView || a.parentWindow : !1 } m.offset = {
    setOffset: function(a, b, c) {
      var d, e, f, g, h, i, j, k = m.css(a, "position"),
        l = m(a),
        n = {};
      "static" === k && (a.style.position = "relative"), h = l.offset(), f = m.css(a, "top"), i = m.css(a, "left"), j = ("absolute" === k || "fixed" === k) && m.inArray("auto", [f, i]) > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), m.isFunction(b) && (b = b.call(a, c, h)), null != b.top && (n.top = b.top - h.top + g), null != b.left && (n.left = b.left - h.left + e), "using" in b ? b.using.call(a, n) : l.css(n)
    }
  }, m.fn.extend({
    offset: function(a) {
      if (arguments.length) return void 0 === a ? this : this.each(function(b) { m.offset.setOffset(this, a, b) });
      var b, c, d = { top: 0, left: 0 },
        e = this[0],
        f = e && e.ownerDocument;
      if (f) return b = f.documentElement, m.contains(b, e) ? (typeof e.getBoundingClientRect !== K && (d = e.getBoundingClientRect()), c = dd(f), { top: d.top + (c.pageYOffset || b.scrollTop) - (b.clientTop || 0), left: d.left + (c.pageXOffset || b.scrollLeft) - (b.clientLeft || 0) }) : d
    },
    position: function() {
      if (this[0]) {
        var a, b, c = { top: 0, left: 0 },
          d = this[0];
        return "fixed" === m.css(d, "position") ? b = d.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), m.nodeName(a[0], "html") || (c = a.offset()), c.top += m.css(a[0], "borderTopWidth", !0), c.left += m.css(a[0], "borderLeftWidth", !0)), { top: b.top - c.top - m.css(d, "marginTop", !0), left: b.left - c.left - m.css(d, "marginLeft", !0) }
      }
    },
    offsetParent: function() { return this.map(function() { var a = this.offsetParent || cd; while (a && !m.nodeName(a, "html") && "static" === m.css(a, "position")) a = a.offsetParent; return a || cd }) }
  }), m.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(a, b) {
    var c = /Y/.test(b);
    m.fn[a] = function(d) { return V(this, function(a, d, e) { var f = dd(a); return void 0 === e ? f ? b in f ? f[b] : f.document.documentElement[d] : a[d] : void(f ? f.scrollTo(c ? m(f).scrollLeft() : e, c ? e : m(f).scrollTop()) : a[d] = e) }, a, d, arguments.length, null) }
  }), m.each(["top", "left"], function(a, b) { m.cssHooks[b] = Lb(k.pixelPosition, function(a, c) { return c ? (c = Jb(a, b), Hb.test(c) ? m(a).position()[b] + "px" : c) : void 0 }) }), m.each({ Height: "height", Width: "width" }, function(a, b) {
    m.each({ padding: "inner" + a, content: b, "": "outer" + a }, function(c, d) {
      m.fn[d] = function(d, e) {
        var f = arguments.length && (c || "boolean" != typeof d),
          g = c || (d === !0 || e === !0 ? "margin" : "border");
        return V(this, function(b, c, d) { var e; return m.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement, Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? m.css(b, c, g) : m.style(b, c, d, g) }, b, f ? d : void 0, f, null)
      }
    })
  }), m.fn.size = function() { return this.length }, m.fn.andSelf = m.fn.addBack, "function" == typeof define && __webpack_require__(286) && define("jquery", [], function() { return m });
  var ed = a.jQuery,
    fd = a.$;
  return m.noConflict = function(b) { return a.$ === m && (a.$ = fd), b && a.jQuery === m && (a.jQuery = ed), m }, typeof b === K && (a.jQuery = a.$ = m), m
});




/* harmony default export */ __webpack_exports__["a"] = ({ //export your file
  init:function() {
    var _showTab = 0;
    var $defaultLi = $('ul.tabs li').eq(_showTab);
    $($defaultLi.find('a').attr('href')).siblings().hide();
    $('ul.tabs li').click(function() {
      var $this = $(this),
        _clickTab = $this.find('a').attr('href');
      $('ul.tabs li').removeClass('active')
      $this.addClass('active').siblings('.active');
      $(_clickTab).stop(false, true).fadeIn().siblings().hide();

      return false;
    }).find('a').focus(function() {
      this.blur();
    });
  }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1306)(module), __webpack_require__(6)))

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var defer = function defer() {
  var state = false; // Resolved or not
  var callbacks = [];
  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;
    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }
    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },

    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

function createRecaptcha() {
  var deferred = defer();

  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (window.hasOwnProperty('grecaptcha')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}

var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var VueRecaptcha$1 = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();
    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired
    });
    var container = this.$slots.default ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;
      _this.$emit('render', id);
    });
  },

  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots.default);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VueRecaptcha$1);


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(256)
__webpack_require__(249)
__webpack_require__(250)
__webpack_require__(251)
__webpack_require__(252)
__webpack_require__(67)
__webpack_require__(68)
__webpack_require__(69)
__webpack_require__(253)
__webpack_require__(254)
__webpack_require__(255)
__webpack_require__(248)

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(285),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 285:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-not-found"
    }
  }, [_c('div', [_c('h1', [_vm._v("Error 404")]), _vm._v(" "), _c('p', [_vm._v("Page not found")])])])
}]}

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, setImmediate) {/*
 * jQuery FlexSlider v2.6.4
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
;
(function ($) {

  var focused = true;

  //FlexSlider: Object Instance
  $.flexslider = function(el, options) {
    var slider = $(el);

    // making variables public
    slider.vars = $.extend({}, $.flexslider.defaults, options);

    var namespace = slider.vars.namespace,
        msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
        touch = (( "ontouchstart" in window ) || msGesture || window.DocumentTouch && document instanceof DocumentTouch) && slider.vars.touch,
        // deprecating this idea, as devices are being released with both of these events
        eventType = "click touchend MSPointerUp keyup",
        watchedEvent = "",
        watchedEventClearTimer,
        vertical = slider.vars.direction === "vertical",
        reverse = slider.vars.reverse,
        carousel = (slider.vars.itemWidth > 0),
        fade = slider.vars.animation === "fade",
        asNav = slider.vars.asNavFor !== "",
        methods = {};

    // Store a reference to the slider object
    $.data(el, "flexslider", slider);

    // Private slider methods
    methods = {
      init: function() {
        slider.animating = false;
        // Get current slide and make sure it is a number
        slider.currentSlide = parseInt( ( slider.vars.startAt ? slider.vars.startAt : 0), 10 );
        if ( isNaN( slider.currentSlide ) ) { slider.currentSlide = 0; }
        slider.animatingTo = slider.currentSlide;
        slider.atEnd = (slider.currentSlide === 0 || slider.currentSlide === slider.last);
        slider.containerSelector = slider.vars.selector.substr(0,slider.vars.selector.search(' '));
        slider.slides = $(slider.vars.selector, slider);
        slider.container = $(slider.containerSelector, slider);
        slider.count = slider.slides.length;
        // SYNC:
        slider.syncExists = $(slider.vars.sync).length > 0;
        // SLIDE:
        if (slider.vars.animation === "slide") { slider.vars.animation = "swing"; }
        slider.prop = (vertical) ? "top" : "marginLeft";
        slider.args = {};
        // SLIDESHOW:
        slider.manualPause = false;
        slider.stopped = false;
        //PAUSE WHEN INVISIBLE
        slider.started = false;
        slider.startTimeout = null;
        // TOUCH/USECSS:
        slider.transitions = !slider.vars.video && !fade && slider.vars.useCSS && (function() {
          var obj = document.createElement('div'),
              props = ['perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
          for (var i in props) {
            if ( obj.style[ props[i] ] !== undefined ) {
              slider.pfx = props[i].replace('Perspective','').toLowerCase();
              slider.prop = "-" + slider.pfx + "-transform";
              return true;
            }
          }
          return false;
        }());
        slider.ensureAnimationEnd = '';
        // CONTROLSCONTAINER:
        if (slider.vars.controlsContainer !== "") slider.controlsContainer = $(slider.vars.controlsContainer).length > 0 && $(slider.vars.controlsContainer);
        // MANUAL:
        if (slider.vars.manualControls !== "") slider.manualControls = $(slider.vars.manualControls).length > 0 && $(slider.vars.manualControls);

        // CUSTOM DIRECTION NAV:
        if (slider.vars.customDirectionNav !== "") slider.customDirectionNav = $(slider.vars.customDirectionNav).length === 2 && $(slider.vars.customDirectionNav);

        // RANDOMIZE:
        if (slider.vars.randomize) {
          slider.slides.sort(function() { return (Math.round(Math.random())-0.5); });
          slider.container.empty().append(slider.slides);
        }

        slider.doMath();

        // INIT
        slider.setup("init");

        // CONTROLNAV:
        if (slider.vars.controlNav) { methods.controlNav.setup(); }

        // DIRECTIONNAV:
        if (slider.vars.directionNav) { methods.directionNav.setup(); }

        // KEYBOARD:
        if (slider.vars.keyboard && ($(slider.containerSelector).length === 1 || slider.vars.multipleKeyboard)) {
          $(document).bind('keyup', function(event) {
            var keycode = event.keyCode;
            if (!slider.animating && (keycode === 39 || keycode === 37)) {
              var target = (keycode === 39) ? slider.getTarget('next') :
                           (keycode === 37) ? slider.getTarget('prev') : false;
              slider.flexAnimate(target, slider.vars.pauseOnAction);
            }
          });
        }
        // MOUSEWHEEL:
        if (slider.vars.mousewheel) {
          slider.bind('mousewheel', function(event, delta, deltaX, deltaY) {
            event.preventDefault();
            var target = (delta < 0) ? slider.getTarget('next') : slider.getTarget('prev');
            slider.flexAnimate(target, slider.vars.pauseOnAction);
          });
        }

        // PAUSEPLAY
        if (slider.vars.pausePlay) { methods.pausePlay.setup(); }

        //PAUSE WHEN INVISIBLE
        if (slider.vars.slideshow && slider.vars.pauseInvisible) { methods.pauseInvisible.init(); }

        // SLIDSESHOW
        if (slider.vars.slideshow) {
          if (slider.vars.pauseOnHover) {
            slider.hover(function() {
              if (!slider.manualPlay && !slider.manualPause) { slider.pause(); }
            }, function() {
              if (!slider.manualPause && !slider.manualPlay && !slider.stopped) { slider.play(); }
            });
          }
          // initialize animation
          //If we're visible, or we don't use PageVisibility API
          if(!slider.vars.pauseInvisible || !methods.pauseInvisible.isHidden()) {
            (slider.vars.initDelay > 0) ? slider.startTimeout = setTimeout(slider.play, slider.vars.initDelay) : slider.play();
          }
        }

        // ASNAV:
        if (asNav) { methods.asNav.setup(); }

        // TOUCH
        if (touch && slider.vars.touch) { methods.touch(); }

        // FADE&&SMOOTHHEIGHT || SLIDE:
        if (!fade || (fade && slider.vars.smoothHeight)) { $(window).bind("resize orientationchange focus", methods.resize()); }

        slider.find("img").attr("draggable", "false");

        // API: start() Callback
        setTimeout(function(){
          slider.vars.start(slider);
        }, 200);
      },
      asNav: {
        setup: function() {
          slider.asNav = true;
          slider.animatingTo = Math.floor(slider.currentSlide/slider.move);
          slider.currentItem = slider.currentSlide;
          slider.slides.removeClass(namespace + "active-slide").eq(slider.currentItem).addClass(namespace + "active-slide");
          if(!msGesture){
              slider.slides.on(eventType, function(e){
                e.preventDefault();
                var $slide = $(this),
                    target = $slide.index();
                var posFromLeft = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
                if( posFromLeft <= 0 && $slide.hasClass( namespace + 'active-slide' ) ) {
                  slider.flexAnimate(slider.getTarget("prev"), true);
                } else if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass(namespace + "active-slide")) {
                  slider.direction = (slider.currentItem < target) ? "next" : "prev";
                  slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                }
              });
          }else{
              el._slider = slider;
              slider.slides.each(function (){
                  var that = this;
                  that._gesture = new MSGesture();
                  that._gesture.target = that;
                  that.addEventListener("MSPointerDown", function (e){
                      e.preventDefault();
                      if(e.currentTarget._gesture) {
                        e.currentTarget._gesture.addPointer(e.pointerId);
                      }
                  }, false);
                  that.addEventListener("MSGestureTap", function (e){
                      e.preventDefault();
                      var $slide = $(this),
                          target = $slide.index();
                      if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass('active')) {
                          slider.direction = (slider.currentItem < target) ? "next" : "prev";
                          slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                      }
                  });
              });
          }
        }
      },
      controlNav: {
        setup: function() {
          if (!slider.manualControls) {
            methods.controlNav.setupPaging();
          } else { // MANUALCONTROLS:
            methods.controlNav.setupManual();
          }
        },
        setupPaging: function() {
          var type = (slider.vars.controlNav === "thumbnails") ? 'control-thumbs' : 'control-paging',
              j = 1,
              item,
              slide;

          slider.controlNavScaffold = $('<ol class="'+ namespace + 'control-nav ' + namespace + type + '"></ol>');

          if (slider.pagingCount > 1) {
            for (var i = 0; i < slider.pagingCount; i++) {
              slide = slider.slides.eq(i);
              if ( undefined === slide.attr( 'data-thumb-alt' ) ) { slide.attr( 'data-thumb-alt', '' ); }
              var altText = ( '' !== slide.attr( 'data-thumb-alt' ) ) ? altText = ' alt="' + slide.attr( 'data-thumb-alt' ) + '"' : '';
              item = (slider.vars.controlNav === "thumbnails") ? '<img src="' + slide.attr( 'data-thumb' ) + '"' + altText + '/>' : '<a href="#">' + j + '</a>';
              if ( 'thumbnails' === slider.vars.controlNav && true === slider.vars.thumbCaptions ) {
                var captn = slide.attr( 'data-thumbcaption' );
                if ( '' !== captn && undefined !== captn ) { item += '<span class="' + namespace + 'caption">' + captn + '</span>'; }
              }
              slider.controlNavScaffold.append('<li>' + item + '</li>');
              j++;
            }
          }

          // CONTROLSCONTAINER:
          (slider.controlsContainer) ? $(slider.controlsContainer).append(slider.controlNavScaffold) : slider.append(slider.controlNavScaffold);
          methods.controlNav.set();

          methods.controlNav.active();

          slider.controlNavScaffold.delegate('a, img', eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              var $this = $(this),
                  target = slider.controlNav.index($this);

              if (!$this.hasClass(namespace + 'active')) {
                slider.direction = (target > slider.currentSlide) ? "next" : "prev";
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();

          });
        },
        setupManual: function() {
          slider.controlNav = slider.manualControls;
          methods.controlNav.active();

          slider.controlNav.bind(eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              var $this = $(this),
                  target = slider.controlNav.index($this);

              if (!$this.hasClass(namespace + 'active')) {
                (target > slider.currentSlide) ? slider.direction = "next" : slider.direction = "prev";
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        set: function() {
          var selector = (slider.vars.controlNav === "thumbnails") ? 'img' : 'a';
          slider.controlNav = $('.' + namespace + 'control-nav li ' + selector, (slider.controlsContainer) ? slider.controlsContainer : slider);
        },
        active: function() {
          slider.controlNav.removeClass(namespace + "active").eq(slider.animatingTo).addClass(namespace + "active");
        },
        update: function(action, pos) {
          if (slider.pagingCount > 1 && action === "add") {
            slider.controlNavScaffold.append($('<li><a href="#">' + slider.count + '</a></li>'));
          } else if (slider.pagingCount === 1) {
            slider.controlNavScaffold.find('li').remove();
          } else {
            slider.controlNav.eq(pos).closest('li').remove();
          }
          methods.controlNav.set();
          (slider.pagingCount > 1 && slider.pagingCount !== slider.controlNav.length) ? slider.update(pos, action) : methods.controlNav.active();
        }
      },
      directionNav: {
        setup: function() {
          var directionNavScaffold = $('<ul class="' + namespace + 'direction-nav"><li class="' + namespace + 'nav-prev"><a class="' + namespace + 'prev" href="#">' + slider.vars.prevText + '</a></li><li class="' + namespace + 'nav-next"><a class="' + namespace + 'next" href="#">' + slider.vars.nextText + '</a></li></ul>');

          // CUSTOM DIRECTION NAV:
          if (slider.customDirectionNav) {
            slider.directionNav = slider.customDirectionNav;
          // CONTROLSCONTAINER:
          } else if (slider.controlsContainer) {
            $(slider.controlsContainer).append(directionNavScaffold);
            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider.controlsContainer);
          } else {
            slider.append(directionNavScaffold);
            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider);
          }

          methods.directionNav.update();

          slider.directionNav.bind(eventType, function(event) {
            event.preventDefault();
            var target;

            if (watchedEvent === "" || watchedEvent === event.type) {
              target = ($(this).hasClass(namespace + 'next')) ? slider.getTarget('next') : slider.getTarget('prev');
              slider.flexAnimate(target, slider.vars.pauseOnAction);
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        update: function() {
          var disabledClass = namespace + 'disabled';
          if (slider.pagingCount === 1) {
            slider.directionNav.addClass(disabledClass).attr('tabindex', '-1');
          } else if (!slider.vars.animationLoop) {
            if (slider.animatingTo === 0) {
              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "prev").addClass(disabledClass).attr('tabindex', '-1');
            } else if (slider.animatingTo === slider.last) {
              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "next").addClass(disabledClass).attr('tabindex', '-1');
            } else {
              slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
            }
          } else {
            slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
          }
        }
      },
      pausePlay: {
        setup: function() {
          var pausePlayScaffold = $('<div class="' + namespace + 'pauseplay"><a href="#"></a></div>');

          // CONTROLSCONTAINER:
          if (slider.controlsContainer) {
            slider.controlsContainer.append(pausePlayScaffold);
            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider.controlsContainer);
          } else {
            slider.append(pausePlayScaffold);
            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider);
          }

          methods.pausePlay.update((slider.vars.slideshow) ? namespace + 'pause' : namespace + 'play');

          slider.pausePlay.bind(eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              if ($(this).hasClass(namespace + 'pause')) {
                slider.manualPause = true;
                slider.manualPlay = false;
                slider.pause();
              } else {
                slider.manualPause = false;
                slider.manualPlay = true;
                slider.play();
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        update: function(state) {
          (state === "play") ? slider.pausePlay.removeClass(namespace + 'pause').addClass(namespace + 'play').html(slider.vars.playText) : slider.pausePlay.removeClass(namespace + 'play').addClass(namespace + 'pause').html(slider.vars.pauseText);
        }
      },
      touch: function() {
        var startX,
          startY,
          offset,
          cwidth,
          dx,
          startT,
          onTouchStart,
          onTouchMove,
          onTouchEnd,
          scrolling = false,
          localX = 0,
          localY = 0,
          accDx = 0;

        if(!msGesture){
            onTouchStart = function(e) {
              if (slider.animating) {
                e.preventDefault();
              } else if ( ( window.navigator.msPointerEnabled ) || e.touches.length === 1 ) {
                slider.pause();
                // CAROUSEL:
                cwidth = (vertical) ? slider.h : slider. w;
                startT = Number(new Date());
                // CAROUSEL:

                // Local vars for X and Y points.
                localX = e.touches[0].pageX;
                localY = e.touches[0].pageY;

                offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                         (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                         (carousel && slider.currentSlide === slider.last) ? slider.limit :
                         (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                         (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                startX = (vertical) ? localY : localX;
                startY = (vertical) ? localX : localY;

                el.addEventListener('touchmove', onTouchMove, false);
                el.addEventListener('touchend', onTouchEnd, false);
              }
            };

            onTouchMove = function(e) {
              // Local vars for X and Y points.

              localX = e.touches[0].pageX;
              localY = e.touches[0].pageY;

              dx = (vertical) ? startX - localY : startX - localX;
              scrolling = (vertical) ? (Math.abs(dx) < Math.abs(localX - startY)) : (Math.abs(dx) < Math.abs(localY - startY));

              var fxms = 500;

              if ( ! scrolling || Number( new Date() ) - startT > fxms ) {
                e.preventDefault();
                if (!fade && slider.transitions) {
                  if (!slider.vars.animationLoop) {
                    dx = dx/((slider.currentSlide === 0 && dx < 0 || slider.currentSlide === slider.last && dx > 0) ? (Math.abs(dx)/cwidth+2) : 1);
                  }
                  slider.setProps(offset + dx, "setTouch");
                }
              }
            };

            onTouchEnd = function(e) {
              // finish the touch by undoing the touch session
              el.removeEventListener('touchmove', onTouchMove, false);

              if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                var updateDx = (reverse) ? -dx : dx,
                    target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                  slider.flexAnimate(target, slider.vars.pauseOnAction);
                } else {
                  if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
                }
              }
              el.removeEventListener('touchend', onTouchEnd, false);

              startX = null;
              startY = null;
              dx = null;
              offset = null;
            };

            el.addEventListener('touchstart', onTouchStart, false);
        }else{
            el.style.msTouchAction = "none";
            el._gesture = new MSGesture();
            el._gesture.target = el;
            el.addEventListener("MSPointerDown", onMSPointerDown, false);
            el._slider = slider;
            el.addEventListener("MSGestureChange", onMSGestureChange, false);
            el.addEventListener("MSGestureEnd", onMSGestureEnd, false);

            function onMSPointerDown(e){
                e.stopPropagation();
                if (slider.animating) {
                    e.preventDefault();
                }else{
                    slider.pause();
                    el._gesture.addPointer(e.pointerId);
                    accDx = 0;
                    cwidth = (vertical) ? slider.h : slider. w;
                    startT = Number(new Date());
                    // CAROUSEL:

                    offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                        (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                            (carousel && slider.currentSlide === slider.last) ? slider.limit :
                                (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                                    (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                }
            }

            function onMSGestureChange(e) {
                e.stopPropagation();
                var slider = e.target._slider;
                if(!slider){
                    return;
                }
                var transX = -e.translationX,
                    transY = -e.translationY;

                //Accumulate translations.
                accDx = accDx + ((vertical) ? transY : transX);
                dx = accDx;
                scrolling = (vertical) ? (Math.abs(accDx) < Math.abs(-transX)) : (Math.abs(accDx) < Math.abs(-transY));

                if(e.detail === e.MSGESTURE_FLAG_INERTIA){
                    setImmediate(function (){
                        el._gesture.stop();
                    });

                    return;
                }

                if (!scrolling || Number(new Date()) - startT > 500) {
                    e.preventDefault();
                    if (!fade && slider.transitions) {
                        if (!slider.vars.animationLoop) {
                            dx = accDx / ((slider.currentSlide === 0 && accDx < 0 || slider.currentSlide === slider.last && accDx > 0) ? (Math.abs(accDx) / cwidth + 2) : 1);
                        }
                        slider.setProps(offset + dx, "setTouch");
                    }
                }
            }

            function onMSGestureEnd(e) {
                e.stopPropagation();
                var slider = e.target._slider;
                if(!slider){
                    return;
                }
                if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                    var updateDx = (reverse) ? -dx : dx,
                        target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                    if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                        slider.flexAnimate(target, slider.vars.pauseOnAction);
                    } else {
                        if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
                    }
                }

                startX = null;
                startY = null;
                dx = null;
                offset = null;
                accDx = 0;
            }
        }
      },
      resize: function() {
        if (!slider.animating && slider.is(':visible')) {
          if (!carousel) { slider.doMath(); }

          if (fade) {
            // SMOOTH HEIGHT:
            methods.smoothHeight();
          } else if (carousel) { //CAROUSEL:
            slider.slides.width(slider.computedW);
            slider.update(slider.pagingCount);
            slider.setProps();
          }
          else if (vertical) { //VERTICAL:
            slider.viewport.height(slider.h);
            slider.setProps(slider.h, "setTotal");
          } else {
            // SMOOTH HEIGHT:
            if (slider.vars.smoothHeight) { methods.smoothHeight(); }
            slider.newSlides.width(slider.computedW);
            slider.setProps(slider.computedW, "setTotal");
          }
        }
      },
      smoothHeight: function(dur) {
        if (!vertical || fade) {
          var $obj = (fade) ? slider : slider.viewport;
          (dur) ? $obj.animate({"height": slider.slides.eq(slider.animatingTo).innerHeight()}, dur) : $obj.innerHeight(slider.slides.eq(slider.animatingTo).innerHeight());
        }
      },
      sync: function(action) {
        var $obj = $(slider.vars.sync).data("flexslider"),
            target = slider.animatingTo;

        switch (action) {
          case "animate": $obj.flexAnimate(target, slider.vars.pauseOnAction, false, true); break;
          case "play": if (!$obj.playing && !$obj.asNav) { $obj.play(); } break;
          case "pause": $obj.pause(); break;
        }
      },
      uniqueID: function($clone) {
        // Append _clone to current level and children elements with id attributes
        $clone.filter( '[id]' ).add($clone.find( '[id]' )).each(function() {
          var $this = $(this);
          $this.attr( 'id', $this.attr( 'id' ) + '_clone' );
        });
        return $clone;
      },
      pauseInvisible: {
        visProp: null,
        init: function() {
          var visProp = methods.pauseInvisible.getHiddenProp();
          if (visProp) {
            var evtname = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
            document.addEventListener(evtname, function() {
              if (methods.pauseInvisible.isHidden()) {
                if(slider.startTimeout) {
                  clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
                } else {
                  slider.pause(); //Or just pause
                }
              }
              else {
                if(slider.started) {
                  slider.play(); //Initiated before, just play
                } else {
                  if (slider.vars.initDelay > 0) {
                    setTimeout(slider.play, slider.vars.initDelay);
                  } else {
                    slider.play(); //Didn't init before: simply init or wait for it
                  }
                }
              }
            });
          }
        },
        isHidden: function() {
          var prop = methods.pauseInvisible.getHiddenProp();
          if (!prop) {
            return false;
          }
          return document[prop];
        },
        getHiddenProp: function() {
          var prefixes = ['webkit','moz','ms','o'];
          // if 'hidden' is natively supported just return it
          if ('hidden' in document) {
            return 'hidden';
          }
          // otherwise loop over all the known prefixes until we find one
          for ( var i = 0; i < prefixes.length; i++ ) {
              if ((prefixes[i] + 'Hidden') in document) {
                return prefixes[i] + 'Hidden';
              }
          }
          // otherwise it's not supported
          return null;
        }
      },
      setToClearWatchedEvent: function() {
        clearTimeout(watchedEventClearTimer);
        watchedEventClearTimer = setTimeout(function() {
          watchedEvent = "";
        }, 3000);
      }
    };

    // public methods
    slider.flexAnimate = function(target, pause, override, withSync, fromNav) {
      if (!slider.vars.animationLoop && target !== slider.currentSlide) {
        slider.direction = (target > slider.currentSlide) ? "next" : "prev";
      }

      if (asNav && slider.pagingCount === 1) slider.direction = (slider.currentItem < target) ? "next" : "prev";

      if (!slider.animating && (slider.canAdvance(target, fromNav) || override) && slider.is(":visible")) {
        if (asNav && withSync) {
          var master = $(slider.vars.asNavFor).data('flexslider');
          slider.atEnd = target === 0 || target === slider.count - 1;
          master.flexAnimate(target, true, false, true, fromNav);
          slider.direction = (slider.currentItem < target) ? "next" : "prev";
          master.direction = slider.direction;

          if (Math.ceil((target + 1)/slider.visible) - 1 !== slider.currentSlide && target !== 0) {
            slider.currentItem = target;
            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
            target = Math.floor(target/slider.visible);
          } else {
            slider.currentItem = target;
            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
            return false;
          }
        }

        slider.animating = true;
        slider.animatingTo = target;

        // SLIDESHOW:
        if (pause) { slider.pause(); }

        // API: before() animation Callback
        slider.vars.before(slider);

        // SYNC:
        if (slider.syncExists && !fromNav) { methods.sync("animate"); }

        // CONTROLNAV
        if (slider.vars.controlNav) { methods.controlNav.active(); }

        // !CAROUSEL:
        // CANDIDATE: slide active class (for add/remove slide)
        if (!carousel) { slider.slides.removeClass(namespace + 'active-slide').eq(target).addClass(namespace + 'active-slide'); }

        // INFINITE LOOP:
        // CANDIDATE: atEnd
        slider.atEnd = target === 0 || target === slider.last;

        // DIRECTIONNAV:
        if (slider.vars.directionNav) { methods.directionNav.update(); }

        if (target === slider.last) {
          // API: end() of cycle Callback
          slider.vars.end(slider);
          // SLIDESHOW && !INFINITE LOOP:
          if (!slider.vars.animationLoop) { slider.pause(); }
        }

        // SLIDE:
        if (!fade) {
          var dimension = (vertical) ? slider.slides.filter(':first').height() : slider.computedW,
              margin, slideString, calcNext;

          // INFINITE LOOP / REVERSE:
          if (carousel) {
            margin = slider.vars.itemMargin;
            calcNext = ((slider.itemW + margin) * slider.move) * slider.animatingTo;
            slideString = (calcNext > slider.limit && slider.visible !== 1) ? slider.limit : calcNext;
          } else if (slider.currentSlide === 0 && target === slider.count - 1 && slider.vars.animationLoop && slider.direction !== "next") {
            slideString = (reverse) ? (slider.count + slider.cloneOffset) * dimension : 0;
          } else if (slider.currentSlide === slider.last && target === 0 && slider.vars.animationLoop && slider.direction !== "prev") {
            slideString = (reverse) ? 0 : (slider.count + 1) * dimension;
          } else {
            slideString = (reverse) ? ((slider.count - 1) - target + slider.cloneOffset) * dimension : (target + slider.cloneOffset) * dimension;
          }
          slider.setProps(slideString, "", slider.vars.animationSpeed);
          if (slider.transitions) {
            if (!slider.vars.animationLoop || !slider.atEnd) {
              slider.animating = false;
              slider.currentSlide = slider.animatingTo;
            }

            // Unbind previous transitionEnd events and re-bind new transitionEnd event
            slider.container.unbind("webkitTransitionEnd transitionend");
            slider.container.bind("webkitTransitionEnd transitionend", function() {
              clearTimeout(slider.ensureAnimationEnd);
              slider.wrapup(dimension);
            });

            // Insurance for the ever-so-fickle transitionEnd event
            clearTimeout(slider.ensureAnimationEnd);
            slider.ensureAnimationEnd = setTimeout(function() {
              slider.wrapup(dimension);
            }, slider.vars.animationSpeed + 100);

          } else {
            slider.container.animate(slider.args, slider.vars.animationSpeed, slider.vars.easing, function(){
              slider.wrapup(dimension);
            });
          }
        } else { // FADE:
          if (!touch) {
            slider.slides.eq(slider.currentSlide).css({"zIndex": 1}).animate({"opacity": 0}, slider.vars.animationSpeed, slider.vars.easing);
            slider.slides.eq(target).css({"zIndex": 2}).animate({"opacity": 1}, slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);
          } else {
            slider.slides.eq(slider.currentSlide).css({ "opacity": 0, "zIndex": 1 });
            slider.slides.eq(target).css({ "opacity": 1, "zIndex": 2 });
            slider.wrapup(dimension);
          }
        }
        // SMOOTH HEIGHT:
        if (slider.vars.smoothHeight) { methods.smoothHeight(slider.vars.animationSpeed); }
      }
    };
    slider.wrapup = function(dimension) {
      // SLIDE:
      if (!fade && !carousel) {
        if (slider.currentSlide === 0 && slider.animatingTo === slider.last && slider.vars.animationLoop) {
          slider.setProps(dimension, "jumpEnd");
        } else if (slider.currentSlide === slider.last && slider.animatingTo === 0 && slider.vars.animationLoop) {
          slider.setProps(dimension, "jumpStart");
        }
      }
      slider.animating = false;
      slider.currentSlide = slider.animatingTo;
      // API: after() animation Callback
      slider.vars.after(slider);
    };

    // SLIDESHOW:
    slider.animateSlides = function() {
      if (!slider.animating && focused ) { slider.flexAnimate(slider.getTarget("next")); }
    };
    // SLIDESHOW:
    slider.pause = function() {
      clearInterval(slider.animatedSlides);
      slider.animatedSlides = null;
      slider.playing = false;
      // PAUSEPLAY:
      if (slider.vars.pausePlay) { methods.pausePlay.update("play"); }
      // SYNC:
      if (slider.syncExists) { methods.sync("pause"); }
    };
    // SLIDESHOW:
    slider.play = function() {
      if (slider.playing) { clearInterval(slider.animatedSlides); }
      slider.animatedSlides = slider.animatedSlides || setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
      slider.started = slider.playing = true;
      // PAUSEPLAY:
      if (slider.vars.pausePlay) { methods.pausePlay.update("pause"); }
      // SYNC:
      if (slider.syncExists) { methods.sync("play"); }
    };
    // STOP:
    slider.stop = function () {
      slider.pause();
      slider.stopped = true;
    };
    slider.canAdvance = function(target, fromNav) {
      // ASNAV:
      var last = (asNav) ? slider.pagingCount - 1 : slider.last;
      return (fromNav) ? true :
             (asNav && slider.currentItem === slider.count - 1 && target === 0 && slider.direction === "prev") ? true :
             (asNav && slider.currentItem === 0 && target === slider.pagingCount - 1 && slider.direction !== "next") ? false :
             (target === slider.currentSlide && !asNav) ? false :
             (slider.vars.animationLoop) ? true :
             (slider.atEnd && slider.currentSlide === 0 && target === last && slider.direction !== "next") ? false :
             (slider.atEnd && slider.currentSlide === last && target === 0 && slider.direction === "next") ? false :
             true;
    };
    slider.getTarget = function(dir) {
      slider.direction = dir;
      if (dir === "next") {
        return (slider.currentSlide === slider.last) ? 0 : slider.currentSlide + 1;
      } else {
        return (slider.currentSlide === 0) ? slider.last : slider.currentSlide - 1;
      }
    };

    // SLIDE:
    slider.setProps = function(pos, special, dur) {
      var target = (function() {
        var posCheck = (pos) ? pos : ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo,
            posCalc = (function() {
              if (carousel) {
                return (special === "setTouch") ? pos :
                       (reverse && slider.animatingTo === slider.last) ? 0 :
                       (reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                       (slider.animatingTo === slider.last) ? slider.limit : posCheck;
              } else {
                switch (special) {
                  case "setTotal": return (reverse) ? ((slider.count - 1) - slider.currentSlide + slider.cloneOffset) * pos : (slider.currentSlide + slider.cloneOffset) * pos;
                  case "setTouch": return (reverse) ? pos : pos;
                  case "jumpEnd": return (reverse) ? pos : slider.count * pos;
                  case "jumpStart": return (reverse) ? slider.count * pos : pos;
                  default: return pos;
                }
              }
            }());

            return (posCalc * -1) + "px";
          }());

      if (slider.transitions) {
        target = (vertical) ? "translate3d(0," + target + ",0)" : "translate3d(" + target + ",0,0)";
        dur = (dur !== undefined) ? (dur/1000) + "s" : "0s";
        slider.container.css("-" + slider.pfx + "-transition-duration", dur);
         slider.container.css("transition-duration", dur);
      }

      slider.args[slider.prop] = target;
      if (slider.transitions || dur === undefined) { slider.container.css(slider.args); }

      slider.container.css('transform',target);
    };

    slider.setup = function(type) {
      // SLIDE:
      if (!fade) {
        var sliderOffset, arr;

        if (type === "init") {
          slider.viewport = $('<div class="' + namespace + 'viewport"></div>').css({"overflow": "hidden", "position": "relative"}).appendTo(slider).append(slider.container);
          // INFINITE LOOP:
          slider.cloneCount = 0;
          slider.cloneOffset = 0;
          // REVERSE:
          if (reverse) {
            arr = $.makeArray(slider.slides).reverse();
            slider.slides = $(arr);
            slider.container.empty().append(slider.slides);
          }
        }
        // INFINITE LOOP && !CAROUSEL:
        if (slider.vars.animationLoop && !carousel) {
          slider.cloneCount = 2;
          slider.cloneOffset = 1;
          // clear out old clones
          if (type !== "init") { slider.container.find('.clone').remove(); }
          slider.container.append(methods.uniqueID(slider.slides.first().clone().addClass('clone')).attr('aria-hidden', 'true'))
                          .prepend(methods.uniqueID(slider.slides.last().clone().addClass('clone')).attr('aria-hidden', 'true'));
        }
        slider.newSlides = $(slider.vars.selector, slider);

        sliderOffset = (reverse) ? slider.count - 1 - slider.currentSlide + slider.cloneOffset : slider.currentSlide + slider.cloneOffset;
        // VERTICAL:
        if (vertical && !carousel) {
          slider.container.height((slider.count + slider.cloneCount) * 200 + "%").css("position", "absolute").width("100%");
          setTimeout(function(){
            slider.newSlides.css({"display": "block"});
            slider.doMath();
            slider.viewport.height(slider.h);
            slider.setProps(sliderOffset * slider.h, "init");
          }, (type === "init") ? 100 : 0);
        } else {
          slider.container.width((slider.count + slider.cloneCount) * 200 + "%");
          slider.setProps(sliderOffset * slider.computedW, "init");
          setTimeout(function(){
            slider.doMath();
            slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "left", "display": "block"});
            // SMOOTH HEIGHT:
            if (slider.vars.smoothHeight) { methods.smoothHeight(); }
          }, (type === "init") ? 100 : 0);
        }
      } else { // FADE:
        slider.slides.css({"width": "100%", "float": "left", "marginRight": "-100%", "position": "relative"});
        if (type === "init") {
          if (!touch) {
            //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
            if (slider.vars.fadeFirstSlide == false) {
              slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).css({"opacity": 1});
            } else {
              slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).animate({"opacity": 1},slider.vars.animationSpeed,slider.vars.easing);
            }
          } else {
            slider.slides.css({ "opacity": 0, "display": "block", "webkitTransition": "opacity " + slider.vars.animationSpeed / 1000 + "s ease", "zIndex": 1 }).eq(slider.currentSlide).css({ "opacity": 1, "zIndex": 2});
          }
        }
        // SMOOTH HEIGHT:
        if (slider.vars.smoothHeight) { methods.smoothHeight(); }
      }
      // !CAROUSEL:
      // CANDIDATE: active slide
      if (!carousel) { slider.slides.removeClass(namespace + "active-slide").eq(slider.currentSlide).addClass(namespace + "active-slide"); }

      //FlexSlider: init() Callback
      slider.vars.init(slider);
    };

    slider.doMath = function() {
      var slide = slider.slides.first(),
          slideMargin = slider.vars.itemMargin,
          minItems = slider.vars.minItems,
          maxItems = slider.vars.maxItems;

      slider.w = (slider.viewport===undefined) ? slider.width() : slider.viewport.width();
      slider.h = slide.height();
      slider.boxPadding = slide.outerWidth() - slide.width();

      // CAROUSEL:
      if (carousel) {
        slider.itemT = slider.vars.itemWidth + slideMargin;
        slider.itemM = slideMargin;
        slider.minW = (minItems) ? minItems * slider.itemT : slider.w;
        slider.maxW = (maxItems) ? (maxItems * slider.itemT) - slideMargin : slider.w;
        slider.itemW = (slider.minW > slider.w) ? (slider.w - (slideMargin * (minItems - 1)))/minItems :
                       (slider.maxW < slider.w) ? (slider.w - (slideMargin * (maxItems - 1)))/maxItems :
                       (slider.vars.itemWidth > slider.w) ? slider.w : slider.vars.itemWidth;

        slider.visible = Math.floor(slider.w/(slider.itemW));
        slider.move = (slider.vars.move > 0 && slider.vars.move < slider.visible ) ? slider.vars.move : slider.visible;
        slider.pagingCount = Math.ceil(((slider.count - slider.visible)/slider.move) + 1);
        slider.last =  slider.pagingCount - 1;
        slider.limit = (slider.pagingCount === 1) ? 0 :
                       (slider.vars.itemWidth > slider.w) ? (slider.itemW * (slider.count - 1)) + (slideMargin * (slider.count - 1)) : ((slider.itemW + slideMargin) * slider.count) - slider.w - slideMargin;
      } else {
        slider.itemW = slider.w;
        slider.itemM = slideMargin;
        slider.pagingCount = slider.count;
        slider.last = slider.count - 1;
      }
      slider.computedW = slider.itemW - slider.boxPadding;
      slider.computedM = slider.itemM;
    };

    slider.update = function(pos, action) {
      slider.doMath();

      // update currentSlide and slider.animatingTo if necessary
      if (!carousel) {
        if (pos < slider.currentSlide) {
          slider.currentSlide += 1;
        } else if (pos <= slider.currentSlide && pos !== 0) {
          slider.currentSlide -= 1;
        }
        slider.animatingTo = slider.currentSlide;
      }

      // update controlNav
      if (slider.vars.controlNav && !slider.manualControls) {
        if ((action === "add" && !carousel) || slider.pagingCount > slider.controlNav.length) {
          methods.controlNav.update("add");
        } else if ((action === "remove" && !carousel) || slider.pagingCount < slider.controlNav.length) {
          if (carousel && slider.currentSlide > slider.last) {
            slider.currentSlide -= 1;
            slider.animatingTo -= 1;
          }
          methods.controlNav.update("remove", slider.last);
        }
      }
      // update directionNav
      if (slider.vars.directionNav) { methods.directionNav.update(); }

    };

    slider.addSlide = function(obj, pos) {
      var $obj = $(obj);

      slider.count += 1;
      slider.last = slider.count - 1;

      // append new slide
      if (vertical && reverse) {
        (pos !== undefined) ? slider.slides.eq(slider.count - pos).after($obj) : slider.container.prepend($obj);
      } else {
        (pos !== undefined) ? slider.slides.eq(pos).before($obj) : slider.container.append($obj);
      }

      // update currentSlide, animatingTo, controlNav, and directionNav
      slider.update(pos, "add");

      // update slider.slides
      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
      // re-setup the slider to accomdate new slide
      slider.setup();

      //FlexSlider: added() Callback
      slider.vars.added(slider);
    };
    slider.removeSlide = function(obj) {
      var pos = (isNaN(obj)) ? slider.slides.index($(obj)) : obj;

      // update count
      slider.count -= 1;
      slider.last = slider.count - 1;

      // remove slide
      if (isNaN(obj)) {
        $(obj, slider.slides).remove();
      } else {
        (vertical && reverse) ? slider.slides.eq(slider.last).remove() : slider.slides.eq(obj).remove();
      }

      // update currentSlide, animatingTo, controlNav, and directionNav
      slider.doMath();
      slider.update(pos, "remove");

      // update slider.slides
      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
      // re-setup the slider to accomdate new slide
      slider.setup();

      // FlexSlider: removed() Callback
      slider.vars.removed(slider);
    };

    //FlexSlider: Initialize
    methods.init();
  };

  // Ensure the slider isn't focussed if the window loses focus.
  $( window ).blur( function ( e ) {
    focused = false;
  }).focus( function ( e ) {
    focused = true;
  });

  //FlexSlider: Default Settings
  $.flexslider.defaults = {
    namespace: "flex-",             //{NEW} String: Prefix string attached to the class of every element generated by the plugin
    selector: ".slides > li",       //{NEW} Selector: Must match a simple pattern. '{container} > {slide}' -- Ignore pattern at your own peril
    animation: "fade",              //String: Select your animation type, "fade" or "slide"
    easing: "swing",                //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
    direction: "horizontal",        //String: Select the sliding direction, "horizontal" or "vertical"
    reverse: false,                 //{NEW} Boolean: Reverse the animation direction
    animationLoop: true,            //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
    smoothHeight: false,            //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
    startAt: 0,                     //Integer: The slide that the slider should start on. Array notation (0 = first slide)
    slideshow: true,                //Boolean: Animate slider automatically
    slideshowSpeed: 7000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
    animationSpeed: 600,            //Integer: Set the speed of animations, in milliseconds
    initDelay: 0,                   //{NEW} Integer: Set an initialization delay, in milliseconds
    randomize: false,               //Boolean: Randomize slide order
    fadeFirstSlide: true,           //Boolean: Fade in the first slide when animation type is "fade"
    thumbCaptions: false,           //Boolean: Whether or not to put captions on thumbnails when using the "thumbnails" controlNav.

    // Usability features
    pauseOnAction: true,            //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
    pauseOnHover: false,            //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
    pauseInvisible: true,   		//{NEW} Boolean: Pause the slideshow when tab is invisible, resume when visible. Provides better UX, lower CPU usage.
    useCSS: true,                   //{NEW} Boolean: Slider will use CSS3 transitions if available
    touch: true,                    //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
    video: false,                   //{NEW} Boolean: If using video in the slider, will prevent CSS3 3D Transforms to avoid graphical glitches

    // Primary Controls
    controlNav: true,               //Boolean: Create navigation for paging control of each slide? Note: Leave true for manualControls usage
    directionNav: true,             //Boolean: Create navigation for previous/next navigation? (true/false)
    prevText: "Previous",           //String: Set the text for the "previous" directionNav item
    nextText: "Next",               //String: Set the text for the "next" directionNav item

    // Secondary Navigation
    keyboard: true,                 //Boolean: Allow slider navigating via keyboard left/right keys
    multipleKeyboard: false,        //{NEW} Boolean: Allow keyboard navigation to affect multiple sliders. Default behavior cuts out keyboard navigation with more than one slider present.
    mousewheel: false,              //{UPDATED} Boolean: Requires jquery.mousewheel.js (https://github.com/brandonaaron/jquery-mousewheel) - Allows slider navigating via mousewheel
    pausePlay: false,               //Boolean: Create pause/play dynamic element
    pauseText: "Pause",             //String: Set the text for the "pause" pausePlay item
    playText: "Play",               //String: Set the text for the "play" pausePlay item

    // Special properties
    controlsContainer: "",          //{UPDATED} jQuery Object/Selector: Declare which container the navigation elements should be appended too. Default container is the FlexSlider element. Example use would be $(".flexslider-container"). Property is ignored if given element is not found.
    manualControls: "",             //{UPDATED} jQuery Object/Selector: Declare custom control navigation. Examples would be $(".flex-control-nav li") or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
    customDirectionNav: "",         //{NEW} jQuery Object/Selector: Custom prev / next button. Must be two jQuery elements. In order to make the events work they have to have the classes "prev" and "next" (plus namespace)
    sync: "",                       //{NEW} Selector: Mirror the actions performed on this slider with another slider. Use with care.
    asNavFor: "",                   //{NEW} Selector: Internal property exposed for turning the slider into a thumbnail navigation for another slider

    // Carousel Options
    itemWidth: 0,                   //{NEW} Integer: Box-model width of individual carousel items, including horizontal borders and padding.
    itemMargin: 0,                  //{NEW} Integer: Margin between carousel items.
    minItems: 1,                    //{NEW} Integer: Minimum number of carousel items that should be visible. Items will resize fluidly when below this.
    maxItems: 0,                    //{NEW} Integer: Maxmimum number of carousel items that should be visible. Items will resize fluidly when above this limit.
    move: 0,                        //{NEW} Integer: Number of carousel items that should move on animation. If 0, slider will move all visible items.
    allowOneSlide: true,           //{NEW} Boolean: Whether or not to allow a slider comprised of a single slide

    // Callback API
    start: function(){},            //Callback: function(slider) - Fires when the slider loads the first slide
    before: function(){},           //Callback: function(slider) - Fires asynchronously with each slider animation
    after: function(){},            //Callback: function(slider) - Fires after each slider animation completes
    end: function(){},              //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
    added: function(){},            //{NEW} Callback: function(slider) - Fires after a slide is added
    removed: function(){},           //{NEW} Callback: function(slider) - Fires after a slide is removed
    init: function() {}             //{NEW} Callback: function(slider) - Fires after the slider is initially setup
  };

  //FlexSlider: Plugin Function
  $.fn.flexslider = function(options) {
    if (options === undefined) { options = {}; }

    if (typeof options === "object") {
      return this.each(function() {
        var $this = $(this),
            selector = (options.selector) ? options.selector : ".slides > li",
            $slides = $this.find(selector);

      if ( ( $slides.length === 1 && options.allowOneSlide === false ) || $slides.length === 0 ) {
          $slides.fadeIn(400);
          if (options.start) { options.start($this); }
        } else if ($this.data('flexslider') === undefined) {
          new $.flexslider(this, options);
        }
      });
    } else {
      // Helper strings to quickly perform functions on the slider
      var $slider = $(this).data('flexslider');
      switch (options) {
        case "play": $slider.play(); break;
        case "pause": $slider.pause(); break;
        case "stop": $slider.stop(); break;
        case "next": $slider.flexAnimate($slider.getTarget("next"), true); break;
        case "prev":
        case "previous": $slider.flexAnimate($slider.getTarget("prev"), true); break;
        default: if (typeof options === "number") { $slider.flexAnimate(options, true); }
      }
    }
  };
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(398).setImmediate))

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lightbox v2.9.0
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright 2007, 2015 Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */

// Uses Node, AMD or browser globals to create a module.
(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (root is window)
        root.lightbox = factory(root.jQuery);
    }
}(this, function ($) {

  function Lightbox(options) {
    this.album = [];
    this.currentImageIndex = void 0;
    this.init();

    // options
    this.options = $.extend({}, this.constructor.defaults);
    this.option(options);
  }

  // Descriptions of all options available on the demo site:
  // http://lokeshdhakar.com/projects/lightbox2/index.html#options
  Lightbox.defaults = {
    albumLabel: 'Image %1 of %2',
    alwaysShowNavOnTouchDevices: false,
    fadeDuration: 600,
    fitImagesInViewport: true,
    imageFadeDuration: 600,
    // maxWidth: 800,
    // maxHeight: 600,
    positionFromTop: 50,
    resizeDuration: 700,
    showImageNumberLabel: true,
    wrapAround: false,
    disableScrolling: false,
    /*
    Sanitize Title
    If the caption data is trusted, for example you are hardcoding it in, then leave this to false.
    This will free you to add html tags, such as links, in the caption.

    If the caption data is user submitted or from some other untrusted source, then set this to true
    to prevent xss and other injection attacks.
     */
    sanitizeTitle: false
  };

  Lightbox.prototype.option = function(options) {
    $.extend(this.options, options);
  };

  Lightbox.prototype.imageCountLabel = function(currentImageNum, totalImages) {
    return this.options.albumLabel.replace(/%1/g, currentImageNum).replace(/%2/g, totalImages);
  };

  Lightbox.prototype.init = function() {
    var self = this;
    // Both enable and build methods require the body tag to be in the DOM.
    $(document).ready(function() {
      self.enable();
      self.build();
    });
  };

  // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
  // that contain 'lightbox'. When these are clicked, start lightbox.
  Lightbox.prototype.enable = function() {
    var self = this;
    $('body').on('click', 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function(event) {
      self.start($(event.currentTarget));
      return false;
    });
  };

  // Build html for the lightbox and the overlay.
  // Attach event handlers to the new DOM elements. click click click
  Lightbox.prototype.build = function() {
    var self = this;
    $('<div id="lightboxOverlay" class="lightboxOverlay"></div><div id="lightbox" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" /><div class="lb-nav"><a class="lb-prev" href="" ></a><a class="lb-next" href="" ></a></div><div class="lb-loader"><a class="lb-cancel"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close"></a></div></div></div></div>').appendTo($('body'));

    // Cache jQuery objects
    this.$lightbox       = $('#lightbox');
    this.$overlay        = $('#lightboxOverlay');
    this.$outerContainer = this.$lightbox.find('.lb-outerContainer');
    this.$container      = this.$lightbox.find('.lb-container');
    this.$image          = this.$lightbox.find('.lb-image');
    this.$nav            = this.$lightbox.find('.lb-nav');

    // Store css values for future lookup
    this.containerPadding = {
      top: parseInt(this.$container.css('padding-top'), 10),
      right: parseInt(this.$container.css('padding-right'), 10),
      bottom: parseInt(this.$container.css('padding-bottom'), 10),
      left: parseInt(this.$container.css('padding-left'), 10)
    };

    this.imageBorderWidth = {
      top: parseInt(this.$image.css('border-top-width'), 10),
      right: parseInt(this.$image.css('border-right-width'), 10),
      bottom: parseInt(this.$image.css('border-bottom-width'), 10),
      left: parseInt(this.$image.css('border-left-width'), 10)
    };

    // Attach event handlers to the newly minted DOM elements
    this.$overlay.hide().on('click', function() {
      self.end();
      return false;
    });

    this.$lightbox.hide().on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$outerContainer.on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$lightbox.find('.lb-prev').on('click', function() {
      if (self.currentImageIndex === 0) {
        self.changeImage(self.album.length - 1);
      } else {
        self.changeImage(self.currentImageIndex - 1);
      }
      return false;
    });

    this.$lightbox.find('.lb-next').on('click', function() {
      if (self.currentImageIndex === self.album.length - 1) {
        self.changeImage(0);
      } else {
        self.changeImage(self.currentImageIndex + 1);
      }
      return false;
    });

    /*
      Show context menu for image on right-click

      There is a div containing the navigation that spans the entire image and lives above of it. If
      you right-click, you are right clicking this div and not the image. This prevents users from
      saving the image or using other context menu actions with the image.

      To fix this, when we detect the right mouse button is pressed down, but not yet clicked, we
      set pointer-events to none on the nav div. This is so that the upcoming right-click event on
      the next mouseup will bubble down to the image. Once the right-click/contextmenu event occurs
      we set the pointer events back to auto for the nav div so it can capture hover and left-click
      events as usual.
     */
    this.$nav.on('mousedown', function(event) {
      if (event.which === 3) {
        self.$nav.css('pointer-events', 'none');

        self.$lightbox.one('contextmenu', function() {
          setTimeout(function() {
              this.$nav.css('pointer-events', 'auto');
          }.bind(self), 0);
        });
      }
    });


    this.$lightbox.find('.lb-loader, .lb-close').on('click', function() {
      self.end();
      return false;
    });
  };

  // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
  Lightbox.prototype.start = function($link) {
    var self    = this;
    var $window = $(window);

    $window.on('resize', $.proxy(this.sizeOverlay, this));

    $('select, object, embed').css({
      visibility: 'hidden'
    });

    this.sizeOverlay();

    this.album = [];
    var imageNumber = 0;

    function addToAlbum($link) {
      self.album.push({
        link: $link.attr('href'),
        title: $link.attr('data-title') || $link.attr('title')
      });
    }

    // Support both data-lightbox attribute and rel attribute implementations
    var dataLightboxValue = $link.attr('data-lightbox');
    var $links;

    if (dataLightboxValue) {
      $links = $($link.prop('tagName') + '[data-lightbox="' + dataLightboxValue + '"]');
      for (var i = 0; i < $links.length; i = ++i) {
        addToAlbum($($links[i]));
        if ($links[i] === $link[0]) {
          imageNumber = i;
        }
      }
    } else {
      if ($link.attr('rel') === 'lightbox') {
        // If image is not part of a set
        addToAlbum($link);
      } else {
        // If image is part of a set
        $links = $($link.prop('tagName') + '[rel="' + $link.attr('rel') + '"]');
        for (var j = 0; j < $links.length; j = ++j) {
          addToAlbum($($links[j]));
          if ($links[j] === $link[0]) {
            imageNumber = j;
          }
        }
      }
    }

    // Position Lightbox
    var top  = $window.scrollTop() + this.options.positionFromTop;
    var left = $window.scrollLeft();
    this.$lightbox.css({
      top: top + 'px',
      left: left + 'px'
    }).fadeIn(this.options.fadeDuration);

    // Disable scrolling of the page while open
    if (this.options.disableScrolling) {
      $('body').addClass('lb-disable-scrolling');
    }

    this.changeImage(imageNumber);
  };

  // Hide most UI elements in preparation for the animated resizing of the lightbox.
  Lightbox.prototype.changeImage = function(imageNumber) {
    var self = this;

    this.disableKeyboardNav();
    var $image = this.$lightbox.find('.lb-image');

    this.$overlay.fadeIn(this.options.fadeDuration);

    $('.lb-loader').fadeIn('slow');
    this.$lightbox.find('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption').hide();

    this.$outerContainer.addClass('animating');

    // When image to show is preloaded, we send the width and height to sizeContainer()
    var preloader = new Image();
    preloader.onload = function() {
      var $preloader;
      var imageHeight;
      var imageWidth;
      var maxImageHeight;
      var maxImageWidth;
      var windowHeight;
      var windowWidth;

      $image.attr('src', self.album[imageNumber].link);

      $preloader = $(preloader);

      $image.width(preloader.width);
      $image.height(preloader.height);

      if (self.options.fitImagesInViewport) {
        // Fit image inside the viewport.
        // Take into account the border around the image and an additional 10px gutter on each side.

        windowWidth    = $(window).width();
        windowHeight   = $(window).height();
        maxImageWidth  = windowWidth - self.containerPadding.left - self.containerPadding.right - self.imageBorderWidth.left - self.imageBorderWidth.right - 20;
        maxImageHeight = windowHeight - self.containerPadding.top - self.containerPadding.bottom - self.imageBorderWidth.top - self.imageBorderWidth.bottom - 120;

        // Check if image size is larger then maxWidth|maxHeight in settings
        if (self.options.maxWidth && self.options.maxWidth < maxImageWidth) {
          maxImageWidth = self.options.maxWidth;
        }
        if (self.options.maxHeight && self.options.maxHeight < maxImageWidth) {
          maxImageHeight = self.options.maxHeight;
        }

        // Is the current image's width or height is greater than the maxImageWidth or maxImageHeight
        // option than we need to size down while maintaining the aspect ratio.
        if ((preloader.width > maxImageWidth) || (preloader.height > maxImageHeight)) {
          if ((preloader.width / maxImageWidth) > (preloader.height / maxImageHeight)) {
            imageWidth  = maxImageWidth;
            imageHeight = parseInt(preloader.height / (preloader.width / imageWidth), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          } else {
            imageHeight = maxImageHeight;
            imageWidth = parseInt(preloader.width / (preloader.height / imageHeight), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          }
        }
      }
      self.sizeContainer($image.width(), $image.height());
    };

    preloader.src          = this.album[imageNumber].link;
    this.currentImageIndex = imageNumber;
  };

  // Stretch overlay to fit the viewport
  Lightbox.prototype.sizeOverlay = function() {
    this.$overlay
      .width($(document).width())
      .height($(document).height());
  };

  // Animate the size of the lightbox to fit the image we are showing
  Lightbox.prototype.sizeContainer = function(imageWidth, imageHeight) {
    var self = this;

    var oldWidth  = this.$outerContainer.outerWidth();
    var oldHeight = this.$outerContainer.outerHeight();
    var newWidth  = imageWidth + this.containerPadding.left + this.containerPadding.right + this.imageBorderWidth.left + this.imageBorderWidth.right;
    var newHeight = imageHeight + this.containerPadding.top + this.containerPadding.bottom + this.imageBorderWidth.top + this.imageBorderWidth.bottom;

    function postResize() {
      self.$lightbox.find('.lb-dataContainer').width(newWidth);
      self.$lightbox.find('.lb-prevLink').height(newHeight);
      self.$lightbox.find('.lb-nextLink').height(newHeight);
      self.showImage();
    }

    if (oldWidth !== newWidth || oldHeight !== newHeight) {
      this.$outerContainer.animate({
        width: newWidth,
        height: newHeight
      }, this.options.resizeDuration, 'swing', function() {
        postResize();
      });
    } else {
      postResize();
    }
  };

  // Display the image and its details and begin preload neighboring images.
  Lightbox.prototype.showImage = function() {
    this.$lightbox.find('.lb-loader').stop(true).hide();
    this.$lightbox.find('.lb-image').fadeIn(this.options.imageFadeDuration);

    this.updateNav();
    this.updateDetails();
    this.preloadNeighboringImages();
    this.enableKeyboardNav();
  };

  // Display previous and next navigation if appropriate.
  Lightbox.prototype.updateNav = function() {
    // Check to see if the browser supports touch events. If so, we take the conservative approach
    // and assume that mouse hover events are not supported and always show prev/next navigation
    // arrows in image sets.
    var alwaysShowNav = false;
    try {
      document.createEvent('TouchEvent');
      alwaysShowNav = (this.options.alwaysShowNavOnTouchDevices) ? true : false;
    } catch (e) {}

    this.$lightbox.find('.lb-nav').show();

    if (this.album.length > 1) {
      if (this.options.wrapAround) {
        if (alwaysShowNav) {
          this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1');
        }
        this.$lightbox.find('.lb-prev, .lb-next').show();
      } else {
        if (this.currentImageIndex > 0) {
          this.$lightbox.find('.lb-prev').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-prev').css('opacity', '1');
          }
        }
        if (this.currentImageIndex < this.album.length - 1) {
          this.$lightbox.find('.lb-next').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-next').css('opacity', '1');
          }
        }
      }
    }
  };

  // Display caption, image number, and closing button.
  Lightbox.prototype.updateDetails = function() {
    var self = this;

    // Enable anchor clicks in the injected caption html.
    // Thanks Nate Wright for the fix. @https://github.com/NateWr
    if (typeof this.album[this.currentImageIndex].title !== 'undefined' &&
      this.album[this.currentImageIndex].title !== '') {
      var $caption = this.$lightbox.find('.lb-caption');
      if (this.options.sanitizeTitle) {
        $caption.text(this.album[this.currentImageIndex].title);
      } else {
        $caption.html(this.album[this.currentImageIndex].title);
      }
      $caption.fadeIn('fast')
        .find('a').on('click', function(event) {
          if ($(this).attr('target') !== undefined) {
            window.open($(this).attr('href'), $(this).attr('target'));
          } else {
            location.href = $(this).attr('href');
          }
        });
    }

    if (this.album.length > 1 && this.options.showImageNumberLabel) {
      var labelText = this.imageCountLabel(this.currentImageIndex + 1, this.album.length);
      this.$lightbox.find('.lb-number').text(labelText).fadeIn('fast');
    } else {
      this.$lightbox.find('.lb-number').hide();
    }

    this.$outerContainer.removeClass('animating');

    this.$lightbox.find('.lb-dataContainer').fadeIn(this.options.resizeDuration, function() {
      return self.sizeOverlay();
    });
  };

  // Preload previous and next images in set.
  Lightbox.prototype.preloadNeighboringImages = function() {
    if (this.album.length > this.currentImageIndex + 1) {
      var preloadNext = new Image();
      preloadNext.src = this.album[this.currentImageIndex + 1].link;
    }
    if (this.currentImageIndex > 0) {
      var preloadPrev = new Image();
      preloadPrev.src = this.album[this.currentImageIndex - 1].link;
    }
  };

  Lightbox.prototype.enableKeyboardNav = function() {
    $(document).on('keyup.keyboard', $.proxy(this.keyboardAction, this));
  };

  Lightbox.prototype.disableKeyboardNav = function() {
    $(document).off('.keyboard');
  };

  Lightbox.prototype.keyboardAction = function(event) {
    var KEYCODE_ESC        = 27;
    var KEYCODE_LEFTARROW  = 37;
    var KEYCODE_RIGHTARROW = 39;

    var keycode = event.keyCode;
    var key     = String.fromCharCode(keycode).toLowerCase();
    if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
      this.end();
    } else if (key === 'p' || keycode === KEYCODE_LEFTARROW) {
      if (this.currentImageIndex !== 0) {
        this.changeImage(this.currentImageIndex - 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(this.album.length - 1);
      }
    } else if (key === 'n' || keycode === KEYCODE_RIGHTARROW) {
      if (this.currentImageIndex !== this.album.length - 1) {
        this.changeImage(this.currentImageIndex + 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(0);
      }
    }
  };

  // Closing time. :-(
  Lightbox.prototype.end = function() {
    this.disableKeyboardNav();
    $(window).off('resize', this.sizeOverlay);
    this.$lightbox.fadeOut(this.options.fadeDuration);
    this.$overlay.fadeOut(this.options.fadeDuration);
    $('select, object, embed').css({
      visibility: 'visible'
    });
    if (this.options.disableScrolling) {
      $('body').removeClass('lb-disable-scrolling');
    }
  };

  return new Lightbox();
}));

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export localeToLangParam */
/* harmony export (immutable) */ __webpack_exports__["b"] = langParamToLocale;
/* unused harmony export getUrlLangParam */
/* harmony export (immutable) */ __webpack_exports__["a"] = syncLocaleFromUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateUrlLangParam;
/* harmony export (immutable) */ __webpack_exports__["e"] = withLocaleHashPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = resolveMenuLinkUrl;
/* unused harmony export responseDataGroupByTitle */


// URL L 參數 ↔ sessionStorage.locale（EN / CH）
// 格式：#/photo?L=EN（英文）、#/photo?L=TW 或不帶參數（中文）
// 亦相容舊格式：?L=EN#/photo

function localeToLangParam(locale) {
    return locale === 'EN' ? 'EN' : 'TW';
}

function langParamToLocale(langParam) {
    var value = (langParam || '').toUpperCase();
    if (value === 'EN') return 'EN';
    if (value === 'TW' || value === 'CH') return 'CH';
    return null;
}

function getQueryValue(queryString, key) {
    if (!queryString) return null;
    var match = queryString.match(new RegExp('(?:^|&)' + key + '=([^&]*)', 'i'));
    return match ? decodeURIComponent(match[1]) : null;
}

function setQueryValue(queryString, key, value) {
    var pairs = [];
    var found = false;
    if (queryString) {
        queryString.split('&').forEach(function (pair) {
            if (!pair) return;
            var parts = pair.split('=');
            var name = parts[0];
            if (name.toLowerCase() === key.toLowerCase()) {
                if (value != null && value !== '') {
                    pairs.push(key + '=' + encodeURIComponent(value));
                }
                found = true;
                return;
            }
            pairs.push(pair);
        });
    }
    if (!found && value != null && value !== '') {
        pairs.push(key + '=' + encodeURIComponent(value));
    }
    return pairs.join('&');
}

function getUrlLangParam() {
    // 優先讀 hash query：#/photo?L=EN
    var hash = window.location.hash || '';
    var qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        var fromHash = getQueryValue(hash.substring(qIndex + 1), 'L');
        if (fromHash) return fromHash;
    }

    // 相容：?L=EN#/...
    try {
        var params = new URLSearchParams(window.location.search);
        var fromSearch = params.get('L');
        if (fromSearch) return fromSearch;
    } catch (error) {
        var match = window.location.search.match(/[?&]L=([^&]*)/i);
        if (match) return decodeURIComponent(match[1]);
    }
    return null;
}

// 進站時依 URL L 寫入語系；有參數以 URL 為準，不帶參數一律中文
function syncLocaleFromUrl() {
    var localeFromUrl = langParamToLocale(getUrlLangParam());
    var locale = localeFromUrl || 'CH';
    sessionStorage.setItem('locale', locale);
    normalizeLangParamToHash(locale, !!localeFromUrl);
    return locale;
}

// 將 L 統一寫入 hash query，並清掉 search 上的 L
function normalizeLangParamToHash(locale, hasLangInUrl) {
    var hash = window.location.hash || '#/';
    var pathPart = hash;
    var queryPart = '';
    var qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        pathPart = hash.substring(0, qIndex);
        queryPart = hash.substring(qIndex + 1);
    }
    if (!pathPart || pathPart === '#') pathPart = '#/';

    var nextQuery = queryPart;
    if (hasLangInUrl) {
        nextQuery = setQueryValue(queryPart, 'L', localeToLangParam(locale));
    } else {
        nextQuery = setQueryValue(queryPart, 'L', null);
    }

    var nextHash = nextQuery ? pathPart + '?' + nextQuery : pathPart;

    var search = window.location.search;
    if (/[?&]L=/i.test(search)) {
        search = search.replace(/([?&])L=[^&]*/i, '$1').replace(/\?&/, '?').replace(/[?&]$/, '').replace(/\?&/, '?');
        if (search === '?') search = '';
    }

    var next = window.location.pathname + search + nextHash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next !== current) {
        window.history.replaceState(null, '', next);
    }
}

// 語系切換時更新 hash query：英文 ?L=EN、中文移除 L（等同不帶參數）
function updateUrlLangParam(locale) {
    var hash = window.location.hash || '#/';
    var pathPart = hash;
    var queryPart = '';
    var qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        pathPart = hash.substring(0, qIndex);
        queryPart = hash.substring(qIndex + 1);
    }
    if (!pathPart || pathPart === '#') pathPart = '#/';

    var nextQuery = locale === 'EN' ? setQueryValue(queryPart, 'L', 'EN') : setQueryValue(queryPart, 'L', null);

    var nextHash = nextQuery ? pathPart + '?' + nextQuery : pathPart;

    var search = window.location.search;
    if (/[?&]L=/i.test(search)) {
        search = search.replace(/([?&])L=[^&]*/i, '$1').replace(/\?&/, '?').replace(/[?&]$/, '').replace(/\?&/, '?');
        if (search === '?') search = '';
    }

    var nextUrl = window.location.pathname + search + nextHash;
    window.history.replaceState(null, '', nextUrl);
    return nextUrl;
}

// 站內 hash 路徑補上目前語系 L（英文必帶 ?L=EN）
function withLocaleHashPath(path) {
    var raw = path || '';
    if (raw.indexOf('http') === 0) return raw;

    var hashPath = raw.charAt(0) === '#' ? raw : '#/' + raw.replace(/^\//, '');
    var locale = sessionStorage.getItem('locale') || 'CH';
    if (locale !== 'EN') {
        // 中文：拿掉 L，避免殘留英文參數
        var qIndexCh = hashPath.indexOf('?');
        if (qIndexCh === -1) return hashPath;
        var pathPartCh = hashPath.substring(0, qIndexCh);
        var nextQueryCh = setQueryValue(hashPath.substring(qIndexCh + 1), 'L', null);
        return nextQueryCh ? pathPartCh + '?' + nextQueryCh : pathPartCh;
    }

    var qIndex = hashPath.indexOf('?');
    var pathPart = qIndex === -1 ? hashPath : hashPath.substring(0, qIndex);
    var queryPart = qIndex === -1 ? '' : hashPath.substring(qIndex + 1);
    var nextQuery = setQueryValue(queryPart, 'L', 'EN');
    return pathPart + '?' + nextQuery;
}

// 依語系補上場地租借 L 參數（選單僅有單一 linkUrl，無英文專用欄位）
function resolveMenuLinkUrl(linkUrl) {
    if (!linkUrl || !linkUrl.includes('http')) {
        return linkUrl;
    }

    if (linkUrl.indexOf('rent.pe.ntu.edu.tw') === -1) {
        return linkUrl;
    }

    var locale = sessionStorage.getItem('locale') || 'CH';
    var langParam = localeToLangParam(locale);

    try {
        var url = new URL(linkUrl);
        url.searchParams.set('L', langParam);
        return url.toString();
    } catch (error) {
        if (/[?&]L=/i.test(linkUrl)) {
            return linkUrl.replace(/([?&]L=)[^&]*/i, '$1' + langParam);
        }
        var separator = linkUrl.indexOf('?') !== -1 ? '&' : '?';
        return linkUrl + separator + 'L=' + langParam;
    }
}

function responseDataGroupByTitle(data, groupBy) {
    var myJSON = {};

    for (var i = 0; i < data.length; i++) {
        var title = data[i][groupBy];
        var row = data[i];

        if (!myJSON[title]) myJSON[title] = [];

        myJSON[title].push(row);
    }
    return myJSON;
}

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_404__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Page__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Class__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_News__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_News__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_NewsSub__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_NewsSub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_NewsSub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Video__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_GuestBook__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_GuestBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_GuestBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_NewGuestBook__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_NewGuestBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_NewGuestBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Photo__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Photo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Site__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Site___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Site__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_SiteInfo__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_SiteInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_SiteInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Journal__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Journal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_Journal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_JournalContent__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_JournalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_JournalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Team__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Member__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Member___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Member__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Administrative__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Administrative___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_Administrative__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Teacher__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Teacher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_Teacher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_ClassItem__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_ClassItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_ClassItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_SignUp__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_CoachInfo__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_CoachInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_CoachInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Facility__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Facility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_Facility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_ClassInside__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_ClassInside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_ClassInside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_TeacherInfo__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_TeacherInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_TeacherInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_TeacherBasic__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_TeacherBasic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_TeacherBasic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_TeacherBook__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_TeacherBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_TeacherBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_TeacherEdu__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_TeacherEdu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_TeacherEdu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_TeacherJournal__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_TeacherJournal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_TeacherJournal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_TeacherPrize__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_TeacherPrize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_TeacherPrize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_TeacherResearch__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_TeacherResearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_TeacherResearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_TeacherSeminar__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_TeacherSeminar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_TeacherSeminar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_TeacherCustom__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_TeacherCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_TeacherCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_PhotoIn__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_PhotoIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_PhotoIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_TeamType__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_TeamType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_TeamType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_TeamInfo__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_TeamInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_TeamInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__assets_library_commonFunction__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_breadcrumbs__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vue_breadcrumbs__);















































// 進站依 hash ?L=EN / ?L=TW 設定語系（不帶參數一律中文）
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__assets_library_commonFunction__["a" /* syncLocaleFromUrl */])();
sessionStorage.locale = sessionStorage.locale || 'CH';

var title = {
  home: { CH: '首頁', EN: 'Home' },
  class: { CH: '運動指導班', EN: 'Class' },
  class_item: { CH: '報名班別', EN: 'Apply Class' },
  class_sign: { CH: '課程報名', EN: 'Class_Sign' },
  coach_info: { CH: '教練簡介', EN: 'Coach_Info' },
  facility: { CH: '場地設施', EN: 'Facility' },
  class_inside: { CH: '上課注意事項', EN: 'Note' },
  news: { CH: '最新消息', EN: 'News' },
  news_sub: { CH: '消息', EN: 'News' },
  video: { CH: '影片', EN: 'Video' },
  guest_book: { CH: '留言板', EN: 'Guest_book' },
  new_guest_book: { CH: '留言板', EN: 'Guest_book' },
  photo: { CH: '相簿', EN: 'Photo' },
  photo_in: { CH: '相簿', EN: 'Photo_In' },
  site: { CH: '場地介紹', EN: 'Site' },
  site_info: { CH: '場地', EN: 'Site_Info' },
  team: { CH: '體育代表隊介紹', EN: 'Team' },
  team_type: { CH: '體育代表隊', EN: 'TeamType' },
  team_info: { CH: '代表隊介紹', EN: 'Team_Info' },
  journal: { CH: '期刊及學報', EN: 'Journal' },
  journal_info: { CH: '內容', EN: 'Journal_Info' },
  member: { CH: '成員介紹', EN: 'member' },
  administrative: { CH: '行政成員介紹', EN: 'AdministrativeMember' },
  teacher: { CH: '師資介紹', EN: 'Teacher' },
  teacher_basic: { CH: '個人資料', EN: 'Teacher_Basic' },
  teacher_book: { CH: '專書及專書論文', EN: 'Teacher_Book' },
  teacher_edu: { CH: '學歷＆課程', EN: 'Teacher_Edu' },
  teacher_journal: { CH: '期刊論文', EN: 'Teacher_Journal' },
  teacher_prize: { CH: '獲獎＆學歷', EN: 'Teacher_Prize' },
  teacher_research: { CH: '專題研究報告及其他', EN: 'Teacher_Research' },
  teacher_seminar: { CH: '研討會論文', EN: 'Teacher_Seminar' },
  teacher_custom: { CH: '師資介紹', EN: 'Teacher_Custom' },
  page: { CH: '其他頁面', EN: 'Page' }
};



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_breadcrumbs___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  routes: [
  // { path: '*', redirect: '/404' },
  {
    path: '/404',
    name: '404',
    meta: { title: 'Page not found' },
    component: __WEBPACK_IMPORTED_MODULE_3__pages_404___default.a
  }, {
    path: '/',
    name: 'home',
    meta: {
      title: '國立臺灣大學體育室',
      keepAlive: true,
      breadcrumb: title.home[sessionStorage.locale]
    },
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Home___default.a,
    children: [{
      path: 'class',
      name: 'class',
      meta: {
        title: title.class[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.class[sessionStorage.locale],
        keepAliveSub: false
      },
      component: __WEBPACK_IMPORTED_MODULE_6__pages_Class___default.a,
      children: [{
        path: ':classid/class_item',
        name: 'class_item',
        meta: {
          title: title.class_item[sessionStorage.locale],
          keepAliveSub: true,
          keepAliveSub2: false,
          breadcrumb: title.class_item[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_21__pages_ClassItem___default.a,
        children: [{
          path: ':classname/:admissionsid/sign_up',
          name: 'class_sign',
          meta: {
            title: title.class_sign[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.class_sign[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_22__pages_SignUp___default.a
        }, {
          path: ':classname/coach',
          name: 'coach_info',
          meta: {
            title: title.coach_info[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.coach_info[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_23__pages_CoachInfo___default.a
        }, {
          path: ':classname/facility',
          name: 'facility',
          meta: {
            title: title.facility[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.facility[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_24__pages_Facility___default.a
        }, {
          path: ':classname/note',
          name: 'class_inside',
          meta: {
            title: title.class_inside[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.class_inside[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_25__pages_ClassInside___default.a
        }]
      }]
    }, {
      path: 'news',
      name: 'news',
      meta: {
        title: title.news[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.news[sessionStorage.locale],
        keepAliveSub: false
      },
      component: __WEBPACK_IMPORTED_MODULE_7__pages_News___default.a,
      children: [{
        path: ':newsid/news',
        name: 'news_sub',
        meta: {
          title: title.news_sub[sessionStorage.locale],
          keepAliveSub: true,
          breadcrumb: title.news_sub[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_8__pages_NewsSub___default.a
      }]
    }, {
      path: 'video',
      name: 'video',
      meta: {
        title: title.video[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.video[sessionStorage.locale],
        keepAliveSub: false
      },
      component: __WEBPACK_IMPORTED_MODULE_9__pages_Video___default.a
    }, {
      path: 'guest_book',
      name: 'guest_book',
      meta: {
        title: title.guest_book[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.guest_book[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_10__pages_GuestBook___default.a
    }, {
      path: 'new_guest_book',
      name: 'new_guest_book',
      meta: {
        title: title.new_guest_book[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.new_guest_book[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_11__pages_NewGuestBook___default.a
    }, {
      path: 'photo',
      name: 'photo',
      meta: {
        title: title.photo[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.photo[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_12__pages_Photo___default.a,
      children: [{
        path: ':albumId/photo_in',
        name: 'photo_in',
        meta: {
          title: title.photo_in[sessionStorage.locale],
          keepAliveSub: true
        },
        component: __WEBPACK_IMPORTED_MODULE_35__pages_PhotoIn___default.a
      }]
    }, {
      path: 'site',
      name: 'site',
      meta: {
        title: title.site[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.site[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_13__pages_Site___default.a,
      children: [{
        path: ':site/site_info',
        name: 'site_info',
        meta: {
          title: title.site_info[sessionStorage.locale],
          keepAliveSub: true,
          breadcrumb: title.site_info[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_14__pages_SiteInfo___default.a
      }]
    }, {
      path: 'team',
      name: 'team',
      meta: {
        title: title.team[sessionStorage.locale],
        keepAliveSub: true,
        breadcrumb: title.team[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_17__pages_Team___default.a,
      children: [{
        path: ':teamtypeid/team_type',
        name: 'team_type',
        meta: {
          title: title.team_type[sessionStorage.locale],
          keepAliveSub2: true,
          breadcrumb: title.team_type[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_36__pages_TeamType___default.a,
        children: [{
          path: ':teamid/team_info',
          name: 'team_info',
          meta: {
            title: title.team_info[sessionStorage.locale],
            keepAliveSub3: true,
            breadcrumb: title.team_info[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_37__pages_TeamInfo___default.a
        }]
      }]
    }, {
      path: 'journal',
      name: 'journal',
      meta: {
        title: title.journal[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.journal[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_15__pages_Journal___default.a,
      children: [{
        path: ':journalid/content',
        name: 'journal_info',
        meta: {
          title: title.journal_info[sessionStorage.locale],
          keepAliveSub: true,
          breadcrumb: title.journal_info[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_16__pages_JournalContent___default.a
      }]
    }, {
      path: 'member',
      name: '',
      meta: {
        title: title.member[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.member[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_18__pages_Member___default.a,
      children: [{
        path: 'administrative',
        name: 'administrative',
        meta: {
          title: title.administrative[sessionStorage.locale],
          keepAlive: false,
          breadcrumb: title.administrative[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_19__pages_Administrative___default.a
      }, {
        path: 'teacher',
        name: 'teacher',
        meta: {
          title: title.teacher[sessionStorage.locale],
          keepAlive: false,
          breadcrumb: title.teacher[sessionStorage.locale],
          keepAliveSub: false
        },
        component: __WEBPACK_IMPORTED_MODULE_20__pages_Teacher___default.a,
        children: [{
          path: ':teacherid/',
          name: 'teacher_info',
          meta: {
            title: 'xxx',
            keepAliveSub: true
          },
          component: __WEBPACK_IMPORTED_MODULE_26__pages_TeacherInfo___default.a,
          children: [{
            path: 'basic',
            name: 'teacher_basic',
            meta: {
              title: title.teacher_basic[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_basic[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_27__pages_TeacherBasic___default.a
          }, {
            path: 'book',
            name: 'teacher_book',
            meta: {
              title: title.teacher_book[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_book[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_28__pages_TeacherBook___default.a
          }, {
            path: 'edu',
            name: 'teacher_edu',
            meta: {
              title: title.teacher_edu[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_edu[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_29__pages_TeacherEdu___default.a
          }, {
            path: 'journal',
            name: 'teacher_journal',
            meta: {
              title: title.teacher_journal[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_journal[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_30__pages_TeacherJournal___default.a
          }, {
            path: 'prize',
            name: 'teacher_prize',
            meta: {
              title: title.teacher_prize[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_prize[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_31__pages_TeacherPrize___default.a
          }, {
            path: 'research',
            name: 'teacher_research',
            meta: {
              title: title.teacher_research[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_research[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_32__pages_TeacherResearch___default.a
          }, {
            path: 'seminar',
            name: 'teacher_seminar',
            meta: {
              title: title.teacher_seminar[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_seminar[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_33__pages_TeacherSeminar___default.a
          }, {
            path: ':custom',
            name: 'teacher_custom',
            meta: {
              title: title.teacher_custom[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_custom[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_34__pages_TeacherCustom___default.a
          }]
        }]
      }]
    }, {
      path: ':pageName',
      name: 'page',
      meta: {
        title: title.page[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.page[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_5__pages_Page___default.a
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title;

  var toLang = to.query && to.query.L;
  var localeFromTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__assets_library_commonFunction__["b" /* langParamToLocale */])(toLang);

  // 目標網址已有 L：以 URL 為準
  if (localeFromTo) {
    sessionStorage.setItem('locale', localeFromTo);
    next();
    return;
  }

  // 從英文頁站內導向但漏帶 L 時，自動補上 ?L=EN（維持英文瀏覽）
  var fromIsEn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38__assets_library_commonFunction__["b" /* langParamToLocale */])(from.query && from.query.L) === 'EN';
  if (fromIsEn && sessionStorage.getItem('locale') === 'EN') {
    next({
      path: to.path,
      name: to.name,
      params: to.params,
      query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, to.query, { L: 'EN' }),
      hash: to.hash,
      replace: true
    });
    return;
  }

  // 不帶 L：中文
  sessionStorage.setItem('locale', 'CH');
  next();
});

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(891)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1202),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'administrative',
  data: function data() {
    return {
      admins: [],
      currentPage: 1,
      pagesize: 10,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initAdmins();
    },
    initAdmins: function initAdmins() {
      this.getAdminsData();
    },
    getAdminsData: function getAdminsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].admin).then(function (response) {
        _this.admins = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    showJobTitle: function showJobTitle(admin) {
      var jobTitle = { 'CH': admin.jobTitleCh, 'EN': admin.jobTitleEn };
      return jobTitle[sessionStorage.locale];
    },
    showGroup: function showGroup(admin) {
      var group = {
        'CH': ['無', '體育教學組', '體育活動組', '場地設備組', '法醫校區體育組', '主任室'],
        'EN': ['none', 'Curriculum Section', 'Activities Section', 'Site Section', 'Forensic Section', 'Director Office']
      };
      return group[sessionStorage.locale][admin.activityGroup];
    },
    showName: function showName(admin) {
      var name = { 'CH': admin.nameCh, 'EN': admin.nameEn };
      return name[sessionStorage.locale];
    },
    showIntroduction: function showIntroduction(admin) {
      var introduction = { 'CH': admin.introductionCh, 'EN': admin.introductionEn };
      return introduction[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'class',
  data: function data() {
    return {

      classes: [],
      nowClassitem: '',
      course: '',
      locale: sessionStorage.getItem('locale')
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initCourse();
      this.initClasses();
    },
    initClasses: function initClasses() {
      this.getClassesData();
    },
    initCourse: function initCourse() {
      this.getCourseData();
    },
    getClassesData: function getClassesData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].class + '?courseid=1').then(function (response) {
        _this.classes = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    initCourses: function initCourses() {
      this.getCoursesData();
    },
    initClass: function initClass(classitem) {
      this.nowClassitem = classitem;
    },
    getCourseData: function getCourseData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].course + '?id=1').then(function (response) {
        _this2.course = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    selectClass: function selectClass(classitem) {
      this.nowClassitem = classitem;
      this.$router.push({ name: 'class_item', params: { classid: classitem.id } });
    },
    showName: function showName(classitem) {
      return sessionStorage.locale === 'CH' ? classitem.nameCh : classitem.nameEn;
    },
    showIntroduction: function showIntroduction() {
      return sessionStorage.locale === 'CH' ? this.course.introductionCh : this.course.introductionEn;
    },
    showApplication: function showApplication() {
      return sessionStorage.locale === 'CH' ? this.course.applicationCh : this.course.applicationEn;
    }
  }
});

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'class_inside',
  props: ['classitem'],
  data: function data() {
    return {
      className: this.$route.params.classname,
      locale: sessionStorage.getItem('locale'),
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    showNote: function showNote() {
      return sessionStorage.locale === 'CH' ? this.classitem.noteCh : this.classitem.noteEn;
    }
  }
});

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'class_item',
  props: ['classitem'],
  data: function data() {
    return {
      classId: this.$route.params.classid,
      admissions: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      className: ''
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initAdmissions();
      this.initParentClass();
    },
    initParentClass: function initParentClass() {
      if (!this.classitem) {
        this.getClassData();
      }
    },
    initAdmissions: function initAdmissions() {
      this.getAdmissionsData();
    },
    getClassData: function getClassData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].class + ('?id=' + this.classId)).then(function (response) {
        _this.$emit('initClass', response.data);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getAdmissionsData: function getAdmissionsData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].classadmissions + ('?classId=' + this.classId)).then(function (response) {
        _this2.admissions = response.data;
        _this2.handleReceivedAdmissions();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    handleReceivedAdmissions: function handleReceivedAdmissions() {
      this.admissions.forEach(function (admission) {
        try {
          admission.memberType = JSON.parse(admission.memberType);
          admission.memberType = admission.memberType.map(function (el) {
            if (sessionStorage.locale === 'CH') return el == 1 ? '成人' : '兒童';else return el == 1 ? 'Adult' : 'Child';
          }).toString().replace(',', '/');
        } catch (error) {}
      }, this);
    },
    signUp: function signUp(id) {
      this.$router.push({ name: 'class_sign', params: { classname: this.showName(), admissionsid: id } });
    },
    classTypeName: function classTypeName(admission) {
      if (sessionStorage.locale === 'CH') {
        var level = ['', '初階', '進階', '矯正'],
            maxPersonal = ['零', '一', '二', '三', '四', '五'];
        if (admission.type === 1) {
          return admission.maxPersonal + level[admission.classLevel] + '班';
        } else if (admission.type === 2) {
          return '團體' + level[admission.classLevel] + '班';
        }
      } else {
        var _level = ['', 'Beginner', 'Advanced', 'Correction'],
            _maxPersonal = ['zero', 'one', 'two', 'three', 'four', 'five'];
        if (admission.type === 1) {
          return admission.maxPersonal + ' ' + _level[admission.classLevel] + ' class';
        } else if (admission.type === 2) {
          return 'Group ' + _level[admission.classLevel] + ' Class';
        }
      }
    },
    showName: function showName() {
      return sessionStorage.locale === 'CH' ? this.classitem.nameCh : this.classitem.nameEn;
    },
    showIntroduction: function showIntroduction() {
      return sessionStorage.locale === 'CH' ? this.classitem.introductionCh : this.classitem.introductionEn;
    },
    showNote: function showNote() {
      return sessionStorage.locale === 'CH' ? this.classitem.noteCh : this.classitem.noteEn;
    },
    memberRange: function memberRange(admission) {
      if (admission.minMember == admission.maxMember) {
        return admission.maxMember;
      } else {
        return admission.minMember + '~' + admission.maxMember;
      }
    }
  }
});

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'coach_info',
  data: function data() {
    return {
      classId: this.$route.params.classid,
      coachs: [],
      className: this.$route.params.classname,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initCoachs();
    },
    initCoachs: function initCoachs() {
      this.getCoachsData();
    },
    getCoachsData: function getCoachsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].classcoach + ('?classid=' + this.classId)).then(function (response) {
        _this.coachs = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    showName: function showName(coach) {
      return sessionStorage.locale === 'CH' ? coach.nameCh : coach.nameEn;
    },
    showSex: function showSex(sex) {
      return sessionStorage.locale === 'CH' ? sex ? '男' : '女' : sex ? 'male' : 'Female';
    },
    showLicense: function showLicense(coach) {
      return sessionStorage.locale === 'CH' ? coach.licenseCh : coach.licenseEn;
    },
    showHistory: function showHistory(coach) {
      return sessionStorage.locale === 'CH' ? coach.historyCh : coach.historyEn;
    }
  }
});

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'facility',
  props: ['classitem'],
  data: function data() {
    return {
      className: this.$route.params.classname,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    showSite: function showSite() {
      return sessionStorage.locale === 'CH' ? this.classitem.siteCh : this.classitem.siteEn;
    }
  }
});

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'guest_book',
  data: function data() {
    return {
      spinShow: true,
      books: [],
      currentPage: 1,
      pagesize: 10,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    changeBreak: function changeBreak(str) {
      var index = 0;
      var index2 = 0;
      while (str.indexOf("\n", index) != -1) {
        str = str.replace("\n", "<br />");
        index = str.indexOf("\n", index);
      }
      while (str.indexOf("&#10;", index2) != -1) {
        str = str.replace("&#10;", "<br />");
        index2 = str.indexOf("&#10;", index2);
      }

      return str;
    },
    init: function init() {
      this.initBooks();
    },
    initBooks: function initBooks() {
      this.getBooksData();
    },
    getBooksData: function getBooksData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].message).then(function (response) {
        //for (var i = response.data.length - 1; i >= 0; i--) {
        //  this.books.push(response.data[i])
        //}
        _this.books = response.data;
        _this.books = _this.books.filter(function (data) {
          return data.trash !== 1 && data.isDisplay === 1;
        });
      }).then(function () {
        _this.spinShow = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    }
  }
});

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_jquery_latest_min_js__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_home_js__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_library_commonFunction__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_HomeNotice_vue__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_HomeNotice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_HomeNotice_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    HomeNotice: __WEBPACK_IMPORTED_MODULE_8__pages_HomeNotice_vue___default.a
  },
  data: function data() {
    return {
      notices: [
        // {
        //  createdAt: '',
        //  title: '',
        //  typeId: '',
        // keepTop: '',
        // }
      ],
      types: [{
        id: 0,
        nameCh: '最新消息',
        nameEn: 'latest news',
        homeDisplay: 1
      }],
      type: { id: 0 },
      noticepictures: [],
      videos: [],
      video: '',
      menu: [],
      course: {},
      classes: [],
      alert: [],
      modal: false,
      nowRocYear: '',
      links: [],
      locale: sessionStorage.getItem('locale'),
      news: { CH: '最新消息', EN: 'latest news' },
      academicYear: { CH: '學年度', EN: ' Academic Year ' },
      homeTitle: { CH: '臺灣大學體育室', EN: 'Department of Athletics, NTU' },
      footTitle: { CH: '國立臺灣大學體育室', EN: 'National Taiwan University Gymnasium' },

      footContent1: { CH: '地址：臺北市羅斯福路四段一號', EN: 'Address: No. 1, Sec. 4, Roosevelt Road, Taipei, 10617 Taiwan(R.O.C)' },
      footContent2: {
        CH: '信箱：ntupe@ntu.edu.tw',
        EN: 'Mail：ntupe@ntu.edu.tw'
      },

      homeInfoCh: "",
      homeInfoEn: "",
      nowYear: ''

    };
  },
  created: function created() {
    if (!sessionStorage.locale) {
      sessionStorage.setItem('locale', 'CH');
      this.locale = 'CH';
    }
    this.nowYear = new Date().getFullYear();
    this.init();
  },


  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_2__static_js_jquery_latest_min_js__["a" /* default */].init();
    });
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_2__static_js_jquery_latest_min_js__["a" /* default */].init();
    __WEBPACK_IMPORTED_MODULE_3__static_js_home_js__["a" /* default */].init();
    __WEBPACK_IMPORTED_MODULE_3__static_js_home_js__["a" /* default */].test();
  },

  methods: {
    init: function init() {
      this.showPage();
      this.initNowRocYear();
      this.initNotice();
      this.initTypes();
      this.initVideo();
      this.initMenu();
      this.initCourse();

      this.initLinks();
      this.getAlert();
    },
    initNowRocYear: function initNowRocYear() {
      var now = new Date();
      this.nowRocYear = now.getFullYear() - 1910;
    },
    initTypes: function initTypes() {
      this.getTypesData();
    },
    initNotice: function initNotice() {
      this.getNoticeData();
    },
    initVideo: function initVideo() {
      this.getVideoData();
    },
    initMenu: function initMenu() {
      this.getMenuData();
    },
    initCourse: function initCourse() {
      this.getCourseData();
    },
    initClasses: function initClasses() {
      this.getClassesData();
    },
    initLinks: function initLinks() {
      this.getlinksData();
    },
    getAlert: function getAlert() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].setting + "?id=1").then(function (response) {
        _this.alert = response.data;
        _this.homeInfoCh = response.data.homeInfoCh;
        _this.homeInfoEn = response.data.homeInfoEn;
      }).then(function () {
        if (_this.alert && _this.alert.isActive == 1) {
          alert(_this.alert.context);
          // this.modal = true
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getNoticeData: function getNoticeData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].notice + "?groupTop=8").then(function (response) {
        _this2.notices = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this2.handleReceivedNotices();
        _this2.getNoticePictures();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    getTypesData: function getTypesData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].code + "?type=2").then(function (response) {
        _this3.types = _this3.types.concat(response.data.filter(function (data) {
          return data.trash !== 1 && data.homeDisplay === 1;
        }));
        // this.type = this.types.filter(type => {
        //   return type.homeDisplay === 1;
        // })[0];
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this3)(error);
      });
    },
    getVideoData: function getVideoData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].video).then(function (response) {
        _this4.videos = response.data;
        while (1) {
          var random = Math.floor(Math.random() * _this4.videos.length);
          if (_this4.videos[random].fileUrl) {
            _this4.video = _this4.videos[random];
            break;
          }
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this4)(error);
      });
    },
    getMenuData: function getMenuData() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].menu + '/tree').then(function (response) {
        _this5.menu = response.data.baseData;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this5)(error);
      });
    },
    getNoticePictures: function getNoticePictures() {
      var _this6 = this;

      this.notices.forEach(function (notice) {
        if (notice.pictures) {
          notice.pictures.forEach(function (picture) {
            if (!picture.file_url) return;
            var newnotice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, notice);
            newnotice.pictures = picture.file_url;
            _this6.noticepictures.push(newnotice);
          }, _this6);
        }
      }, this);
    },
    getCourseData: function getCourseData() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].course)
      // axios.get(API.course + '?id=1')
      .then(function (response) {
        var course = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this7.course = course[course.length - 1];
      }).then(function () {
        _this7.initClasses();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this7)(error);
      });
    },
    getClassesData: function getClassesData() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].class + ("?courseid=" + this.course.id)).then(function (response) {
        _this8.classes = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this8)(error);
      });
    },
    getlinksData: function getlinksData() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].link).then(function (response) {
        _this9.links = response.data.filter(function (data) {
          return data.trash !== 1 && data.isActive === 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this9)(error);
      });
    },
    handleReceivedNotices: function handleReceivedNotices() {
      this.notices.sort(function (a, b) {
        var ac = a.createdAt.split(' '),
            acd = ac[0].split('-'),
            act = ac[1].split(':'),
            bc = b.createdAt.split(' '),
            bcd = bc[0].split('-'),
            bct = bc[1].split(':');
        var aDate = new Date(acd[0], acd[1] - 1, acd[2], act[0], act[1], act[2]),
            bDate = new Date(bcd[0], bcd[1] - 1, bcd[2], bct[0], bct[1], bct[2]);

        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    pushToClassItem: function pushToClassItem(id) {
      this.$router.push({ name: 'class_item', params: { classid: id } });
    },
    selectType: function selectType(type) {
      this.type = type;
    },
    subMenu: function subMenu(data) {
      if (data.target.attributes.var) {
        $(".sub[var=\"" + data.target.attributes.var.value + "\"]").slideToggle();
      } else {
        $('.sub').slideUp();
      }
    },
    pushToNewsSub: function pushToNewsSub(newsitem) {
      if (newsitem.linkType !== 1) return;
      this.newsitem = newsitem;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target: function target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href: function href(newsitem) {
      if (newsitem.linkType === 2 && newsitem.externalLink) return newsitem.externalLink;
      return undefined;
    },
    setLocale: function setLocale(lanuage) {
      sessionStorage.setItem('locale', lanuage);
      // 同步為 #/path?L=EN（英文）或不帶 L（中文）
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_library_commonFunction__["c" /* updateUrlLangParam */])(lanuage);
      if (this.$route.name === 'coach_info' || this.$route.name === 'facility' || this.$route.name === 'class_inside') {
        var query = lanuage === 'EN' ? { L: 'EN' } : {};
        this.$router.push({ name: 'class_item', params: { classid: this.$route.params.classid }, query: query });
      }
      window.location.reload();
    },
    showPage: function showPage() {
      this.academicYear = this.academicYear[this.locale];
      this.homeTitle = this.homeTitle[this.locale];
      this.footTitle = this.footTitle[this.locale];
      this.footContent1 = this.footContent1[this.locale];
      this.footContent2 = this.footContent2[this.locale];
      this.news = this.news[this.locale];
    },
    showTitle: function showTitle(itemone) {
      return sessionStorage.locale === 'CH' ? itemone.titleCh : itemone.titleEn;
    },
    showType: function showType(type) {
      return sessionStorage.locale === 'CH' ? type.nameCh : type.nameEn;
    },
    showCourseName: function showCourseName() {
      var show = { CH: this.course.nameCh, EN: this.course.nameEn };
      return show[sessionStorage.locale];
    },
    checkTitle: function checkTitle(itemone) {
      var show = { CH: itemone.titleCh, EN: itemone.titleEn };
      return show[sessionStorage.locale] ? true : false;
    },
    resolveLinkUrl: function resolveLinkUrl(linkUrl) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_library_commonFunction__["d" /* resolveMenuLinkUrl */])(linkUrl);
    },
    linkUrl: function linkUrl(item) {
      var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_library_commonFunction__["d" /* resolveMenuLinkUrl */])(item.linkUrl);
      if (url.includes('http')) {
        if (item.openMode == 2) {
          window.open(url, '_blank');
        } else {
          location.href = url;
        }
      } else {
        location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_library_commonFunction__["e" /* withLocaleHashPath */])(url);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'tab_container',
  props: ['type', 'notices'],
  data: function data() {
    return {
      newsitem: '',
      locale: sessionStorage.getItem('locale')
    };
  },

  computed: {
    topNotice: function topNotice() {
      var _this = this;

      var arr = this.notices;
      arr = arr.filter(function (item) {
        return (item.typeId == _this.type.id || _this.type.id === 0) && item.isTop && item.language.toUpperCase() === _this.locale;
      });
      return arr;
    },
    normalNotices: function normalNotices() {
      var _this2 = this;

      var arr = this.notices;
      // 1. 第一階段：篩選內容 (維持原本邏輯：類別、非置頂、語言)
      arr = arr.filter(function (item) {
        return (item.typeId == _this2.type.id || _this2.type.id === 0) && !item.isTop && item.language.toUpperCase() === _this2.locale;
      });
      // 2. 第二階段：數量截斷 (總數維持 5 筆)
      // 計算邏輯：目標 5 筆 - 目前置頂的數量
      var limit = 5 - this.topNotice.length;
      return arr.slice(0, Math.max(0, limit));
    }
  },
  methods: {
    pushToNews: function pushToNews(newsitem) {
      this.$router.push({ name: 'news' });
    },
    pushToNewsSub: function pushToNewsSub(newsitem) {
      if (newsitem.linkType !== 1) return;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target: function target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href: function href(newsitem) {
      if (newsitem.linkType === 2 && newsitem.externalLink) return newsitem.externalLink;
      return undefined;
    }
  }
});

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'journal',
  data: function data() {
    return {
      types: [],
      nowType: '',
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initType();
    },
    initType: function initType() {
      this.getTypeData();
    },
    initNowType: function initNowType() {
      var _this = this;

      if (this.$route.params.journalid) {
        this.types.some(function (type) {
          if (type.id = _this.$route.params.journalid) {
            _this.nowType = type;
            return true;
          }
        });
      }
    },
    getTypeData: function getTypeData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].code + '?type=1').then(function (response) {
        _this2.types = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this2.initNowType();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    pushToJournal: function pushToJournal(typeobj) {
      this.nowType = typeobj;
      this.$router.push({ name: 'journal_info', params: { journalid: typeobj.id } });
    },
    showName: function showName(typeobj) {
      var show = { 'CH': typeobj.nameCh, 'EN': typeobj.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'journal_content',
  props: ['type'],
  data: function data() {
    return {
      journalId: this.$route.params.journalid,
      journals: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initJournals();
      this.initType();
    },
    initJournals: function initJournals() {
      this.getData();
    },
    initType: function initType() {
      // this.$emit
    },
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].journal + ('?typeId=' + this.journalId)).then(function (response) {
        _this.journals = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this.sort();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    sort: function sort() {
      this.journals.sort(function (a, b) {
        var aDate = new Date(a.createdAt),
            bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    showName: function showName(type) {
      var show = { 'CH': type.nameCh, 'EN': type.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'member',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__ = __webpack_require__(230);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'new_guest_book',
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__["a" /* default */] },
  data: function data() {
    return {
      book: {
        guestName: '',
        guestEmail: '',
        guestMessage: '',
        verifycode: ''
      },
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },


  methods: {
    onSubmit: function onSubmit() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function onVerify(response) {
      this.verifycode = response;
    },

    sendMessage: function sendMessage() {
      var _this = this;

      try {
        this.checkName();
        this.checkEmail();
        this.verify();
      } catch (error) {
        alert(error.message);
        return;
      }

      var form = new FormData();

      form.append('guestName', this.book.guestName || '');
      form.append('guestEmail', this.book.guestEmail || '');
      form.append('guestMessage', this.book.guestMessage || '');
      form.append('g-recaptcha-response', this.verifycode);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].message, form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        _this.$Message.destroy();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["b" /* ShowMessage */])(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["c" /* Message */].SaveSuccessfully[sessionStorage.locale]);
        _this.$router.push({ name: 'guest_book' });
      }).catch(function (error) {
        _this.$Message.destroy();
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["c" /* PostErrorHandler */].bind(_this)(error, 'message');
      });
    },
    checkName: function checkName() {
      if (!this.book.guestName) {
        throw new Error('請輸入姓名');
      }
    },
    verify: function verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    checkEmail: function checkEmail() {
      var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.book.guestEmail && !this.book.guestEmail.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    }
  }
});

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news',
  data: function data() {
    return {
      spinShow: true,
      allNews: [],
      news: [],
      hotNews: [],
      normalNews: [],
      newsitem: '',
      types: [],
      currentPage: 1,
      pagesize: 10,
      on: { 1: { on: true } },
      locale: sessionStorage.getItem('locale'),
      newsTitle: { CH: '最新消息', EN: 'Latest News' },
      allNewsExec: false,
      typesExec: false
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.showPage();
      this.initNews();
      this.initTypes();
    },
    initNews: function initNews() {
      this.getNewsData();
    },
    initTypes: function initTypes() {
      this.getTypesData();
    },
    initNewsitem: function initNewsitem(newsitem) {
      this.newsitem = newsitem;
    },
    getNewsData: function getNewsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].notice).then(function (response) {
        _this.allNews = response.data.filter(function (data) {
          return data.trash !== 1 && data.language.toUpperCase() === _this.locale;
        });
        // this.handleReceivedNews();
        _this.allNewsExec = true;
        if (_this.allNewsExec && _this.typesData) _this.selectName(_this.types[0].id);
      }).then(function () {
        _this.spinShow = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getHotNewsData: function getHotNewsData() {
      this.hotNews = this.news.filter(function (news) {
        return news.isTop;
      });
    },
    getNormalNewsData: function getNormalNewsData() {
      this.normalNews = this.news.filter(function (news) {
        return !news.isTop;
      });
    },
    getTypesData: function getTypesData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].code + '?type=2').then(function (response) {
        _this2.types = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this2.typesData = true;
        if (_this2.allNewsExec && _this2.typesData) _this2.selectName(_this2.types[0].id);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    handleReceivedNews: function handleReceivedNews() {
      this.allNews.sort(function (a, b) {
        var aDate = new Date(a.createdAt),
            bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    focus: function focus(index) {
      this.on = {};
      this.on[index] = { on: true };
    },
    selectName: function selectName(id) {
      this.currentPage = 1;
      this.news = this.allNews.filter(function (news) {
        return news.typeId == id;
      });
      this.getHotNewsData();
      this.getNormalNewsData();
    },
    pushToNew: function pushToNew() {
      if (this.$route.name === 'news_sub') this.$router.push({ name: 'news' });
    },
    pushToNewsSub: function pushToNewsSub(newsitem) {
      if (newsitem.linkType !== 1) return;
      this.newsitem = newsitem;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target: function target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href: function href(newsitem) {
      if (newsitem.linkType === 2 && newsitem.externalLink) return newsitem.externalLink;
      return undefined;
    },
    showPage: function showPage() {
      this.newsTitle = this.newsTitle[this.locale];
    },
    showType: function showType(type) {
      return sessionStorage.locale === 'CH' ? type.nameCh : type.nameEn;
    }
  }
});

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news_sub',
  props: ['newsitem'],
  data: function data() {
    return {
      newsId: this.$route.params.newsid,
      news: '',
      locale: sessionStorage.getItem('locale'),
      attachPicture: { CH: '附加圖檔', EN: 'Attach Picture' },
      attachFile: { CH: '附加檔案', EN: 'Attach File' },
      backname: { CH: '回上一頁', EN: 'back' },
      imgUrl: '',
      pictureModal: false
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.showPage();
      this.initNews();
    },
    initNews: function initNews() {
      if (this.newsitem) {
        this.news = this.newsitem;
      }
      if (!this.newsitem) {
        this.getNewsData();
      }
    },
    getNewsData: function getNewsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].notice + ('?id=' + this.newsId)).then(function (response) {
        _this.news = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    back: function back() {
      // this.$router.go(-1);
      window.history.go(-1);
    },
    showPage: function showPage() {
      this.attachPicture = this.attachPicture[this.locale];
      this.attachFile = this.attachFile[this.locale];
      this.backname = this.backname[this.locale];
    },
    showPicture: function showPicture(url) {
      this.pictureModal = true;
      this.imgUrl = url;
    }
  }
});

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page',
  data: function data() {
    return {
      PageLink: this.$route.params.pageName,
      Page: {},
      language: sessionStorage.getItem('locale')

    };
  },
  created: function created() {
    this.init();
  },

  watch: {
    '$route': function $route(to, from) {
      this.PageLink = this.$route.params.pageName;
      this.init();
    }
  },
  computed: {
    allContent: function allContent() {
      if (typeof this.Page.context !== "undefined") {
        return JSON.parse(this.Page.context).map(function (item) {
          return item.content;
        }).join('<br><br>');
      }
    }
  },
  methods: {
    init: function init() {
      this.initPage();
    },
    initPage: function initPage() {
      this.getPageData();
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].webpage + ('?linkUrl=' + this.PageLink + '&language=' + this.language)).then(function (response) {
        response.data = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        if (response.data[0]) {
          _this.Page = response.data[0];
        } else {

          _this.$router.push({ name: '404' });
          return false;
        }
      }).then(function () {
        document.title = sessionStorage.locale === 'CH' ? _this.Page.menuTitleCh : _this.Page.menuTitleEn;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    }
  }
});

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photo',
  data: function data() {
    return {
      allAlbums: [],
      albums: [],
      searchName: '',
      currentPage: 1,
      pagesize: 12,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initAlbums();
    },
    initAlbums: function initAlbums() {
      this.getAlbumsData();
    },
    getAlbumsData: function getAlbumsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].album).then(function (response) {
        _this.allAlbums = response.data;
        _this.albums = _this.allAlbums;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    search: function search() {
      var _this2 = this;

      if (this.searchName) {
        this.albums = this.allAlbums.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            if (key !== 'nameCh' && key !== 'nameEn') return false;
            return String(row[key]).toLowerCase().indexOf(_this2.searchName) !== -1;
          });
        });
      } else this.albums = this.allAlbums;

      this.currentPage = 1;
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    showName: function showName(album) {
      var show = { 'CH': album.nameCh, 'EN': album.nameEn };
      return show[sessionStorage.locale];
    },
    showMemo: function showMemo(album) {
      var show = { 'CH': album.memoCh, 'EN': album.memoEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_lightbox_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_lightbox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_js_lightbox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import "@/../static/js/jquery-1.12.4.js";

// import "@/../static/js/photoin.js";　　　//好像用不到的js





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photo_in',
  data: function data() {
    return {
      photos: [],
      currentPage: 1,
      pagesize: 12
    };
  },

  props: ['outerphoto'],
  created: function created() {
    this.init();
  },

  computed: {
    photobread: function photobread() {
      for (var i in this.outerphoto) {
        if (this.outerphoto[i].id == this.$route.params.albumId) {
          return this.outerphoto[i].nameCh;
          // 英文待處理
        }
      }
    }
  },
  methods: {
    init: function init() {
      this.initPhotos();
    },
    initPhotos: function initPhotos() {
      this.getPhotosData();
    },
    getPhotosData: function getPhotosData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].picture + ('?albumId=' + this.$route.params.albumId)).then(function (response) {
        _this.photos = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    }
  }
});

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__ = __webpack_require__(4);



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    return {
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      className: this.$route.params.classname,
      admissionsId: this.$route.params.admissionsid,
      classNow: {},
      admission: {},
      recordToEdit: {
        name: '',
        sex: 2,
        idNo: '',
        birthday: '',
        parentsName: '',
        serviceUnit: '',
        tel: '',
        mobile: '',
        email: '',
        address: '',
        memberType: 1,
        chargesType: 1,
        classWeek: [],
        classCount: 0,
        classTime: [],
        classTimeOther: '',
        coach: 0,
        coachOther: ''
      },
      agree: false
    };
  },
  created: function created() {
    this.init();
  },

  methods: (_methods = {
    init: function init() {
      this.initClass();
      this.initAdmission();
    },
    initClass: function initClass() {
      this.getClassData();
    },
    initAdmission: function initAdmission() {
      this.getAdmissionData();
    },
    getClassData: function getClassData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["b" /* API */].class + ('?id=' + this.classId)).then(function (response) {
        _this.classNow = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getAdmissionData: function getAdmissionData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["b" /* API */].classadmissions + ('?id=' + this.admissionsId)).then(function (response) {
        _this2.admission = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    saveData: function saveData() {
      var _this3 = this;

      try {
        this.checkField();
      } catch (error) {
        alert(error.message);
        return;
      }

      var form = new FormData();

      form.append('admissionsId', this.admissionsId);
      form.append('name', this.recordToEdit.name || '');
      form.append('sex', this.recordToEdit.sex || '');
      form.append('idNo', this.recordToEdit.idNo || '');
      form.append('birthday', this.recordToEdit.birthday || '');
      form.append('parentsName', this.recordToEdit.parentsName || '');
      form.append('serviceUnit', this.recordToEdit.serviceUnit || '');
      form.append('tel', this.recordToEdit.tel || '');
      form.append('mobile', this.recordToEdit.mobile || '');
      form.append('email', this.recordToEdit.email || '');
      form.append('address', this.recordToEdit.address || '');
      form.append('memberType', this.recordToEdit.memberType.toString());
      form.append('chargesType', this.recordToEdit.chargesType || 0);
      form.append('classWeek', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.recordToEdit.classWeek) || '');
      form.append('classCount', this.recordToEdit.classCount.toString());
      form.append('classTime', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.recordToEdit.classTime) || '');
      form.append('classTimeOther', this.recordToEdit.classTimeOther || '');
      form.append('coach', this.recordToEdit.coach.toString());
      form.append('coachOther', this.recordToEdit.coachOther || '');

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["b" /* API */].application, form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        _this3.$Message.destroy();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["b" /* ShowMessage */])(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["c" /* Message */].SaveSuccessfully[sessionStorage.locale]);
        _this3.$router.push({ name: 'class_item' });
      }).catch(function (error) {
        _this3.$Message.destroy();
        __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["c" /* PostErrorHandler */].bind(_this3)(error, 'application');
      });
    },
    checkField: function checkField() {
      this.checkAgree();
      this.checkEmpty();
      this.checkClassCount();
      this.checkIdNo();
      this.checkTel();
      this.checkMobile();
      this.checkEmail();
    },
    checkEmpty: function checkEmpty() {
      if (!this.recordToEdit.name) throw new Error('姓名必填');
      if (!this.recordToEdit.classCount) throw new Error('課堂數必填');
      if (!this.recordToEdit.idNo) throw new Error('身分證字號必填');
      if (!this.recordToEdit.parentsName) throw new Error('家長必填');
      if (!this.recordToEdit.serviceUnit) throw new Error('服務單位必填');
      if (!this.recordToEdit.tel) throw new Error('聯絡電話必填');
      if (!this.recordToEdit.mobile) throw new Error('手機必填');
      if (!this.recordToEdit.email) throw new Error('Email必填');
      if (!this.recordToEdit.address) throw new Error('聯絡地址必填');
    },
    checkClassCount: function checkClassCount() {
      if (isNaN(parseInt(this.recordToEdit.classCount))) throw new Error('課堂數需為數字');
    },
    checkIdNo: function checkIdNo() {
      var regExp = /^[A-Z][0-9]{9}$/;
      if (!this.recordToEdit.idNo.match(regExp)) {
        throw new Error('身分證字號無效');
      }
    },
    checkTel: function checkTel() {
      var regExp = /^[0-9\-()]*$/;
      if (this.recordToEdit.tel && !this.recordToEdit.tel.match(regExp)) {
        throw new Error('電話欄位無效');
      }
    },
    checkMobile: function checkMobile() {
      var regExp = /^09[0-9]{8}$/;
      if (this.recordToEdit.mobile && !this.recordToEdit.mobile.match(regExp)) {
        throw new Error('手機欄位無效');
      }
    },
    checkEmail: function checkEmail() {
      var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.recordToEdit.email) {
        throw new Error('請填寫電子信箱');
      }
      if (this.recordToEdit.email && !this.recordToEdit.email.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    },
    checkAgree: function checkAgree() {
      if (!this.agree) throw new Error('請先詳閱上課須知及各注意事項，並同意遵行');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'checkClassCount', function checkClassCount() {
    if (this.recordToEdit.classCount && isNaN(parseInt(this.recordToEdit.classCount))) throw new Error('課堂數需為數字');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'dateChange', function dateChange(date) {
    this.recordToEdit.birthday = date;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'classTypeName', function classTypeName(admission) {
    if (sessionStorage.locale === 'CH') {
      var level = ['', '初階', '進階', '矯正'],
          maxPersonal = ['零', '一', '二', '三', '四', '五'];
      if (admission.type === 1) {
        return admission.maxPersonal + level[admission.classLevel] + '班';
      } else if (admission.type === 2) {
        return '團體' + level[admission.classLevel] + '班';
      }
    } else {
      var _level = ['', 'Beginner', 'Advanced', 'Correction'],
          _maxPersonal = ['zero', 'one', 'two', 'three', 'four', 'five'];
      if (admission.type === 1) {
        return admission.maxPersonal + ' ' + _level[admission.classLevel] + ' class';
      } else if (admission.type === 2) {
        return 'Group ' + _level[admission.classLevel] + ' Class';
      }
    }
  }), _methods)
});

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site',
  data: function data() {
    return {
      sites: []
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initSites();
    },
    initSites: function initSites() {
      this.getSitesData();
    },
    getSitesData: function getSitesData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].site).then(function (response) {
        _this.sites = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    handleReceivedSites: function handleReceivedSites() {
      this.sites = this.sites.filter(function (site) {
        return trash === 0;
      });
    },
    pushToSite: function pushToSite(index) {
      this.$router.push({ name: 'site_info', params: { site: index } });
    },
    showName: function showName(site) {
      var show = { 'CH': site.nameCh, 'EN': site.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site',
  props: ['sites'],
  data: function data() {
    return {
      siteindex: this.$route.params.site,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    // this.init();
  },

  watch: {
    $route: function $route() {
      this.siteindex = this.$route.params.site;
    }
  },
  methods: {
    init: function init() {
      this.initSites();
    },
    initSites: function initSites() {
      this.getSitesData();
    },
    getSitesData: function getSitesData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].site).then(function (response) {
        _this.sites = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    back: function back() {
      // this.$router.go(-1);
      window.history.go(-1);
    },
    showName: function showName(site) {
      var show = { 'CH': site.nameCh, 'EN': site.nameEn };
      return show[sessionStorage.locale];
    },
    showIntroduction: function showIntroduction(site) {
      var introduction = {
        CH: site.introductionCh,
        EN: site.introductionEn
      };
      return introduction[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher',
  data: function data() {
    return {
      allTeachers: [],
      teachers: [],
      teacher: '',
      searchName: '',
      currentPage: 1,
      pagesize: 10,
      on: { 1: { on: true } },
      titleIndex: 1,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      customs: []
    };
  },
  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      this.initTeachers();
      this.initCustoms();
    },
    initTeachers: function initTeachers() {
      this.getTeachersData();
    },
    getTeachersData: function getTeachersData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].teacher).then(function (response) {
        _this.allTeachers = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this.selectTitle(_this.titleIndex);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    initCustoms: function initCustoms() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].teacherCustom).then(function (response) {
        _this2.customs = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    pushToInfo: function pushToInfo(teacher, index) {
      this.teacher = teacher;
      var routename = ['teacher_basic', 'teacher_edu', 'teacher_prize', 'teacher_seminar', 'teacher_journal', 'teacher_book', 'teacher_research'];
      this.$router.push({ name: routename[index], params: { teacherid: teacher.id } });
    },
    returnDept: function returnDept(dept) {
      return dept === 1 ? '體育室主任' : '體育室副主任';
    },
    teachercustoms: function teachercustoms(teacher) {
      return this.customs.filter(function (item) {
        return item.teacherId == teacher.id;
      });
    },
    search: function search() {
      var _this3 = this;

      if (this.searchName) {
        this.teachers = this.teachers.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            if (key !== 'nameCh' && key !== 'nameEn') return false;
            return String(row[key]).toLowerCase().indexOf(_this3.searchName) !== -1;
          });
        });
      } else this.selectTitle(this.titleIndex);

      this.currentPage = 1;
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    focus: function focus(index) {
      this.on = {};
      this.on[index] = { on: true };
    },
    selectTitle: function selectTitle(index) {
      this.titleIndex = index;
      this.currentPage = 1;
      this.teachers = this.allTeachers.filter(function (teacher) {
        return teacher.title == index;
      });
    },
    pushToTeacher: function pushToTeacher() {
      if (this.$route.name !== 'teacher') this.$router.push({ name: 'teacher' });
    },
    showTitle: function showTitle() {
      var title = ['', this.showPage.professor, this.showPage.associateProfessor, this.showPage.assistantProfessor, this.showPage.distinguishedProfessor, this.showPage.fullTimeLecturer, this.showPage.adjunctProfessor, this.showPage.adjunctAssociateProfessor, this.showPage.adjunctAssistantProfessor, this.showPage.adjunctLecture, this.showPage.teachingAssistant, this.showPage.honoraryProfessor];
      return title[this.titleIndex];
    },
    showName: function showName(custom) {
      var name = { 'CH': custom.nameCh, 'EN': custom.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_basic',
  props: ['teacher'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    showDegree: function showDegree(background) {
      var degreeEn = { '學士': 'Bachelor', '碩士': 'Master', '博士': 'Doctor' },
          degree = { CH: background.degree, EN: degreeEn[background.degree] };
      return degree[sessionStorage.locale];
    },
    showSchool: function showSchool(background) {
      var school = { CH: background.school_ch, EN: background.school_en };
      return school[sessionStorage.locale];
    },
    showTitle: function showTitle(title) {
      var titlename = ['', this.showPage.professor, this.showPage.associateProfessor, this.showPage.assistantProfessor, this.showPage.distinguishedProfessor, this.showPage.fullTimeLecturer, this.showPage.adjunctProfessor, this.showPage.adjunctAssociateProfessor, this.showPage.adjunctAssistantProfessor, this.showPage.adjunctLecture, this.showPage.teachingAssistant];
      return titlename[title];
    },
    showResearchArea: function showResearchArea(researchArea) {
      var research = { CH: researchArea.research_area_ch, EN: researchArea.research_area_en };
      return research[sessionStorage.locale];
    },
    showResearchSummary: function showResearchSummary() {
      var research = { CH: this.teacher.researchSummaryCh, EN: this.teacher.researchSummaryEn };
      return research[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_book',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      teacherId: this.$route.params.teacherid,
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    publication: function publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    showReviewSystem: function showReviewSystem(teacherpublication) {
      var showCH = { 0: '無', 1: '有' },
          showEN = { 0: 'nonexist', 1: 'exist' },
          show = { CH: showCH[teacherpublication.reviewSystem], EN: showEN[teacherpublication.reviewSystem] };
      return show[sessionStorage.locale];
    },
    showName: function showName(teacherpublication) {
      var name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_custom',
  props: ['customs'],
  data: function data() {
    return {
      custom: this.$route.params.custom,
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },

  watch: {
    $route: function $route() {
      this.custom = this.$route.params.custom;
    }
  },
  created: function created() {},

  methods: {
    showName: function showName(custom) {
      var show = { 'CH': custom.nameCh, 'EN': custom.nameEn };
      return show[sessionStorage.locale];
    },
    showContext: function showContext(custom) {
      var show = { 'CH': custom.contextCh, 'EN': custom.contextEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_edu',
  props: ['teacher'],
  data: function data() {
    var _this = this;

    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      backgroundColumn: [{
        title: this.showDegreeName(),
        key: 'degree',
        render: function render(h, params) {
          return h('div', [h('span', _this.showDegree(params.row))]);
        }
      }, {
        title: this.showSchool(),
        key: 'school_ch'
      }, {
        title: this.showSchoolEn(),
        key: 'school_en'
      }, {
        title: this.showGraduationYear(),
        key: 'graduation_year'
      }]
    };
  },
  created: function created() {},

  methods: {
    showDegree: function showDegree(background) {
      var degreeEn = { '學士': 'Bachelor', '碩士': 'Master', '博士': 'Doctor' },
          degree = { CH: background.degree, EN: degreeEn[background.degree] };
      return degree[sessionStorage.locale];
    },
    showDegreeName: function showDegreeName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).degree;
    },
    showSchool: function showSchool() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).school;
    },
    showSchoolEn: function showSchoolEn() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).school_en;
    },
    showGraduationYear: function showGraduationYear() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).graduation_year;
    },
    showCourse: function showCourse(course) {
      var show = { CH: course.course_ch, EN: course.course_en };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_info',
  props: ['teacher'],
  data: function data() {
    return {
      teacherId: this.$route.params.teacherid,
      info: {},
      teacherpublications: [],
      customs: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initInfo();
      this.initPublications();
      this.initCustoms();
    },
    initInfo: function initInfo() {
      if (this.teacher) this.info = this.teacher;else this.getData();
    },
    initPublications: function initPublications() {
      this.getPublicationsData();
    },
    initCustoms: function initCustoms() {
      this.getCustomsData();
    },
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].teacher + ('?id=' + this.teacherId)).then(function (response) {
        _this.info = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getPublicationsData: function getPublicationsData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].teacherpublication + ('?teacherId=' + this.teacherId)).then(function (response) {
        _this2.teacherpublications = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    getCustomsData: function getCustomsData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].teacherCustom + ('?teacherid=' + this.teacherId)).then(function (response) {
        _this3.customs = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this3)(error);
      });
    },
    showName: function showName(custom) {
      var name = { 'CH': custom.nameCh, 'EN': custom.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_journal',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    publication: function publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    showName: function showName(teacherpublication) {
      var name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return name[sessionStorage.locale];
    },
    showIssueNumber: function showIssueNumber(teacherpublication) {
      var show = {
        CH: '\u7B2C ' + teacherpublication.journal + ' \u671F\uFF0C\u7B2C ' + teacherpublication.journalUnit + ' \u55AE\u5143',
        EN: 'Vol. ' + teacherpublication.journal + ' No. ' + teacherpublication.journalUnit
      };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_prize',
  props: ['teacher'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    showHonor: function showHonor() {
      var show = { CH: this.teacher.honorCh, EN: this.teacher.honorEn };
      return show[sessionStorage.locale];
    },
    showHistory: function showHistory() {
      var show = { CH: this.teacher.historyCh, EN: this.teacher.historyEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_research',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    executiveDateS: function executiveDateS(teacherpublication) {
      if (teacherpublication.executiveDateS) {
        var dateArr = teacherpublication.executiveDateS.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    executiveDateE: function executiveDateE(teacherpublication) {
      if (teacherpublication.executiveDateE) {
        var dateArr = teacherpublication.executiveDateE.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    showFundSource: function showFundSource(teacherpublication) {
      var show = { CH: teacherpublication.fundSourceCh, EN: teacherpublication.fundSourceEn };
      return show[sessionStorage.locale];
    },
    showName: function showName(teacherpublication) {
      var show = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_seminar',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    publication: function publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    publicationmonth: function publicationmonth(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        switch (dateArr[1]) {
          case '01':
            return 'January';
            break;
          case '02':
            return 'February';
            break;
          case '03':
            return 'March';
            break;
          case '04':
            return 'April';
            break;
          case '05':
            return 'May';
            break;
          case '06':
            return 'June';
            break;
          case '07':
            return 'July';
            break;
          case '08':
            return 'August';
            break;
          case '09':
            return 'September';
            break;
          case '10':
            return 'October';
            break;
          case '11':
            return 'November';
            break;
          case '12':
            return 'December';
            break;
          default:
            break;
        }
      }
      return '';
    },
    showName: function showName(teacherpublication) {
      var name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team',
  data: function data() {
    return {
      teams: [],
      teamInfo: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initTeams();
      this.initTeamInfo();
    },
    initTeams: function initTeams() {
      this.getTeamsData();
    },
    initTeamInfo: function initTeamInfo() {
      this.getTeamInfo();
    },
    getTeamsData: function getTeamsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].team).then(function (response) {
        _this.teams = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getTeamInfo: function getTeamInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].setting + '?id=1').then(function (response) {
        _this2.teamInfo = response.data;
        _this2.handleReceivedTeamInfo();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    handleReceivedTeamInfo: function handleReceivedTeamInfo() {
      this.teamInfo.teamIntroductionCh = this.teamInfo.teamIntroductionCh;
      this.teamInfo.teamIntroductionEn = this.teamInfo.teamIntroductionEn;
    },
    showIntroduction: function showIntroduction() {
      var introduction = { CH: this.teamInfo.teamIntroductionCh,
        EN: this.teamInfo.teamIntroductionEn };
      return introduction[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team_type',
  props: ['teams'],
  data: function data() {
    return {
      teamId: this.$route.params.teamid,
      team: '',
      albums: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  watch: {
    teams: function teams() {
      this.init();
    }
  },
  methods: {
    init: function init() {
      this.initTeam();
      this.initAlbums();
    },
    initTeam: function initTeam() {
      var _this = this;

      this.teams.some(function (team) {
        if (team.id == _this.teamId) {
          _this.team = team;
          return true;
        }
      });
    },
    initAlbums: function initAlbums() {
      this.getAlbumsData();
    },
    getAlbumsData: function getAlbumsData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].album + ('?teamId=' + this.teamId)).then(function (response) {
        _this2.albums = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    showName: function showName(album) {
      var show = { 'CH': album.nameCh, 'EN': album.nameEn };
      return show[sessionStorage.locale];
    },
    showIntroduction: function showIntroduction() {
      var introduction = { CH: this.team.introductionCh,
        EN: this.team.introductionEn };
      return introduction[sessionStorage.locale];
    },
    showMemo: function showMemo(album) {
      var show = { 'CH': album.memoCh, 'EN': album.memoEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team_type',
  props: ['teams'],
  data: function data() {
    return {
      teamtypeId: this.$route.params.teamtypeid
    };
  },
  created: function created() {},

  methods: {
    selectTeam: function selectTeam(team) {
      this.$router.push({ name: 'team_info', params: { teamid: team.id } });
    },
    showName: function showName(teamitem) {
      var name = { 'CH': teamitem.nameCh, 'EN': teamitem.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video',
  data: function data() {
    return {
      allVideos: [],
      videos: [],
      nowVideo: '',
      nowTitle: '',
      searchName: '',
      currentPage: 1,
      pagesize: 10,
      modalvideo: false,
      sortstatus: false,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initVideos();
    },
    initVideos: function initVideos() {
      this.getVideosData();
    },
    getVideosData: function getVideosData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].video).then(function (response) {
        _this.allVideos = response.data;
        _this.sort();
        _this.videos = _this.allVideos.slice();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    selectVideo: function selectVideo(video) {
      this.nowVideo = video.fileUrl;
      this.nowTitle = this.showTitle(video);
      this.modalvideo = true;
      this.addViewCount(video);
    },
    addViewCount: function addViewCount(video) {

      var form = new FormData();

      form.append('id', video.id);

      // params   id account name isActive limit all
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].video + '/viewer', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        // ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
      }).catch(function (error) {
        // PostErrorHandler.bind(this)(error, 'album');
      });
    },
    search: function search() {
      var _this2 = this;

      if (this.searchName) {
        this.videos = this.allVideos.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            if (key !== 'titleCh' && key !== 'titleEn') return false;
            return String(row[key]).toLowerCase().indexOf(_this2.searchName) !== -1;
          });
        });
      } else this.videos = this.allVideos.slice();

      this.currentPage = 1;
    },
    sort: function sort() {
      this.sortstatus = true;
      this.allVideos.sort(function (a, b) {
        var aDate = new Date(a.createdAt),
            bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    sortCancel: function sortCancel() {
      this.sortstatus = false;
      this.videos = this.allVideos.slice();
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    showTitle: function showTitle(video) {
      var show = { CH: video.titleCh, EN: video.titleEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview_dist_styles_iview_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flexslider__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flexslider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_flexslider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_iview___default.a, { locale: __WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW___default.a });

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.ignoredElements = ['gcse:search']; // google 站內搜尋

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* router */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 905:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 931:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 950:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 956:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 964:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 972:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[637]);


// WEBPACK FOOTER //
// static/js/app.786d569ad187fb7ae412.js